/* Independent vehicle finder: no dependency on legacy custom.js or its interaction loader. */
(function (global) {
  'use strict';
  if (global.__coFinderRuntimeLoaded) return;
  global.__coFinderRuntimeLoaded = true;

/* BEGIN CAROPTIONS EU VEHICLE MATCH — generated by build-candidate.mjs */
/* CarOptions Smart Vehicle Finder
 * Single-input search across the full /products.json catalog.
 * Index: /assets/co-search-index.json (built from products.json + manual backfill).
 * Spec: CarOptions-Searcher-Audit-And-Fix.docx
 */
(function () {
  'use strict';
  if (window.__coFinderInit) return;
  window.__coFinderInit = true;

  var INDEX_URL = window.coFinderIndexUrl || '/assets/co-search-index.json';
  /* Index ownership is shared with every finder surface through coFinderLoadIndex. */

  // Locale-aware URL prefix — preserves /it/, /fr/, etc. so navigation
  // doesn't drop the visitor back to the default locale.
  // 1) Prefer Shopify's own routes.root (set by liquid via routes object) when present.
  // 2) Otherwise sniff the current URL: if it starts with /xx/ where xx is two
  //    letters or xx-yy, treat it as the locale root.
  function localeRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
    if (root && root !== '/') {
      return root.replace(/\/$/, '');
    }
    var m = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
    return m ? m[1] : '';
  }
  function withLocale(path) {
    var prefix = localeRoot();
    if (!prefix) return path;
    if (path.indexOf(prefix + '/') === 0) return path; // already prefixed
    return prefix + path;
  }

  // i18n — per-locale string tables. Active locale comes from window.CO_LOCALE
  // (set by layout/theme.liquid for non-English visitors). Falls back to en.
  // Adding a new locale: add a new entry to LOCALE_STRINGS with the same keys.
  var LOCALE_STRINGS = {
  "en": {
    "your_car": "your car",
    "fits_aria": "100% fit",
    "fits_label": "Fits",
    "fit_msg": "Apple CarPlay &amp; Android Auto is <b>100% compatible</b> with your <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Showing results for <b>{to}</b> — searched for \"{from}\"",
    "unsupported_h": "We don't carry {brand} (yet)",
    "unsupported_p": "If you've already confirmed your car has factory CarPlay support, our team can double-check whether one of our boxes will work.",
    "unsupported_btn": "Ask about my car →",
    "grouped_head": "{brand} {model} — pick a year range",
    "generations_head": "{brand} {model} — pick your year range",
    "no_match_h": "No matches",
    "no_match_p": "Try just the brand and year, or contact us if you can't find your car.",
    "no_match_btn": "Ask about my car →",
    "fit_badge": "Fits your {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox for {brand}",
    "fit_info_detected": "Auto-detected for your <b>{system}</b> system.",
    "fit_info_default": "Wireless Apple CarPlay + Android Auto for your factory infotainment.",
    "fit_view_btn": "View product →",
    "fit_change": "Not your car? Change vehicle",
    "yr_present": "present"
  },
  "it": {
    "your_car": "la tua auto",
    "fits_aria": "compatibilità 100%",
    "fits_label": "Compatibile",
    "fit_msg": "Apple CarPlay e Android Auto sono <b>100% compatibili</b> con la tua <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Mostro risultati per <b>{to}</b> — hai cercato \"{from}\"",
    "unsupported_h": "Non offriamo ancora {brand}",
    "unsupported_p": "Se hai già confermato che la tua auto supporta CarPlay di serie, il nostro team può verificare se una delle nostre soluzioni è compatibile.",
    "unsupported_btn": "Chiedi informazioni sulla mia auto →",
    "grouped_head": "{brand} {model} — scegli un intervallo di anni",
    "generations_head": "{brand} {model} — scegli il tuo intervallo di anni",
    "no_match_h": "Nessun risultato",
    "no_match_p": "Prova solo con la marca e l'anno, oppure contattaci se non trovi la tua auto.",
    "no_match_btn": "Chiedi informazioni sulla mia auto →",
    "fit_badge": "Compatibile con la tua {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox per {brand}",
    "fit_info_detected": "Rilevato automaticamente per il tuo sistema <b>{system}</b>.",
    "fit_info_default": "Apple CarPlay e Android Auto wireless per il tuo infotainment di fabbrica.",
    "fit_view_btn": "Vedi prodotto →",
    "fit_change": "Non è la tua auto? Cambia veicolo",
    "yr_present": "oggi"
  },
  "es": {
    "your_car": "tu coche",
    "fits_aria": "compatibilidad 100%",
    "fits_label": "Compatible",
    "fit_msg": "Apple CarPlay y Android Auto son <b>100% compatibles</b> con tu <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Mostrando resultados para <b>{to}</b> — buscaste \"{from}\"",
    "unsupported_h": "Aún no ofrecemos {brand}",
    "unsupported_p": "Si ya has confirmado que tu coche tiene soporte CarPlay de fábrica, nuestro equipo puede comprobar si alguna de nuestras soluciones es compatible.",
    "unsupported_btn": "Pregunta por mi coche →",
    "grouped_head": "{brand} {model} — elige un rango de años",
    "generations_head": "{brand} {model} — elige tu rango de años",
    "no_match_h": "Sin resultados",
    "no_match_p": "Prueba solo con la marca y el año, o contáctanos si no encuentras tu coche.",
    "no_match_btn": "Pregunta por mi coche →",
    "fit_badge": "Compatible con tu {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox para {brand}",
    "fit_info_detected": "Detectado automáticamente para tu sistema <b>{system}</b>.",
    "fit_info_default": "Apple CarPlay y Android Auto inalámbricos para tu infotainment de fábrica.",
    "fit_view_btn": "Ver producto →",
    "fit_change": "¿No es tu coche? Cambiar vehículo",
    "yr_present": "presente"
  },
  "fr": {
    "your_car": "votre voiture",
    "fits_aria": "compatibilité 100%",
    "fits_label": "Compatible",
    "fit_msg": "Apple CarPlay et Android Auto sont <b>100% compatibles</b> avec votre <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Résultats pour <b>{to}</b> — recherche : \"{from}\"",
    "unsupported_h": "Nous ne proposons pas encore {brand}",
    "unsupported_p": "Si vous avez déjà confirmé que votre voiture est compatible CarPlay d'origine, notre équipe peut vérifier si l'une de nos solutions fonctionne.",
    "unsupported_btn": "Posez une question sur ma voiture →",
    "grouped_head": "{brand} {model} — choisissez une plage d'années",
    "generations_head": "{brand} {model} — choisissez votre plage d'années",
    "no_match_h": "Aucun résultat",
    "no_match_p": "Essayez juste la marque et l'année, ou contactez-nous si vous ne trouvez pas votre voiture.",
    "no_match_btn": "Posez une question sur ma voiture →",
    "fit_badge": "Compatible avec votre {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox pour {brand}",
    "fit_info_detected": "Détecté automatiquement pour votre système <b>{system}</b>.",
    "fit_info_default": "Apple CarPlay et Android Auto sans fil pour votre système d'origine.",
    "fit_view_btn": "Voir le produit →",
    "fit_change": "Ce n'est pas votre voiture ? Changer de véhicule",
    "yr_present": "présent"
  },
  "de": {
    "your_car": "Ihrem Auto",
    "fits_aria": "100% Kompatibilität",
    "fits_label": "Kompatibel",
    "fit_msg": "Apple CarPlay und Android Auto sind <b>100% kompatibel</b> mit Ihrem <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Ergebnisse für <b>{to}</b> — gesucht: \"{from}\"",
    "unsupported_h": "Wir bieten {brand} noch nicht an",
    "unsupported_p": "Wenn Sie bereits bestätigt haben, dass Ihr Auto werkseitig CarPlay-kompatibel ist, kann unser Team prüfen, ob eine unserer Lösungen funktioniert.",
    "unsupported_btn": "Frage zu meinem Auto stellen →",
    "grouped_head": "{brand} {model} — wählen Sie einen Jahrgangsbereich",
    "generations_head": "{brand} {model} — wählen Sie Ihren Jahrgangsbereich",
    "no_match_h": "Keine Übereinstimmungen",
    "no_match_p": "Versuchen Sie es nur mit Marke und Jahr, oder kontaktieren Sie uns, wenn Sie Ihr Auto nicht finden können.",
    "no_match_btn": "Frage zu meinem Auto stellen →",
    "fit_badge": "Kompatibel mit Ihrem {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox für {brand}",
    "fit_info_detected": "Automatisch erkannt für Ihr <b>{system}</b>-System.",
    "fit_info_default": "Drahtloses Apple CarPlay und Android Auto für Ihr Werks-Infotainment.",
    "fit_view_btn": "Produkt ansehen →",
    "fit_change": "Nicht Ihr Auto? Fahrzeug wechseln",
    "yr_present": "heute"
  },
  "pl": {
    "your_car": "Twój samochód",
    "fits_aria": "100% dopasowania",
    "fits_label": "Pasuje",
    "fit_msg": "Apple CarPlay &amp; Android Auto są <b>w 100% kompatybilne</b> z Twoim <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Wyświetlanie wyników dla <b>{to}</b> — wyszukiwano \"{from}\"",
    "unsupported_h": "Nie mamy (jeszcze) {brand} w ofercie",
    "unsupported_p": "Jeśli potwierdziłeś już, że Twój samochód ma fabryczną obsługę CarPlay, nasz zespół może dodatkowo sprawdzić, czy jeden z naszych modułów będzie działał.",
    "unsupported_btn": "Zapytaj o mój samochód →",
    "grouped_head": "{brand} {model} — wybierz zakres roczników",
    "generations_head": "{brand} {model} — wybierz zakres roczników swojego auta",
    "no_match_h": "Brak dopasowań",
    "no_match_p": "Spróbuj podać tylko markę i rok lub skontaktuj się z nami, jeśli nie możesz znaleźć swojego samochodu.",
    "no_match_btn": "Zapytaj o mój samochód →",
    "fit_badge": "Pasuje do {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox dla {brand}",
    "fit_info_detected": "Wykryto automatycznie dla systemu <b>{system}</b>.",
    "fit_info_default": "Bezprzewodowy Apple CarPlay + Android Auto dla fabrycznego systemu multimedialnego.",
    "fit_view_btn": "Zobacz produkt →",
    "fit_change": "To nie Twój samochód? Zmień pojazd",
    "yr_present": "obecny"
  },
  "sv": {
    "your_car": "din bil",
    "fits_aria": "100 % passform",
    "fits_label": "Passar",
    "fit_msg": "Apple CarPlay &amp; Android Auto är <b>100% kompatibelt</b> med din <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Visar resultat för <b>{to}</b> — sökte efter \"{from}\"",
    "unsupported_h": "Vi har inte {brand} (än)",
    "unsupported_p": "Om du redan har bekräftat att bilen har fabriksmonterat stöd för CarPlay kan vårt team dubbelkolla om någon av våra boxar fungerar.",
    "unsupported_btn": "Fråga om min bil →",
    "grouped_head": "{brand} {model} — välj ett årsintervall",
    "generations_head": "{brand} {model} — välj årsintervall",
    "no_match_h": "Inga träffar",
    "no_match_p": "Prova att bara ange bilmärke och årsmodell. Kontakta oss om du ändå inte hittar din bil.",
    "no_match_btn": "Fråga om min bil →",
    "fit_badge": "Passar din {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox för {brand}",
    "fit_info_detected": "Identifieras automatiskt för ditt <b>{system}</b>-system.",
    "fit_info_default": "Trådlös Apple CarPlay + Android Auto för bilens fabriksmonterade infotainmentsystem.",
    "fit_view_btn": "Visa produkt →",
    "fit_change": "Inte din bil? Byt fordon",
    "yr_present": "nuvarande"
  },
  "da": {
    "your_car": "din bil",
    "fits_aria": "100% pasform",
    "fits_label": "Passer",
    "fit_msg": "Apple CarPlay &amp; Android Auto er <b>100% kompatibelt</b> med din <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Viser resultater for <b>{to}</b> — der blev søgt efter \"{from}\"",
    "unsupported_h": "Vi fører ikke {brand} (endnu)",
    "unsupported_p": "Hvis du allerede har bekræftet, at din bil har CarPlay fra fabrikken, kan vores team dobbelttjekke, om en af vores bokse fungerer.",
    "unsupported_btn": "Spørg om min bil →",
    "grouped_head": "{brand} {model} — vælg et årgangsinterval",
    "generations_head": "{brand} {model} — vælg dit årgangsinterval",
    "no_match_h": "Ingen resultater",
    "no_match_p": "Prøv kun med mærke og årgang, eller kontakt os, hvis du ikke kan finde din bil.",
    "no_match_btn": "Spørg om min bil →",
    "fit_badge": "Passer til din {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox til {brand}",
    "fit_info_detected": "Automatisk registreret for dit <b>{system}</b>-system.",
    "fit_info_default": "Trådløs Apple CarPlay + Android Auto til bilens originale infotainmentsystem.",
    "fit_view_btn": "Se produkt →",
    "fit_change": "Ikke din bil? Skift køretøj",
    "yr_present": "nuværende"
  },
  "fi": {
    "your_car": "autosi",
    "fits_aria": "100% yhteensopiva",
    "fits_label": "Sopii",
    "fit_msg": "Apple CarPlay &amp; Android Auto on <b>100% yhteensopiva</b> ajoneuvosi <b class=\"co-fit-card__veh\">{label}</b> kanssa",
    "didyoumean": "Näytetään tulokset haulle <b>{to}</b> — alkuperäinen haku \"{from}\"",
    "unsupported_h": "Valikoimassamme ei ole {brand}-tuotteita (vielä)",
    "unsupported_p": "Jos olet jo varmistanut, että autosi tukee tehdasasenteista CarPlayta, tiimimme voi vielä tarkistaa, sopiiko jokin laitteistamme autoosi.",
    "unsupported_btn": "Kysy autostani →",
    "grouped_head": "{brand} {model} — valitse vuosimalliväli",
    "generations_head": "{brand} {model} — valitse vuosimalliväli",
    "no_match_h": "Ei osumia",
    "no_match_p": "Kokeile hakea pelkällä merkillä ja vuosimallilla. Jos et löydä autoasi, ota meihin yhteyttä.",
    "no_match_btn": "Kysy autostani →",
    "fit_badge": "Sopii autoosi {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox merkille {brand}",
    "fit_info_detected": "Tunnistettu automaattisesti <b>{system}</b>-järjestelmällesi.",
    "fit_info_default": "Langaton Apple CarPlay + Android Auto autonne alkuperäiseen infotainment-järjestelmään.",
    "fit_view_btn": "Näytä tuote →",
    "fit_change": "Eikö tämä ole autosi? Vaihda ajoneuvo",
    "yr_present": "esitellä"
  },
  "no": {
    "your_car": "bilen din",
    "fits_aria": "100 % passform",
    "fits_label": "Passer",
    "fit_msg": "Apple CarPlay &amp; Android Auto er <b>100% kompatibelt</b> med din <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Viser resultater for <b>{to}</b> — søkte etter \"{from}\"",
    "unsupported_h": "Vi fører ikke {brand} (ennå)",
    "unsupported_p": "Hvis du allerede har bekreftet at bilen har fabrikkmontert støtte for CarPlay, kan teamet vårt dobbeltsjekke om en av boksene våre fungerer.",
    "unsupported_btn": "Spør om bilen min →",
    "grouped_head": "{brand} {model} — velg et årsintervall",
    "generations_head": "{brand} {model} — velg årsintervallet ditt",
    "no_match_h": "Ingen treff",
    "no_match_p": "Prøv å bare oppgi bilmerke og årsmodell. Kontakt oss hvis du fortsatt ikke finner bilen din.",
    "no_match_btn": "Spør om bilen min →",
    "fit_badge": "Passer til din {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox for {brand}",
    "fit_info_detected": "Registreres automatisk for <b>{system}</b>-systemet ditt.",
    "fit_info_default": "Trådløs Apple CarPlay + Android Auto for bilens fabrikkmonterte infotainmentsystem.",
    "fit_view_btn": "Vis produkt →",
    "fit_change": "Ikke bilen din? Bytt kjøretøy",
    "yr_present": "nåværende"
  }
};
  var I18N = LOCALE_STRINGS[window.CO_LOCALE] || LOCALE_STRINGS.en;
  function t(key, vars) {
    var s = I18N[key] || '';
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('{' + k + '}').join(vars[k]);
      });
    }
    return s;
  }

  function loadIndex(options) {
    if (typeof window.coFinderLoadIndex === 'function') return window.coFinderLoadIndex(options || {});
    if (typeof window.fetch !== 'function') return Promise.reject(new Error('vehicle index fetch unavailable'));
    var state = window.__coFinderIndexState || (window.__coFinderIndexState = {
      status: 'idle', promise: null, value: null, error: null, attempt: 0
    });
    if (state.value && !(options && options.retry)) return Promise.resolve(state.value);
    if (state.promise && !(options && options.retry)) return state.promise;
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var timeout = controller ? window.setTimeout(controller.abort.bind(controller), 8000) : null;
    state.status = 'loading';
    state.attempt += 1;
    state.promise = fetch(INDEX_URL, {
      credentials: 'same-origin', signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('vehicle index request failed');
      return response.json();
    }).then(function (index) {
      state.status = 'ready';
      state.value = index;
      return index;
    }).catch(function (error) {
      state.status = 'error';
      state.error = error;
      state.promise = null;
      throw error;
    }).then(function (index) {
      if (timeout) window.clearTimeout(timeout);
      return index;
    }, function (error) {
      if (timeout) window.clearTimeout(timeout);
      throw error;
    });
    window.__coFinderIndexPromise = state.promise;
    return state.promise;
  }

  function norm(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[-_/\\\u2013\u2014]/g, ' ')  // hyphen, underscore, slashes, en-dash, em-dash
      .replace(/\s+/g, ' ').trim();
  }
  function tokens(s) { return norm(s).split(' ').filter(Boolean); }
  function extractYear(s) {
    var m = String(s).match(/\b(19[8-9]\d|20\d{2})\b/);
    return m ? +m[1] : null;
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n; if (!n) return m;
    var prev = new Array(n + 1), curr = new Array(n + 1);
    for (var j = 0; j <= n; j++) prev[j] = j;
    for (var i = 1; i <= m; i++) {
      curr[0] = i;
      for (var jj = 1; jj <= n; jj++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(jj - 1) ? 0 : 1;
        curr[jj] = Math.min(prev[jj] + 1, curr[jj - 1] + 1, prev[jj - 1] + cost);
      }
      var tmp = prev; prev = curr; curr = tmp;
    }
    return prev[n];
  }

  function hasWord(haystack, needle) {
    if (!haystack || !needle) return false;
    if (haystack === needle) return true;
    if (haystack.indexOf(needle) === -1) return false;
    // Word-boundary check using normalised whitespace
    var idx = haystack.indexOf(needle);
    while (idx !== -1) {
      var before = idx === 0 ? ' ' : haystack[idx - 1];
      var after = idx + needle.length >= haystack.length ? ' ' : haystack[idx + needle.length];
      if (/\s/.test(before) && /\s/.test(after)) return true;
      idx = haystack.indexOf(needle, idx + 1);
    }
    return false;
  }

  function fuzzyTokenMatch(qTok, target) {
    if (!qTok || !target) return 0;
    if (target.indexOf(qTok) !== -1) return 1;
    if (qTok.length >= 3) {
      var parts = target.split(' ');
      for (var i = 0; i < parts.length; i++) {
        var d = levenshtein(qTok, parts[i]);
        if (d <= 1) return 0.9;
        if (qTok.length >= 5 && d <= 2) return 0.75;
      }
    }
    return 0;
  }

  function search(rawQ, idx) {
    var q = norm(rawQ);
    if (!q) return { kind: 'empty' };

    var year = extractYear(q);
    // Strip ALL years from the query (the user may type a range like
    // "2012–2020" — only the first year is used as a filter, the rest are
    // noise tokens that shouldn't influence scoring).
    var qNoYear = q.replace(/\b(19[8-9]\d|20\d{2})\b/g, '').trim();
    var qToks = tokens(qNoYear);
    var hasIntentTokens = qToks.length > 0;

    var brandAliases = idx.brandAliases || {};
    var unsupported = idx.unsupported || {};

    var resolvedBrand = null;
    // Multi-word aliases (e.g. "land rover", "mini cooper") — check on raw q
    Object.keys(brandAliases).forEach(function (k) {
      if (resolvedBrand) return;
      if (k.indexOf(' ') !== -1 && q.indexOf(k) !== -1) resolvedBrand = brandAliases[k];
    });
    // Single-word aliases — check on tokens
    if (!resolvedBrand) {
      for (var i = 0; i < qToks.length && !resolvedBrand; i++) {
        if (brandAliases[qToks[i]]) resolvedBrand = brandAliases[qToks[i]];
      }
    }

    // Unsupported?
    if (!resolvedBrand) {
      var uHit = null;
      Object.keys(unsupported).forEach(function (k) {
        if (uHit) return;
        if (k.indexOf(' ') !== -1) {
          if (q.indexOf(k) !== -1) uHit = unsupported[k];
        } else if (qToks.indexOf(k) !== -1) {
          uHit = unsupported[k];
        }
      });
      if (uHit) return { kind: 'unsupported', brand: uHit, query: rawQ };
    }

    // Build a set of all model alias tokens across the index for cheap lookup —
    // used to decide whether a typed token could legitimately *be* a model alias
    // (in which case we should NOT treat it as a typo of a brand name).
    if (!idx.__modelTokenSet) {
      var s = {};
      var vs = idx.vehicles || [];
      for (var iv = 0; iv < vs.length; iv++) {
        var ah = vs[iv].aliases || [];
        for (var ja = 0; ja < ah.length; ja++) {
          var an = norm(ah[ja]);
          if (an) s[an] = true;
        }
        var mn = norm(vs[iv].model);
        if (mn) s[mn] = true;
      }
      idx.__modelTokenSet = s;
    }

    var didYouMean = null;
    // Brand-typo correction. Only on tokens that don't look like model aliases.
    if (!resolvedBrand && qToks.length) {
      var first = qToks[0];
      if (first.length >= 3 && !idx.__modelTokenSet[first]) {
        var dymBest = null, dymD = Infinity;
        Object.keys(brandAliases).forEach(function (k) {
          if (k.length < 3 || k.indexOf(' ') !== -1) return;
          var d = levenshtein(first, k);
          var maxD = first.length >= 4 ? 2 : 1;
          if (d <= maxD && d < dymD) { dymD = d; dymBest = k; }
        });
        if (dymBest) {
          didYouMean = { from: first, to: brandAliases[dymBest] };
          resolvedBrand = brandAliases[dymBest];
        }
      }
    }

    // Score every vehicle
    var scored = [];
    var vehicles = idx.vehicles || [];
    var qNormFull = norm(qNoYear);
    for (var v = 0; v < vehicles.length; v++) {
      var veh = vehicles[v];
      var intentScore = 0;  // brand + model + token contributions only (no year)
      var aliasArr = veh.aliases || [];
      var aliases = aliasArr.join(' ');
      var modelRaw = veh.modelRaw || veh.model;
      var hay = norm([veh.brand, veh.model, modelRaw, aliases, veh.chassis || ''].join(' '));
      var modelNorm = norm(veh.model);

      if (resolvedBrand && veh.brand === resolvedBrand) intentScore += 4;

      if (modelNorm && hasWord(qNormFull, modelNorm)) {
        intentScore += 6;
      } else {
        for (var ai = 0; ai < aliasArr.length; ai++) {
          var aN = norm(aliasArr[ai]);
          if (aN && hasWord(qNormFull, aN)) { intentScore += 5; break; }
        }
      }

      for (var t = 0; t < qToks.length; t++) {
        var tok = qToks[t];
        if (tok.length < 2) continue;  // single-char tokens are noise
        if (resolvedBrand && brandAliases[tok] === resolvedBrand) continue;
        var m = fuzzyTokenMatch(tok, hay);
        if (m > 0) intentScore += m * (tok.length >= 3 ? 2 : 1);
      }

      // If the user typed brand/model intent but this vehicle didn't match
      // ANY of it, drop it — even if a year happens to be in range. Otherwise
      // "Volkswagen Golf 2012" would surface every car whose lifespan covers
      // 2012 (Jaguars, etc.).
      if (hasIntentTokens && intentScore === 0) continue;

      var score = intentScore;
      if (year && veh.y0 && veh.y1) {
        if (year >= veh.y0 && year <= veh.y1) score += 5;
        else score -= 1.5;
      }

      if (score > 1.5) scored.push({ v: veh, score: score });
    }
    // Primary: score desc. Tiebreak: y0 ascending (oldest generation first)
    // so multi-generation models read as a chronological timeline.
    scored.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return (a.v.y0 || 0) - (b.v.y0 || 0);
    });

    if (scored.length === 0) {
      return { kind: 'no-match', query: rawQ, didYouMean: didYouMean };
    }

    // Group by model when brand resolved + no year + many matches
    if (resolvedBrand && !year && scored.length > 4) {
      var byModel = {};
      var ordered = [];
      for (var s = 0; s < scored.length; s++) {
        var vv = scored[s].v;
        if (vv.brand !== resolvedBrand) continue;
        var key = vv.model;
        if (!byModel[key]) { byModel[key] = []; ordered.push(key); }
        byModel[key].push(vv);
      }
      var groups = ordered.map(function (k) { return { model: k, vehicles: byModel[k] }; });
      if (groups.length > 1) {
        return { kind: 'grouped', brand: resolvedBrand, groups: groups, didYouMean: didYouMean };
      }
    }

    // Group by year-range when single brand+model with multiple generations
    if (resolvedBrand && !year) {
      var topModel = scored[0].v.model;
      var sameModel = scored.filter(function (x) { return x.v.brand === resolvedBrand && x.v.model === topModel; });
      if (sameModel.length > 1) {
        var seen = {};
        var generations = [];
        sameModel.forEach(function (x) {
          var key = x.v.y0 + '-' + x.v.y1;
          if (!seen[key]) { seen[key] = true; generations.push(x.v); }
        });
        if (generations.length > 1) {
          return { kind: 'generations', brand: resolvedBrand, model: topModel, vehicles: generations, didYouMean: didYouMean };
        }
      }
    }

    return { kind: 'matches', items: scored.slice(0, 8).map(function (x) { return x.v; }), didYouMean: didYouMean };
  }

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function brandInitials(brand) {
    return brand.split(/[\s\-]/).filter(Boolean).map(function (p) { return p[0]; }).join('').slice(0, 2).toUpperCase();
  }

  function yearLabel(v) {
    if (v.y1 >= 2025) return v.y0 + '–' + I18N.yr_present;
    return v.y0 + '–' + v.y1;
  }

  function renderSug(v, opts) {
    opts = opts || {};
    var year = yearLabel(v);
    var chassis = v.chassis ? '<span class="cof__sug-chassis">' + escapeHTML(v.chassis) + '</span>' : '';
    var classes = 'cof__sug';
    var fitTag = '';
    if (opts.confirmedFit) {
      classes += ' is-fit';
      fitTag = '<span class="cof__sug-fittag" aria-label="' + I18N.fits_aria + '">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
        ' ' + I18N.fits_label +
        '</span>';
    }
    return (
      '<button class="' + classes + '" role="option" data-id="' + escapeHTML(v.id) + '">' +
      '<span class="cof__sug-logo">' + escapeHTML(brandInitials(v.brand)) + '</span>' +
      '<span class="cof__sug-body">' +
      '<span class="cof__sug-title">' + escapeHTML(v.brand) + ' ' + escapeHTML(v.modelRaw || v.model) + '</span>' +
      '<span class="cof__sug-meta">' +
      '<span class="cof__sug-year">' + year + '</span>' +
      chassis +
      '</span>' +
      '</span>' +
      fitTag +
      '<svg class="cof__sug-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>' +
      '</button>'
    );
  }

  function setGarage(v) {
    var label = (v.y0 === v.y1 ? v.y0 : v.y0 + '–' + (v.y1 >= 2025 ? I18N.yr_present : v.y1)) + ' ' + v.brand + ' ' + (v.modelRaw || v.model);
    try { localStorage.setItem('co_garage', JSON.stringify({ id: v.id, label: label, productHandle: v.productHandle, variantId: v.variantId })); } catch (e) {}
    document.cookie = 'co_garage=' + encodeURIComponent(v.id) + '; path=/; max-age=' + (60 * 60 * 24 * 90) + '; SameSite=Lax';
    renderGarageChips();
  }

  function clearGarage() {
    try { localStorage.removeItem('co_garage'); } catch (e) {}
    document.cookie = 'co_garage=; path=/; max-age=0; SameSite=Lax';
    renderGarageChips();
  }

  function getGarage() {
    try {
      var s = localStorage.getItem('co_garage');
      if (s) return JSON.parse(s);
    } catch (e) {}
    return null;
  }

  function renderGarageChips() {
    var data = getGarage();
    document.querySelectorAll('[data-co-garage-chip]').forEach(function (el) {
      if (data) {
        el.classList.add('is-on');
        var label = el.querySelector('[data-co-garage-label]');
        if (label) label.textContent = data.label;
        var go = el.querySelector('[data-co-garage-go]');
        if (go && data.productHandle) {
          go.href = withLocale('/products/' + data.productHandle) + (data.variantId ? '?variant=' + data.variantId : '');
        }
      } else {
        el.classList.remove('is-on');
      }
    });
  }

  function navigateToVariant(v, openInNew) {
    // Stash the pending-fit signal in sessionStorage BEFORE navigating —
    // Shopify's variant picker rewrites the URL on load and strips unknown
    // query params, so we can't rely on ?fit=1 surviving the trip.
    try {
      sessionStorage.setItem('co_pending_fit', JSON.stringify({
        id: v.id,
        productHandle: v.productHandle,
        variantId: v.variantId || null,
        ts: Date.now()
      }));
    } catch (e) {}
    var qs = [];
    // For deduped/grouped vehicles (variantId === null) we don't preselect a
    // variant — the customer picks the head unit on the product page.
    if (v.variantId) qs.push('variant=' + v.variantId);
    qs.push('fit=1');
    qs.push('vid=' + encodeURIComponent(v.id));
    var url = withLocale('/products/' + v.productHandle) + '?' + qs.join('&');
    if (openInNew) window.open(url, '_blank');
    else window.location.href = url;
  }

  // Try to find a vehicle in the index by id (set by ?vid= or stored garage).
  function findVehicleById(idx, id) {
    if (!id || !idx || !idx.vehicles) return null;
    for (var i = 0; i < idx.vehicles.length; i++) {
      if (idx.vehicles[i].id === id) return idx.vehicles[i];
    }
    return null;
  }

  function getQueryParam(name) {
    if (!window.location.search) return null;
    var params = window.location.search.replace(/^\?/, '').split('&');
    for (var i = 0; i < params.length; i++) {
      var kv = params[i].split('=');
      if (decodeURIComponent(kv[0]) === name) return decodeURIComponent(kv[1] || '');
    }
    return null;
  }

  // Confetti: 360° burst from the centre of `host`. Each piece is launched in
  // a random direction with a random initial speed; gravity then pulls them
  // down via a CSS variable in the keyframe. ~50 pieces, no dependency.
  function fireConfetti(host) {
    if (!host) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    // Brand-driven palette: blue lead, plus festive accent colours that aren't
    // used as static UI elements anywhere on the site.
    var colors = ['#1556FF', '#0A8F4E', '#FF4D6D', '#7C3AED', '#22D3EE', '#0F44D8', '#FF7A1A'];
    var layer = document.createElement('div');
    layer.className = 'co-fit-confetti';
    layer.setAttribute('aria-hidden', 'true');
    var pieces = 56;
    for (var i = 0; i < pieces; i++) {
      var p = document.createElement('span');
      p.className = 'co-fit-confetti__p';
      // Pick a random angle in the upper hemisphere mostly (so pieces shoot
      // up and outward, then fall) but allow some sideways too.
      var angle = (-Math.PI / 2) + (Math.random() - 0.5) * Math.PI * 1.4; // -126° to -54° from horizontal, i.e. up-ish
      var velocity = 80 + Math.random() * 220;
      var dx = Math.round(Math.cos(angle) * velocity);
      var dy = Math.round(Math.sin(angle) * velocity);   // mostly negative (upward)
      var gravity = 280 + Math.random() * 160;            // px of "fall" added at the end
      var delay = Math.round(Math.random() * 120);
      var dur = (1100 + Math.random() * 700).toFixed(0);
      var rot = Math.round(Math.random() * 1080 - 540);
      var color = colors[i % colors.length];
      var size = Math.round(6 + Math.random() * 6);
      // Mix two shapes so it feels like real confetti, not pixels
      var shape = i % 3 === 0 ? '50%' : '2px';
      p.style.cssText =
        'background:' + color + ';' +
        'width:' + size + 'px;height:' + (size + 4) + 'px;' +
        'border-radius:' + shape + ';' +
        'animation-delay:' + delay + 'ms;' +
        'animation-duration:' + dur + 'ms;' +
        '--cof-dx:' + dx + 'px;' +
        '--cof-dy:' + dy + 'px;' +
        '--cof-gravity:' + Math.round(gravity) + 'px;' +
        '--cof-rot:' + rot + 'deg;';
      layer.appendChild(p);
    }
    host.appendChild(layer);
    setTimeout(function () { if (layer.parentElement) layer.parentElement.removeChild(layer); }, 2400);
  }

  // Find the best mount point on the product page so the card sits ABOVE the
  // gallery image. The Kalles theme this site uses puts the layout inside
  // .t4s-main-product__content; we insert as that container's first child so
  // the card spans the full content width on desktop and stacks above on
  // mobile. Falls back through ever-broader containers, finally <main>.
  function findFitMount() {
    var candidates = [
      '.t4s-main-product__content',
      '[data-product-featured]',
      '.t4s-row__product',
      '.t4s-section-main-product',
      '.t4s-product__media-wrapper',
      '.t4s-product__media',
      '.product__media',
      '[data-product-media]',
      'main',
      '[role="main"]'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    return document.body;
  }

  function readPendingFit() {
    var pending = null;
    try {
      var raw = sessionStorage.getItem('co_pending_fit');
      if (raw) {
        pending = JSON.parse(raw);
        // Expire after 10 minutes — covers slow phones / new tabs without
        // leaving a stale celebration on revisits.
        if (!pending || Date.now() - (pending.ts || 0) > 10 * 60 * 1000) pending = null;
      }
    } catch (e) {}
    return pending;
  }

  function clearPendingFit() {
    try { sessionStorage.removeItem('co_pending_fit'); } catch (e) {}
  }

  function showFitBanner(idx) {
    var pending = readPendingFit();
    var fromUrlFit = getQueryParam('fit') === '1';
    if (!pending && !fromUrlFit) return;
    // If a card is already on the page (e.g. theme section reload re-fired
    // init), don't insert a duplicate.
    if (document.querySelector('.co-fit-card')) return;
    var finder = window.CarOptionsFullFinder;
    if (!finder) return;
    var veh = finder.resolveProductVehicleSelection(idx, {
      language: window.CO_LOCALE || 'en',
      productHandle: finder.productHandleForPage(null, window),
      search: window.location.search || '',
      garageJson: pending ? JSON.stringify(pending) : '',
    });
    if (!veh) return;
    // Trim to brand + canonical model only — no year, no chassis sub-codes
    // ("3 Series" not "3 Series / M3"). Keep it clean for the celebration.
    var label = veh.brandName + ' ' + veh.modelName;

    var mount = findFitMount();
    if (!mount) return;
    var existing = document.querySelector('.co-fit-card');
    if (existing) existing.parentElement.removeChild(existing);

    var card = document.createElement('div');
    card.className = 'co-fit-card';
    card.innerHTML =
      '<div class="co-fit-card__row">' +
      '<span class="co-fit-card__check" aria-hidden="true">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
      '</span>' +
      '<span class="co-fit-card__body">' +
      '<span class="co-fit-card__msg">' + t('fit_msg', { label: escapeHTML(label) }) + '</span>' +
      '</span>' +
      '</div>' +
      '<div class="co-fit-card__confetti-host" aria-hidden="true"></div>';
    mount.insertBefore(card, mount.firstChild);

    // Trigger confetti after a short delay so the user perceives the page
    // first and the celebration feels intentional rather than chaotic.
    setTimeout(function () {
      // Re-query in case the host node was reattached by the theme between
      // initial render and now.
      var host = card.querySelector('.co-fit-card__confetti-host');
      fireConfetti(host || card);
    }, 700);

    // Clear the pending-fit flag a beat after we've shown the card so that:
    //   (a) any theme section-reload that fires within a few seconds still
    //       finds the flag and re-attaches the card (idempotent via the
    //       early "already on page" check); and
    //   (b) a manual page refresh later shows a clean product page without
    //       re-celebrating an old selection.
    setTimeout(clearPendingFit, 2500);
  }

  function priceFmt(p) {
    if (!p) return '';
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return '€' + n.toFixed(0);
  }

  function initFinder(root, idx) {
    var input = root.querySelector('[data-cof-input]');
    var results = root.querySelector('[data-cof-results]');
    // fit-card area is rendered as a sibling of the finder, not a descendant —
    // look in the next siblings, then up to one ancestor for a match.
    var fitArea = root.querySelector('[data-cof-fit]');
    if (!fitArea) {
      var sib = root.nextElementSibling;
      while (sib && !fitArea) {
        if (sib.matches && sib.matches('[data-cof-fit]')) fitArea = sib;
        else if (sib.querySelector) fitArea = sib.querySelector('[data-cof-fit]');
        sib = sib.nextElementSibling;
      }
    }
    if (!fitArea && root.parentElement) {
      fitArea = root.parentElement.querySelector('[data-cof-fit]');
    }
    var clearBtn = root.querySelector('[data-cof-clear]');
    var submitBtn = root.querySelector('[data-cof-submit]');
    var hints = root.querySelector('[data-cof-hints]');
    var inputWrap = root.querySelector('[data-cof-input-wrap]');
    var brandSel = root.querySelector('[data-cof-brand]');
    var modelSel = root.querySelector('[data-cof-model]');
    if (!input || !results) return;

    // Populate the brand select once. Brands are pulled from the canonical
    // values in idx.brandAliases, deduplicated and alphabetically sorted.
    if (brandSel && !brandSel.__cofPopulated) {
      brandSel.__cofPopulated = true;
      var brandSet = {};
      Object.keys(idx.brandAliases || {}).forEach(function (k) { brandSet[idx.brandAliases[k]] = true; });
      Object.keys(brandSet).sort().forEach(function (b) {
        var o = document.createElement('option');
        o.value = b;
        o.textContent = b;
        brandSel.appendChild(o);
      });
    }

    function modelsForBrand(brand) {
      if (!brand || !idx.vehicles) return [];
      var seen = {};
      var out = [];
      for (var i = 0; i < idx.vehicles.length; i++) {
        var v = idx.vehicles[i];
        if (v.brand !== brand) continue;
        if (seen[v.model]) continue;
        seen[v.model] = true;
        out.push(v.model);
      }
      out.sort(function (a, b) { return a.localeCompare(b); });
      return out;
    }

    function populateModels(brand) {
      if (!modelSel) return;
      // Wipe everything except the placeholder
      while (modelSel.options.length > 1) modelSel.remove(1);
      var models = modelsForBrand(brand);
      models.forEach(function (m) {
        var o = document.createElement('option');
        o.value = m;
        o.textContent = m;
        modelSel.appendChild(o);
      });
      modelSel.disabled = models.length === 0;
      modelSel.value = '';
    }

    var debounceT;
    var activeIdx = -1;
    var lastResult = null;

    function open() { root.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
    function close() { root.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); activeIdx = -1; }

    function render() {
      var q = input.value.trim();
      if (inputWrap) inputWrap.classList.toggle('has-value', q.length > 0);
      if (clearBtn) clearBtn.style.display = q.length ? 'flex' : 'none';
      if (q.length === 0) { close(); results.innerHTML = ''; return; }

      var r = search(q, idx);
      lastResult = r;
      open();

      // Year-confirmed fit: row gets the "is-fit" callout only when ALL of:
      //   (1) the user typed a 4-digit year,
      //   (2) the year falls inside the row's [y0, y1] range, AND
      //   (3) the user explicitly mentioned this row's model (name or alias)
      // — otherwise sibling models (1 Series for "3 series 2016") would also
      // light up just because their year span happens to include 2016.
      var qNorm = norm(q);
      var qYear = extractYear(qNorm);
      var fitOf = function (v) {
        if (!qYear || !v.y0 || !v.y1) return false;
        if (qYear < v.y0 || qYear > v.y1) return false;
        var modelNorm = norm(v.model);
        if (modelNorm && hasWord(qNorm, modelNorm)) return true;
        var aliases = v.aliases || [];
        for (var i = 0; i < aliases.length; i++) {
          if (hasWord(qNorm, norm(aliases[i]))) return true;
        }
        return false;
      };

      var html = '';
      if (r.didYouMean) {
        html += '<div class="cof__didyoumean">' + t('didyoumean', { to: escapeHTML(r.didYouMean.to), from: escapeHTML(r.didYouMean.from) }) + '</div>';
      }

      if (r.kind === 'unsupported') {
        html += '<div class="cof__empty"><h4>' + t('unsupported_h', { brand: escapeHTML(r.brand) }) + '</h4>' +
          '<p>' + I18N.unsupported_p + '</p>' +
          '<a class="cof__btn" href="' + withLocale('/pages/contact') + '?vehicle=' + encodeURIComponent(q) + '">' + I18N.unsupported_btn + '</a></div>';
      } else if (r.kind === 'grouped') {
        for (var g = 0; g < r.groups.length; g++) {
          var grp = r.groups[g];
          html += '<div class="cof__sec"><div class="cof__sec-head">' + t('grouped_head', { brand: escapeHTML(r.brand), model: escapeHTML(grp.model) }) + '</div>';
          for (var i = 0; i < grp.vehicles.length; i++) html += renderSug(grp.vehicles[i], { confirmedFit: fitOf(grp.vehicles[i]) });
          html += '</div>';
        }
      } else if (r.kind === 'generations') {
        html += '<div class="cof__sec"><div class="cof__sec-head">' + t('generations_head', { brand: escapeHTML(r.brand), model: escapeHTML(r.model) }) + '</div>';
        for (var j = 0; j < r.vehicles.length; j++) html += renderSug(r.vehicles[j], { confirmedFit: fitOf(r.vehicles[j]) });
        html += '</div>';
      } else if (r.kind === 'matches') {
        html += '<div class="cof__sec">';
        for (var m = 0; m < r.items.length; m++) html += renderSug(r.items[m], { confirmedFit: fitOf(r.items[m]) });
        html += '</div>';
      } else if (r.kind === 'no-match') {
        html += '<div class="cof__empty"><h4>' + I18N.no_match_h + '</h4>' +
          '<p>' + I18N.no_match_p + '</p>' +
          '<a class="cof__btn" href="' + withLocale('/pages/contact') + '?vehicle=' + encodeURIComponent(q) + '">' + I18N.no_match_btn + '</a></div>';
      }
      results.innerHTML = html;
      bindResultClicks();
    }

    function bindResultClicks() {
      results.querySelectorAll('.cof__sug').forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.getAttribute('data-id');
          var v = idx.vehicles.find(function (x) { return x.id === id; });
          if (v) selectVehicle(v);
        });
      });
    }

    function selectVehicle(v) {
      close();
      input.value = v.brand + ' ' + (v.modelRaw || v.model) + ' ' + (v.y1 >= 2025 ? v.y0 + '+' : v.y0 + '–' + v.y1);
      if (inputWrap) inputWrap.classList.add('has-value');
      setGarage(v);
      // Always redirect to the product page so the customer lands directly
      // where they can buy. The product page detects the ?fit=1 param and
      // shows a "100% fit" banner + confetti.
      navigateToVariant(v);
    }

    function renderFitCard(v) {
      if (!fitArea) return;
      var yr = yearLabel(v);
      var price = priceFmt(v.price);
      var info = v.infoDisplay
        ? '<p>' + t('fit_info_detected', { system: escapeHTML(v.infoDisplay) }) + '</p>'
        : '<p>' + I18N.fit_info_default + '</p>';
      fitArea.innerHTML =
        '<div class="cof__fit is-fits">' +
        '<div class="cof__fit-body">' +
        '<span class="cof__fit-badge">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
        ' ' + t('fit_badge', { brand: escapeHTML(v.brand), model: escapeHTML(v.modelRaw || v.model), yr: yr }) + '</span>' +
        '<h3>' + t('fit_h3', { brand: escapeHTML(v.brand) }) + '</h3>' +
        info +
        (price ? '<div class="cof__fit-price">' + price + '</div>' : '') +
        '<div class="cof__fit-actions">' +
        '<a class="cof__btn cof__btn-primary" href="' + withLocale('/products/' + escapeHTML(v.productHandle)) + (v.variantId ? '?variant=' + v.variantId : '') + '">' + I18N.fit_view_btn + '</a>' +
        '<a class="cof__btn cof__btn-link" href="#" data-cof-change>' + I18N.fit_change + '</a>' +
        '</div></div></div>';
      var changeLink = fitArea.querySelector('[data-cof-change]');
      if (changeLink) changeLink.addEventListener('click', function (e) { e.preventDefault(); clearAll(); input.focus(); });
    }

    function clearAll() {
      input.value = '';
      if (inputWrap) inputWrap.classList.remove('has-value');
      close();
      results.innerHTML = '';
      if (fitArea) fitArea.innerHTML = '';
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceT);
      debounceT = setTimeout(render, 80);
    });
    input.addEventListener('focus', function () { if (input.value.trim()) open(); });
    input.addEventListener('keydown', function (e) {
      var items = results.querySelectorAll('.cof__sug');
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, items.length - 1); items.forEach(function (x, i) { x.classList.toggle('is-active', i === activeIdx); }); if (items[activeIdx]) items[activeIdx].scrollIntoView({ block: 'nearest' }); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, -1); items.forEach(function (x, i) { x.classList.toggle('is-active', i === activeIdx); }); if (items[activeIdx]) items[activeIdx].scrollIntoView({ block: 'nearest' }); }
       else if (e.key === 'Enter') { if (activeIdx >= 0 && items[activeIdx]) { e.preventDefault(); items[activeIdx].click(); } }
       else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { clearAll(); input.focus(); });

    // Brand dropdown change → populate models. Doesn't touch the text input,
    // so a user who's mid-typing isn't disturbed.
    if (brandSel) {
      brandSel.addEventListener('change', function () {
        populateModels(brandSel.value);
      });
    }

    // Find the best vehicle for a (brand, model) pair: prefer the most recent
    // year-range so customers buying for a current car land on the right
    // chassis without disambiguating.
    function pickBestForDropdowns(brand, model) {
      if (!brand) return null;
      var candidates = (idx.vehicles || []).filter(function (v) {
        if (v.brand !== brand) return false;
        if (model && v.model !== model) return false;
        return true;
      });
      if (!candidates.length) return null;
      candidates.sort(function (a, b) { return (b.y1 || 0) - (a.y1 || 0); });
      return candidates[0];
    }

    function submit() {
      // 1) Free-text wins when present — pick the active or first suggestion.
      var text = input.value.trim();
      if (text.length) {
        var items = results.querySelectorAll('.cof__sug');
        if (items.length) {
          (items[Math.max(activeIdx, 0)] || items[0]).click();
          return;
        }
        input.focus();
        render();
        return;
      }
      // 2) No text — fall back to whatever the dropdowns specify.
      var brand = brandSel ? brandSel.value : '';
      var model = modelSel ? modelSel.value : '';
      if (brand && model) {
        var v = pickBestForDropdowns(brand, model);
        if (v) { selectVehicle(v); return; }
      }
      if (brand) {
        // Show the brand's models grouped — same UX as typing the brand name.
        input.value = brand;
        render();
        return;
      }
      // 3) Nothing — focus the input.
      input.focus();
    }

    if (submitBtn) submitBtn.addEventListener('click', submit);
    // Pressing Enter inside the model select also submits.
    if (modelSel) modelSel.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
    if (hints) {
      hints.querySelectorAll('[data-cof-chip]').forEach(function (c) {
        c.addEventListener('click', function () {
          input.value = c.getAttribute('data-cof-chip');
          input.focus();
          render();
        });
      });
    }
  }

  function init() {
    loadIndex().then(function (idx) {
      document.querySelectorAll('[data-co-finder]').forEach(function (root) {
        root.__cofLegacyDeferred = true;
      });
      // Garage chips can render without index
      renderGarageChips();
      // Garage clear handlers
      document.querySelectorAll('[data-co-garage-clear]').forEach(function (b) {
        if (b.__cofGCBound) return;
        b.__cofGCBound = true;
        b.addEventListener('click', function (e) { e.preventDefault(); clearGarage(); });
      });
      // 100%-fit banner when arriving from a search redirect
      if (!window.__cofBannerShown) {
        window.__cofBannerShown = true;
        showFitBanner(idx);
      }
    }).catch(function () {
      // The shared bootstrap/full finder owns the visible retry and help state.
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections load dynamically (Shopify section reload)
  document.addEventListener('shopify:section:load', init);
})();
/* BEGIN CAROPTIONS EU FULL VEHICLE FINDER */
(function (global) {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[-_/\\\u2013\u2014]/g, ' ')
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function slug(value) {
    return normalize(value).replace(/\s+/g, '-');
  }

  function languageCode(language) {
    var code = String(language || 'en').toLowerCase().split('-')[0];
    return code === 'nb' || code === 'nn' ? 'no' : code;
  }

  function localizedBrandName(brand, language) {
    var name = typeof brand === 'string' ? brand : brand && brand.name;
    if (name === 'Skoda') return 'Škoda';
    return String(name || '');
  }

  function localizedModelNames(brand, canonicalName) {
    var name = String(canonicalName || '');
    var result = {
      en: name, de: name, es: name, fr: name, it: name,
      pl: name, sv: name, da: name, fi: name, no: name,
    };
    var mercedesLetter = brand === 'Mercedes-Benz' && name.match(/^([ABCEGSVX])-Class$/);
    var mercedesHistoric = brand === 'Mercedes-Benz' && name.match(/^(CL|GL|GLK|ML)-Class$/);
    var mercedesCode = brand === 'Mercedes-Benz' && name.match(/^(CLA|CLS|EQA|EQB|EQC|GLA|GLB|GLC|GLE|GLS|SL|SLC|SLK)-Class$/);
    var bmwSeries = brand === 'BMW' && name.match(/^([1-8]) Series$/);

    if (mercedesLetter) {
      var letter = mercedesLetter[1];
      result = {
        en: letter + '-Class',
        de: letter + '-Klasse',
        es: 'Clase ' + letter,
        fr: 'Classe ' + letter,
        it: 'Classe ' + letter,
        pl: 'Klasa ' + letter,
        sv: letter + '-Klass',
        da: letter + '-Klasse',
        fi: letter + '-sarja',
        no: letter + '-klasse',
      };
    } else if (mercedesHistoric) {
      var historicCode = mercedesHistoric[1] === 'ML' ? 'M' : mercedesHistoric[1];
      result = {
        en: historicCode + '-Class',
        de: historicCode + '-Klasse',
        es: 'Clase ' + historicCode,
        fr: 'Classe ' + historicCode,
        it: 'Classe ' + historicCode,
        pl: 'Klasa ' + historicCode,
        sv: historicCode + '-Klass',
        da: historicCode + '-Klasse',
        fi: historicCode + '-sarja',
        no: historicCode + '-klasse',
      };
    } else if (mercedesCode) {
      Object.keys(result).forEach(function (code) { result[code] = mercedesCode[1]; });
    } else if (brand === 'Mercedes-Benz' && name === 'AMG SLS') {
      Object.keys(result).forEach(function (code) { result[code] = 'SLS AMG'; });
    } else if (bmwSeries) {
      var series = bmwSeries[1];
      result = {
        en: series + ' Series',
        de: series + 'er-Reihe',
        es: 'Serie ' + series,
        fr: 'Série ' + series,
        it: 'Serie ' + series,
        pl: 'Seria ' + series,
        sv: series + '-serie',
        da: series + '-serie',
        fi: series + '-sarja',
        no: series + '-serie',
      };
    } else if (brand === 'Audi' && name === 'E-tron') {
      Object.keys(result).forEach(function (code) { result[code] = 'e-tron'; });
    } else if (brand === 'smart' && name === 'ForFour') {
      Object.keys(result).forEach(function (code) { result[code] = 'smart forfour'; });
    } else if (brand === 'McLaren' && name === 'All Models') {
      result = {
        en: 'All models',
        de: 'Alle Modelle',
        es: 'Todos los modelos',
        fr: 'Tous les modèles',
        it: 'Tutti i modelli',
        pl: 'Wszystkie modele',
        sv: 'Alla modeller',
        da: 'Alle modeller',
        fi: 'Kaikki mallit',
        no: 'Alle modeller',
      };
    }
    return result;
  }

  function localizedModelName(brand, canonicalName, language) {
    var names = localizedModelNames(brand, canonicalName);
    return names[languageCode(language)] || names.en || String(canonicalName || '');
  }

  var MODEL_ORDER_BY_BRAND = {
    BMW: ['1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '6 Series', '7 Series', '8 Series', 'i3', 'i8', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'Z4'],
    Audi: ['A1', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q2', 'Q3', 'Q4', 'Q5', 'Q7', 'Q8', 'E-tron', 'TT', 'R8'],
    'Mercedes-Benz': ['A-Class', 'B-Class', 'C-Class', 'E-Class', 'S-Class', 'CLA-Class', 'CL-Class', 'CLS-Class', 'EQA-Class', 'EQB-Class', 'EQC-Class', 'G-Class', 'GLA-Class', 'GLB-Class', 'GLK-Class', 'GLC-Class', 'ML-Class', 'GLE-Class', 'GL-Class', 'GLS-Class', 'SL-Class', 'SLK-Class', 'SLC-Class', 'AMG GT', 'AMG SLS', 'V-Class', 'X-Class'],
    Volkswagen: ['Arteon', 'Golf', 'Passat', 'Polo', 'T-Cross', 'T-Roc', 'Tiguan', 'Touareg', 'Touran', 'RNS510'],
    Volvo: ['S60', 'S80', 'S90', 'V40', 'V60', 'V70', 'V90', 'XC40', 'XC60', 'XC70', 'XC90'],
    Porsche: ['911', 'Cayman', 'Panamera', 'Macan', 'Cayenne'],
    Lexus: ['CT', 'IS', 'ES', 'GS', 'LS', 'RC', 'LC', 'UX', 'NX', 'RX'],
    'Alfa Romeo': ['Giulietta', 'Giulia', 'Stelvio'],
    'Aston Martin': ['Vantage', 'DB11', 'DBS'],
    Bentley: ['Continental', 'Flying Spur', 'Mulsanne', 'Bentayga'],
    'Citroën': ['C3', 'C4', 'C4 Cactus', 'C4 Picasso', 'C4 SpaceTourer', 'C5', 'DS3', 'DS4', 'DS5'],
    Dodge: ['RAM'],
    Ferrari: ['458', '488', 'F8', '812', 'California T', 'Portofino', 'GTC4Lusso'],
    Fiat: ['124 Spider'],
    Ford: ['Focus', 'Mondeo', 'C-Max', 'S-Max', 'Kuga', 'Mustang'],
    Jaguar: ['XE', 'XF', 'XJ', 'E-PACE', 'F-PACE', 'I-PACE', 'F-TYPE'],
    Jeep: ['Renegade', 'Compass', 'Cherokee'],
    Lamborghini: ['Huracán', 'Aventador'],
    'Land Rover': ['Discovery Sport', 'Discovery', 'Range Rover Evoque', 'Range Rover Sport', 'Range Rover'],
    Maserati: ['Ghibli', 'Quattroporte'],
    Mazda: ['2', '3', '6', 'CX-3', 'CX-5', 'MX-5'],
    McLaren: ['All Models'],
    MINI: ['Cooper', 'Clubman', 'Countryman', 'Paceman', 'Roadster'],
    Nissan: ['370Z', 'GTR'],
    Peugeot: ['208', '308', '508', '2008'],
    Renault: ['Twingo', 'Clio', 'Megane', 'Talisman', 'Captur', 'Kadjar', 'Scenic', 'Espace', 'Zoe', 'Trafic', 'Master'],
    'Rolls-Royce': ['Ghost', 'Phantom', 'Wraith', 'Dawn'],
    SEAT: ['Ibiza', 'Leon', 'Toledo', 'Arona', 'Ateca', 'Tarraco'],
    Skoda: ['Fabia', 'Scala', 'Rapid', 'Octavia', 'Superb', 'Yeti', 'Kamiq', 'Karoq', 'Kodiaq'],
    smart: ['ForFour'],
    Tesla: ['Model 3', 'Model Y'],
    Toyota: ['Yaris', 'Auris', 'Prius', 'C-HR', 'RAV4'],
  };

  function modelSortKey(brand, canonicalName) {
    var name = String(canonicalName || '');
    var order = MODEL_ORDER_BY_BRAND[brand] || [];
    var index = order.indexOf(name);
    return index >= 0
      ? '00-' + String(index).padStart(4, '0')
      : '99-' + name;
  }

  function unique(values) {
    var seen = {};
    return values.filter(function (value) {
      var key = String(value || '');
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character];
    });
  }

  function rangeLabel(y0, y1, copy) {
    if (y0 == null || y1 == null) return copy.all_years;
    if (Number(y0) === Number(y1)) return String(y0);
    if (Number(y1) >= 2099) return y0 + '\u2013' + copy.present;
    return y0 + '\u2013' + y1;
  }

  function rangeActionSignature(range) {
    if (!range || range.y0 == null || range.y1 == null) return null;
    var handles = unique(range.rows.map(function (row) { return row.productHandle; }));
    if (handles.length !== 1) return null;
    if (range.preferredVariantId != null) {
      return ['direct', handles[0], String(range.preferredVariantId), range.systemLabel || ''].join('|');
    }
    if (range.choices.length === 1) {
      return [
        'direct',
        handles[0],
        String(range.choices[0].variantId),
        range.systemLabel || range.choices[0].label || '',
      ].join('|');
    }
    if (range.choices.length > 1) {
      return ['choices', handles[0], range.choices.map(function (choice) {
        return String(choice.variantId) + ':' + String(choice.label || '');
      }).sort().join(';')].join('|');
    }
    return null;
  }

  function mergedRange(left, right, copy) {
    var preferredSource = left.preferredVariantId != null
      ? left
      : right.preferredVariantId != null
        ? right
        : null;
    var choices = [];
    var seenChoices = {};
    left.choices.concat(right.choices).forEach(function (choice) {
      var key = String(choice.variantId);
      if (seenChoices[key]) return;
      seenChoices[key] = true;
      choices.push(choice);
    });
    var y0 = Math.min(Number(left.y0), Number(right.y0));
    var y1 = Math.max(Number(left.y1), Number(right.y1));
    return {
      id: preferredSource ? preferredSource.id : left.id,
      label: rangeLabel(y0, y1, copy),
      y0: y0,
      y1: y1,
      systemLabel: left.systemLabel || right.systemLabel || null,
      preferredVariantId: preferredSource ? preferredSource.preferredVariantId : null,
      choices: choices,
      rows: left.rows.concat(right.rows),
    };
  }

  function coalesceRanges(ranges, copy) {
    var ordered = ranges.slice().sort(function (left, right) {
      if (left.y0 == null && right.y0 == null) return 0;
      if (left.y0 == null) return 1;
      if (right.y0 == null) return -1;
      return Number(left.y0) - Number(right.y0) || Number(left.y1) - Number(right.y1);
    });
    var result = [];
    ordered.forEach(function (range) {
      var previous = result[result.length - 1];
      var previousSignature = rangeActionSignature(previous);
      var currentSignature = rangeActionSignature(range);
      if (
        previous &&
        previous.y0 != null &&
        previous.y1 != null &&
        range.y0 != null &&
        range.y1 != null &&
        Number(range.y0) <= Number(previous.y1) + 1 &&
        previousSignature &&
        previousSignature === currentSignature
      ) {
        result[result.length - 1] = mergedRange(previous, range, copy);
      } else {
        result.push(range);
      }
    });
    return result.sort(function (left, right) {
      if (left.y0 == null && right.y0 == null) return 0;
      if (left.y0 == null) return 1;
      if (right.y0 == null) return -1;
      return Number(right.y0) - Number(left.y0);
    });
  }

  function buildTechnicalTree(index, copy, language) {
    var labels = copy || { all_years: 'All years', present: 'present' };
    var vehicles = index && Array.isArray(index.vehicles) ? index.vehicles : [];
    var brands = index && Array.isArray(index.brands) ? index.brands : [];

    return brands.map(function (brand) {
      var modelMap = {};
      vehicles.forEach(function (vehicle) {
        if (vehicle.brand !== brand.name) return;
        var modelId = slug(vehicle.model);
        if (!modelMap[modelId]) {
          modelMap[modelId] = {
            id: modelId,
            canonicalName: vehicle.model,
            name: localizedModelName(brand.name, vehicle.model, language),
            aliases: [],
            rows: [],
          };
        }
        var localizedNames = localizedModelNames(brand.name, vehicle.model);
        var localizedAliases = Object.keys(localizedNames).map(function (code) { return localizedNames[code]; });
        // Customers also write "3 Reihe" without the German ordinal suffix.
        if (brand.name === 'BMW' && /^[1-8] Series$/.test(vehicle.model)) {
          localizedAliases.push(vehicle.model.charAt(0) + ' Reihe');
        }
        modelMap[modelId].aliases = unique(modelMap[modelId].aliases.concat(
          vehicle.aliases || [],
          localizedAliases,
          [vehicle.model, vehicle.modelRaw, brand.name + ' ' + vehicle.model],
        ));
        modelMap[modelId].rows.push(vehicle);
      });

      var models = Object.keys(modelMap).map(function (modelId) {
        var model = modelMap[modelId];
        var rangeMap = {};
        model.rows.forEach(function (row) {
          var key = String(row.y0 == null ? 'all' : row.y0) + '|' + String(row.y1 == null ? 'all' : row.y1);
          if (!rangeMap[key]) rangeMap[key] = [];
          rangeMap[key].push(row);
        });

        var ranges = Object.keys(rangeMap).map(function (key) {
          var rows = rangeMap[key];
          var systems = unique(rows.map(function (row) { return row.infoDisplay; }));
          var choices = [];
          var seenChoices = {};
          rows.forEach(function (row) {
            if (row.variantId == null) return;
            var variantId = String(row.variantId);
            if (seenChoices[variantId]) return;
            seenChoices[variantId] = true;
            choices.push({
              variantId: variantId,
              label: row.infoDisplay || row.chassis || 'Vehicle system',
              row: row,
            });
          });
          var preferredVariantId = rows.map(function (row) { return row.preferredVariantId; })
            .find(function (value) { return value != null; });
          var preferredChoice = preferredVariantId == null ? null : choices.find(function (choice) {
            return String(choice.variantId) === String(preferredVariantId);
          });
          return {
            id: preferredChoice ? preferredChoice.row.id : rows[0].id,
            label: rangeLabel(rows[0].y0, rows[0].y1, labels),
            y0: rows[0].y0,
            y1: rows[0].y1,
            systemLabel: preferredChoice
              ? preferredChoice.label
              : systems.length === 1
                ? systems[0]
                : choices.length === 1
                  ? choices[0].label
                  : null,
            preferredVariantId: preferredChoice ? preferredChoice.variantId : null,
            choices: choices,
            rows: rows,
          };
        });
        ranges = coalesceRanges(ranges, labels);

        return {
          id: model.id,
          name: model.name,
          canonicalName: model.canonicalName,
          aliases: model.aliases,
          ranges: ranges,
        };
      });
      models.sort(function (left, right) {
        var leftKey = modelSortKey(brand.name, left.canonicalName);
        var rightKey = modelSortKey(brand.name, right.canonicalName);
        return leftKey.localeCompare(rightKey, languageCode(language), { numeric: true, sensitivity: 'base' });
      });

      return {
        id: brand.id,
        name: localizedBrandName(brand, language),
        canonicalName: brand.name,
        aliases: unique((brand.aliases || []).concat([brand.name, localizedBrandName(brand, language)])),
        logo: brand.logo,
        popularRank: brand.popularRank || null,
        productHandle: brand.productHandle,
        models: models,
      };
    });
  }

  function hasCompleteCustomerPeriodCatalog(index) {
    var vehicles = index && Array.isArray(index.vehicles) ? index.vehicles : [];
    var periods = index && Array.isArray(index.customerPeriods) ? index.customerPeriods : [];
    if (!vehicles.length || !periods.length) return false;

    var modelKeys = {};
    var technicalYears = {};
    vehicles.forEach(function (row) {
      if (!row || !row.brand || !row.model) return;
      var key = row.brand + '|' + row.model;
      modelKeys[key] = true;
      if (!technicalYears[key]) technicalYears[key] = {};
      if (Number.isInteger(row.y0) && Number.isInteger(row.y1) && row.y0 <= row.y1 && row.y1 < 2099) {
        for (var year = row.y0; year <= row.y1; year += 1) technicalYears[key][year] = true;
      }
    });

    var periodsByModel = {};
    var exactPeriods = {};
    for (var indexPosition = 0; indexPosition < periods.length; indexPosition += 1) {
      var period = periods[indexPosition];
      var modelKey = period && period.brand + '|' + period.model;
      if (!period || !modelKeys[modelKey]) return false;
      if (!Number.isInteger(period.y0) || !Number.isInteger(period.y1) || period.y0 > period.y1 || period.y0 < 1990 || period.y1 >= 2099) return false;
      if (period.confidence !== 'high' && period.confidence !== 'medium') return false;
      if (!period.productHandle || period.defaultVariantId == null || String(period.defaultVariantId) === '') return false;
      if (!Array.isArray(period.evidenceIds) || period.evidenceIds.length < 2 || unique(period.evidenceIds).length !== period.evidenceIds.length) return false;
      var exactKey = [modelKey, period.y0, period.y1, period.productHandle, period.defaultVariantId].join('|');
      if (exactPeriods[exactKey]) return false;
      exactPeriods[exactKey] = true;
      if (!periodsByModel[modelKey]) periodsByModel[modelKey] = [];
      periodsByModel[modelKey].push(period);
    }

    var expectedModels = Object.keys(modelKeys).sort();
    var actualModels = Object.keys(periodsByModel).sort();
    if (expectedModels.length !== actualModels.length || expectedModels.some(function (key, position) { return key !== actualModels[position]; })) return false;

    var sourceFirstCatalog = periods.every(function (period) {
      return typeof period.reason === 'string' && period.reason.trim() !== '';
    });

    return expectedModels.every(function (key) {
      var modelPeriods = periodsByModel[key];
      var previous = null;
      for (var position = 0; position < modelPeriods.length; position += 1) {
        var current = modelPeriods[position];
        if (previous && (current.y1 >= previous.y0 || current.y1 > previous.y1)) return false;
        previous = current;
      }
      if (sourceFirstCatalog) return true;
      return Object.keys(technicalYears[key] || {}).every(function (year) {
        return modelPeriods.some(function (period) { return period.y0 <= Number(year) && period.y1 >= Number(year); });
      });
    });
  }

  function buildCustomerPeriodTree(index, copy, language) {
    if (!hasCompleteCustomerPeriodCatalog(index)) return null;
    var labels = copy || { all_years: 'All years', present: 'present' };
    var tree = buildTechnicalTree(index, copy, language);
    var periodsByModel = {};
    index.customerPeriods.forEach(function (period) {
      var key = period.brand + '|' + period.model;
      if (!periodsByModel[key]) periodsByModel[key] = [];
      periodsByModel[key].push(period);
    });

    tree.forEach(function (brand) {
      brand.models.forEach(function (model) {
        var periods = periodsByModel[brand.canonicalName + '|' + model.canonicalName] || [];
        model.ranges = periods.map(function (period) {
          var variantId = String(period.defaultVariantId);
          var row = {
            id: ['cp', slug(period.brand), slug(period.model), period.y0 + '-' + period.y1].join('|'),
            brand: period.brand,
            model: period.model,
            y0: period.y0,
            y1: period.y1,
            productHandle: period.productHandle,
            variantId: variantId,
          };
          return {
            id: row.id,
            label: rangeLabel(period.y0, period.y1, labels),
            y0: period.y0,
            y1: period.y1,
            systemLabel: null,
            preferredVariantId: variantId,
            choices: [{ variantId: variantId, label: '', row: row }],
            rows: [row],
            isCustomerPeriod: true,
          };
        });
      });
    });
    return tree;
  }

  function buildTree(index, copy, language) {
    return buildCustomerPeriodTree(index, copy, language) || buildTechnicalTree(index, copy, language);
  }

  function productVehicleIds(options) {
    var values = options || {};
    var ids = [];
    try {
      var params = new global.URLSearchParams(String(values.search || '').replace(/^\?/, ''));
      if (params.get('fit') === '1' && params.get('vid')) ids.push(params.get('vid'));
    } catch (error) {}
    try {
      var stored = JSON.parse(String(values.garageJson || ''));
      if (stored && stored.id) ids.push(String(stored.id));
    } catch (error) {}
    if (values.cookieId) ids.push(String(values.cookieId));
    return unique(ids);
  }

  function productHandleForPage(root, environment) {
    var runtime = environment || global;
    var documentObject = runtime.document;
    var productRoot = root || (documentObject && documentObject.querySelector('[data-co-product-vehicle]'));
    var handle = productRoot && productRoot.getAttribute('data-copv-product-handle');
    if (handle) return handle;
    // Liquid metadata also covers translated handles; the route fallback supports
    // both localized and collection product URLs when this snippet is absent.
    var match = String(runtime.location && runtime.location.pathname || '').match(/\/products\/([^/]+)\/?$/);
    try { return match ? decodeURIComponent(match[1]) : ''; } catch (error) { return ''; }
  }

  function findProductVehicle(tree, id, productHandle) {
    for (var brandIndex = 0; brandIndex < tree.length; brandIndex += 1) {
      var brand = tree[brandIndex];
      for (var modelIndex = 0; modelIndex < brand.models.length; modelIndex += 1) {
        var model = brand.models[modelIndex];
        for (var rangeIndex = 0; rangeIndex < model.ranges.length; rangeIndex += 1) {
          var range = model.ranges[rangeIndex];
          var matchedRows = range.rows.filter(function (row) { return row.id === id; });
          if (!matchedRows.length && range.id === id) matchedRows = range.rows;
          if (!matchedRows.some(function (row) { return row.productHandle === productHandle; })) continue;
          return {
            id: range.id,
            brandId: brand.id,
            brandName: brand.name,
            modelName: model.name,
            yearLabel: range.label,
            label: brand.name + ' ' + model.name + ' \u00b7 ' + range.label,
            logo: brand.logo,
          };
        }
      }
    }
    return null;
  }

  function resolveProductVehicleSelection(index, options) {
    var values = options || {};
    if (!values.productHandle) return null;
    var tree = buildTree(
      index,
      values.copy || { all_years: 'All years', present: 'present' },
      values.language || 'en',
    );
    var ids = productVehicleIds(values);
    var technicalTree = null;
    for (var position = 0; position < ids.length; position += 1) {
      var selected = findProductVehicle(tree, ids[position], values.productHandle);
      // Earlier finder versions persisted technical row IDs. Keep those valid
      // even when the current index renders the newer customer-period catalog.
      if (!selected) {
        if (!technicalTree) technicalTree = buildTechnicalTree(index, values.copy, values.language);
        selected = findProductVehicle(technicalTree, ids[position], values.productHandle);
      }
      if (selected) return selected;
    }
    return null;
  }

  function mountProductVehicle(root, index, environment) {
    if (!root) return null;
    var runtime = environment || global;
    var documentObject = runtime.document || global.document;
    var copyNode = root.querySelector('[data-copv-copy]');
    var copy = {};
    try { copy = JSON.parse(copyNode ? copyNode.textContent : '{}'); } catch (error) {}

    function cookieId() {
      var match = String(documentObject && documentObject.cookie || '').match(/(?:^|;\s*)co_garage=([^;]*)/);
      try { return match ? decodeURIComponent(match[1]) : ''; } catch (error) { return ''; }
    }

    function storedJson() {
      try { return runtime.localStorage && runtime.localStorage.getItem('co_garage') || ''; } catch (error) { return ''; }
    }

    function render() {
      var selected = resolveProductVehicleSelection(index, {
        language: root.getAttribute('data-copv-locale') || 'en',
        productHandle: productHandleForPage(root, runtime),
        search: runtime.location && runtime.location.search || '',
        garageJson: storedJson(),
        cookieId: cookieId(),
        copy: copy,
      });
      var empty = root.querySelector('[data-copv-empty]');
      var panel = root.querySelector('[data-copv-selected]');
      if (empty) empty.hidden = Boolean(selected);
      if (panel) panel.hidden = !selected;
      root.setAttribute('data-copv-state', selected ? 'selected' : 'empty');
      if (!selected) return null;

      var logo = root.querySelector('[data-copv-logo]');
      var label = root.querySelector('[data-copv-label]');
      var year = root.querySelector('[data-copv-year]');
      if (logo) {
        logo.src = selected.logo;
        logo.setAttribute('width', '48');
        logo.setAttribute('height', '48');
        logo.setAttribute('loading', 'eager');
        logo.setAttribute('decoding', 'async');
        logo.setAttribute('fetchpriority', 'high');
      }
      if (label) label.textContent = selected.brandName + ' ' + selected.modelName;
      if (year) year.textContent = selected.yearLabel;
      return selected;
    }

    function stripFitQuery() {
      if (!runtime.location || !runtime.history || typeof runtime.history.replaceState !== 'function') return;
      try {
        var params = new global.URLSearchParams(String(runtime.location.search || '').replace(/^\?/, ''));
        if (!params.has('fit') && !params.has('vid')) return;
        params.delete('fit');
        params.delete('vid');
        var query = params.toString();
        var path = String(runtime.location.pathname || '') + (query ? '?' + query : '') + String(runtime.location.hash || '');
        runtime.history.replaceState(runtime.history.state || null, '', path);
      } catch (error) {}
    }

    function clear() {
      try { if (runtime.localStorage) runtime.localStorage.removeItem('co_garage'); } catch (error) {}
      try { if (runtime.sessionStorage) runtime.sessionStorage.removeItem('co_pending_fit'); } catch (error) {}
      if (documentObject) documentObject.cookie = 'co_garage=; path=/; max-age=0; SameSite=Lax';
      stripFitQuery();
      render();
    }

    var clearButton = root.querySelector('[data-copv-clear]');
    if (clearButton) clearButton.addEventListener('click', clear);
    if (root.closest && copy.or) {
      var picker = root.closest('.license_plate_wrapper__picker');
      var separator = picker && picker.querySelector('.separator-text');
      if (separator) separator.textContent = copy.or;
    }
    render();
    return {
      render: render,
      destroy: function () {
        if (clearButton) clearButton.removeEventListener('click', clear);
      },
    };
  }

  function normalizeRoot(root) {
    var value = String(root || '').trim();
    if (!value || value === '/') return '';
    if (value.charAt(0) !== '/') value = '/' + value;
    return value.replace(/\/+$/, '');
  }

  function destinationFor(range, localeRoot, selectedVariantId) {
    if (!range || !Array.isArray(range.rows) || !range.rows.length) return null;
    var handles = unique(range.rows.map(function (row) { return row.productHandle; }));
    if (handles.length !== 1) return null;

    var variantIds = unique(range.rows.map(function (row) {
      return row.variantId == null ? null : String(row.variantId);
    }));
    var requestedVariantId = selectedVariantId == null
      ? range.preferredVariantId == null ? null : String(range.preferredVariantId)
      : String(selectedVariantId);
    if (requestedVariantId && variantIds.indexOf(requestedVariantId) === -1) return null;
    var allRowsProveVariant = range.rows.every(function (row) { return row.variantId != null; });
    var variantId = requestedVariantId || (allRowsProveVariant && variantIds.length === 1 ? variantIds[0] : null);
    if (!variantId && variantIds.length > 1) return null;
    var query = [];
    if (variantId) query.push('variant=' + encodeURIComponent(variantId));
    query.push('fit=1');
    query.push('vid=' + encodeURIComponent(range.id));

    return {
      productHandle: handles[0],
      variantId: variantId,
      url: normalizeRoot(localeRoot) + '/products/' + handles[0] + '?' + query.join('&'),
    };
  }

  function preserveNavigationBypass(url, currentSearch) {
    var destination = String(url || '');
    if (!destination || typeof global.URLSearchParams !== 'function') return destination;
    try {
      var currentParams = new global.URLSearchParams(String(currentSearch || '').replace(/^\?/, ''));
      if (!currentParams.has('pb')) return destination;

      var hashIndex = destination.indexOf('#');
      var hash = hashIndex >= 0 ? destination.slice(hashIndex) : '';
      var base = hashIndex >= 0 ? destination.slice(0, hashIndex) : destination;
      var queryIndex = base.indexOf('?');
      var destinationParams = new global.URLSearchParams(queryIndex >= 0 ? base.slice(queryIndex + 1) : '');
      if (destinationParams.has('pb')) return destination;

      var separator = queryIndex >= 0 ? '&' : '?';
      var bypassValue = currentParams.get('pb');
      return base + separator + 'pb=' + encodeURIComponent(bypassValue == null ? '' : bypassValue) + hash;
    } catch (error) {
      return destination;
    }
  }

  function singleVariantSelection(model, localeRoot) {
    if (!model || !Array.isArray(model.ranges) || !model.ranges.length) return null;
    var selection = null;
    var destinationKey = null;
    for (var index = 0; index < model.ranges.length; index += 1) {
      var range = model.ranges[index];
      var destination = destinationFor(range, localeRoot);
      if (!destination || !destination.productHandle || !destination.variantId) return null;
      var key = destination.productHandle + '::' + String(destination.variantId);
      if (destinationKey && key !== destinationKey) return null;
      if (!selection) {
        selection = { range: range, destination: destination };
        destinationKey = key;
      }
    }
    return selection;
  }

  function editDistance(left, right) {
    var a = String(left || '');
    var b = String(right || '');
    var matrix = [];
    var row;
    var column;
    for (row = 0; row <= a.length; row += 1) {
      matrix[row] = [];
      matrix[row][0] = row;
    }
    for (column = 0; column <= b.length; column += 1) matrix[0][column] = column;
    for (row = 1; row <= a.length; row += 1) {
      for (column = 1; column <= b.length; column += 1) {
        matrix[row][column] = Math.min(
          matrix[row][column - 1] + 1,
          matrix[row - 1][column] + 1,
          matrix[row - 1][column - 1] + (a.charAt(row - 1) === b.charAt(column - 1) ? 0 : 1)
        );
        if (row > 1 && column > 1 &&
          a.charAt(row - 1) === b.charAt(column - 2) &&
          a.charAt(row - 2) === b.charAt(column - 1)) {
          matrix[row][column] = Math.min(matrix[row][column], matrix[row - 2][column - 2] + 1);
        }
      }
    }
    return matrix[a.length][b.length];
  }

  function isAdjacentTransposition(left, right) {
    var a = String(left || '');
    var b = String(right || '');
    if (a.length !== b.length || a.length < 2) return false;
    var differences = [];
    for (var index = 0; index < a.length; index += 1) {
      if (a.charAt(index) !== b.charAt(index)) differences.push(index);
    }
    return differences.length === 2 && differences[1] === differences[0] + 1 &&
      a.charAt(differences[0]) === b.charAt(differences[1]) &&
      a.charAt(differences[1]) === b.charAt(differences[0]);
  }

  function digitSequence(value) {
    return String(value || '').replace(/[^0-9]/g, '');
  }

  function fuzzyThreshold(value) {
    var length = String(value || '').length;
    if (length >= 8) return 2;
    if (length >= 4) return 1;
    return 0;
  }

  function tokenMatch(queryToken, candidateToken, options) {
    var settings = options || {};
    var query = String(queryToken || '');
    var candidate = String(candidateToken || '');
    if (!query || !candidate) return null;
    if (query === candidate) return { score: 120, kind: 'exact', distance: 0 };

    var minimumPrefixLength = Math.max(1, Number(settings.minimumPrefixLength || 3));
    if (query.length >= minimumPrefixLength && query.length < candidate.length && candidate.indexOf(query) === 0) {
      return { score: 96, kind: 'prefix', distance: 0 };
    }

    var candidateHasLetter = /[a-z]/.test(candidate);
    var candidateHasDigit = /[0-9]/.test(candidate);
    var queryExtendsVehicleCode = query.length > candidate.length && query.indexOf(candidate) === 0 && (
      (candidateHasLetter && candidateHasDigit) ||
      (candidate.length >= 2 && /^[a-z]{2,}$/.test(candidate) && /^[0-9]/.test(query.slice(candidate.length)))
    );
    if (queryExtendsVehicleCode) {
      return { score: 92, kind: 'code-prefix', distance: 0 };
    }

    if (isAdjacentTransposition(query, candidate)) {
      return { score: 82, kind: 'transpose', distance: 1 };
    }

    var shortDistance = Math.abs(query.length - candidate.length) <= 1 ? editDistance(query, candidate) : 99;
    if (settings.allowShortEdit && candidate.length >= 2 && candidate.length <= 3 && shortDistance === 1 &&
      (digitSequence(query) === digitSequence(candidate) || settings.allowNumericEdit)) {
      return { score: 60, kind: 'fuzzy', distance: 1 };
    }
    if (settings.allowNumericEdit && candidate.length >= 2 && shortDistance === 1) {
      return { score: 54, kind: 'fuzzy', distance: 1 };
    }

    var threshold = fuzzyThreshold(candidate);
    if (!threshold || Math.abs(query.length - candidate.length) > threshold) return null;
    if (!settings.allowNumericEdit && digitSequence(query) !== digitSequence(candidate)) return null;
    var distance = editDistance(query, candidate);
    if (distance > threshold) return null;
    return { score: 72 - (distance * 8), kind: 'fuzzy', distance: distance };
  }

  function bestTokenAssignment(queryTokens, candidateTokens, options) {
    if (!candidateTokens.length || candidateTokens.length > queryTokens.length) return null;
    var used = [];
    var best = null;

    function visit(candidateIndex, totalScore, totalDistance, prefixCount, fuzzyCount, indexes) {
      if (candidateIndex >= candidateTokens.length) {
        var result = {
          tokenScore: totalScore,
          distance: totalDistance,
          prefixCount: prefixCount,
          fuzzyCount: fuzzyCount,
          matchedIndexes: indexes.slice(),
        };
        if (!best || result.tokenScore > best.tokenScore ||
          (result.tokenScore === best.tokenScore && result.distance < best.distance)) best = result;
        return;
      }
      for (var queryIndex = 0; queryIndex < queryTokens.length; queryIndex += 1) {
        if (used[queryIndex]) continue;
        var match = tokenMatch(queryTokens[queryIndex], candidateTokens[candidateIndex], options);
        if (!match) continue;
        used[queryIndex] = true;
        indexes.push(queryIndex);
        visit(
          candidateIndex + 1,
          totalScore + match.score,
          totalDistance + match.distance,
          prefixCount + (match.kind === 'prefix' || match.kind === 'code-prefix' ? 1 : 0),
          fuzzyCount + (match.kind === 'fuzzy' || match.kind === 'transpose' ? 1 : 0),
          indexes
        );
        indexes.pop();
        used[queryIndex] = false;
      }
    }

    visit(0, 0, 0, 0, 0, []);
    return best;
  }

  function intentFor(value) {
    var normalizedValue = normalize(value).replace(/\s+/g, ' ').trim();
    return {
      normalized: normalizedValue,
      compact: normalizedValue.replace(/\s+/g, ''),
      tokens: normalizedValue.split(' ').filter(Boolean),
    };
  }

  function phraseEvidence(intent, match, assignment) {
    var seen = {};
    (match.matchedIndexes || []).forEach(function (index) { seen[index] = true; });
    var consumed = Object.keys(seen).length;
    var prefixCount = assignment
      ? Number(assignment.prefixCount || 0)
      : match.kind === 'prefix' ? consumed : 0;
    var fuzzyCount = assignment
      ? Number(assignment.fuzzyCount || 0)
      : match.kind === 'fuzzy' ? consumed : 0;
    return {
      queryTokenCount: intent.tokens.length,
      consumedTokenCount: consumed,
      unexplainedTokenCount: Math.max(0, intent.tokens.length - consumed),
      exactTokenCount: Math.max(0, consumed - prefixCount - fuzzyCount),
      prefixTokenCount: prefixCount,
      fuzzyTokenCount: fuzzyCount,
      coverageRatio: intent.tokens.length ? consumed / intent.tokens.length : 0,
      distance: Number(match.distance || 0),
    };
  }

  function withPhraseEvidence(intent, match, assignment) {
    match.evidence = phraseEvidence(intent, match, assignment);
    return match;
  }

  function compareMatchEvidence(left, right) {
    if (!left || !right || !left.evidence || !right.evidence) return 0;
    var a = left.evidence;
    var b = right.evidence;
    return b.consumedTokenCount - a.consumedTokenCount ||
      a.unexplainedTokenCount - b.unexplainedTokenCount ||
      b.coverageRatio - a.coverageRatio ||
      b.exactTokenCount - a.exactTokenCount ||
      b.prefixTokenCount - a.prefixTokenCount ||
      a.fuzzyTokenCount - b.fuzzyTokenCount ||
      a.distance - b.distance ||
      right.score - left.score;
  }

  function phraseMatch(intent, phrase, options) {
    var settings = options || {};
    var candidate = normalize(phrase);
    if (!candidate || !intent.normalized) return null;
    var compact = candidate.replace(/\s+/g, '');
    var candidateTokens = candidate.split(' ').filter(Boolean);

    if (intent.normalized === candidate) {
      return withPhraseEvidence(intent, { score: 1800 + candidate.length, kind: 'exact', phrase: phrase, matchedIndexes: intent.tokens.map(function (_, index) { return index; }) });
    }
    if (intent.compact === compact) {
      return withPhraseEvidence(intent, { score: 1750 + compact.length, kind: 'compact-exact', phrase: phrase, matchedIndexes: intent.tokens.map(function (_, index) { return index; }) });
    }
    if ((' ' + intent.normalized + ' ').indexOf(' ' + candidate + ' ') !== -1) {
      var exactIndexes = [];
      var start = intent.normalized.split(' ').indexOf(candidateTokens[0]);
      if (start >= 0) {
        for (var exactIndex = 0; exactIndex < candidateTokens.length; exactIndex += 1) exactIndexes.push(start + exactIndex);
      }
      return withPhraseEvidence(intent, { score: 1600, kind: 'contained-exact', phrase: phrase, matchedIndexes: exactIndexes });
    }
    if (settings.allowContainedCompact && compact.length >= 4 && intent.compact.indexOf(compact) !== -1) {
      return withPhraseEvidence(intent, { score: 1500 + compact.length, kind: 'compact-contained', phrase: phrase, matchedIndexes: [] });
    }

    var assignment = bestTokenAssignment(intent.tokens, candidateTokens, settings);
    if (!assignment) return null;
    var category = assignment.fuzzyCount ? 900 : assignment.prefixCount ? 1200 : 1450;
    return withPhraseEvidence(intent, {
      score: category + assignment.tokenScore + candidate.length - (assignment.distance * 30),
      kind: assignment.fuzzyCount ? 'fuzzy' : assignment.prefixCount ? 'prefix' : 'token-exact',
      phrase: phrase,
      matchedIndexes: assignment.matchedIndexes,
      distance: assignment.distance,
    }, assignment);
  }

  function bestPhraseMatch(intent, phrases, options) {
    return unique(phrases || []).reduce(function (best, phrase) {
      var match = phraseMatch(intent, phrase, options);
      if (!match) return best;
      return !best || compareMatchEvidence(match, best) < 0 ? match : best;
    }, null);
  }

  function compareRankedModelEvidence(left, right) {
    if (left && right && left.match && right.match && left.match.evidence && right.match.evidence) {
      var evidenceOrder = compareMatchEvidence(left.match, right.match);
      if (evidenceOrder) return evidenceOrder;
    }
    return right.score - left.score ||
      right.model.name.length - left.model.name.length ||
      left.model.name.localeCompare(right.model.name) ||
      String(left.model.id || '').localeCompare(String(right.model.id || ''));
  }

  function bestPhraseScore(intent, phrases, minimumPrefixLength) {
    var match = bestPhraseMatch(intent, phrases, { minimumPrefixLength: minimumPrefixLength });
    return match ? match.score : 0;
  }

  var BMW_PLATFORM_SERIES = {
    e81: '1 Series', e82: '1 Series', e87: '1 Series', e88: '1 Series', f20: '1 Series', f21: '1 Series', f40: '1 Series',
    f22: '2 Series', f23: '2 Series', f44: '2 Series', f45: '2 Series', f46: '2 Series', g42: '2 Series', u06: '2 Series',
    e30: '3 Series', e36: '3 Series', e46: '3 Series', e90: '3 Series', e91: '3 Series', e92: '3 Series', e93: '3 Series', f30: '3 Series', f31: '3 Series', f34: '3 Series', f35: '3 Series', g20: '3 Series', g21: '3 Series', g28: '3 Series',
    f32: '4 Series', f33: '4 Series', f36: '4 Series', g22: '4 Series', g23: '4 Series', g26: '4 Series', g82: '4 Series', g83: '4 Series',
    e39: '5 Series', e60: '5 Series', e61: '5 Series', f07: '5 Series', f10: '5 Series', f11: '5 Series', g30: '5 Series', g31: '5 Series', g38: '5 Series', g60: '5 Series', g61: '5 Series',
    e63: '6 Series', e64: '6 Series', f06: '6 Series', f12: '6 Series', f13: '6 Series', g32: '6 Series',
    e38: '7 Series', e65: '7 Series', e66: '7 Series', f01: '7 Series', f02: '7 Series', g11: '7 Series', g12: '7 Series', g70: '7 Series',
  };

  function inferredFamilyName(brand, intent) {
    var canonicalBrand = brand.canonicalName || brand.name;
    var match;
    if (canonicalBrand === 'Mercedes-Benz') {
      match = intent.normalized.match(/(?:^|\s)(eqa|eqb|eqc|gla|glb|glc|gle|glk|gls|cla|cls|slc|slk|cl|gl|ml|sl|[abcegsvx])\s*(?:class|klasse|klass|clase|classe|klasa|sarja)?\s*[1-9][0-9o]{2}[a-z]{0,3}(?:\s|$)/);
      if (match) return match[1].toUpperCase() + '-Class';
    }
    if (canonicalBrand === 'BMW') {
      match = intent.normalized.match(/(?:^|\s)(?:m\s*)?([1-7])[0-9]{2}[a-z]{0,3}(?:\s|$)/);
      if (match) return match[1] + ' Series';
      match = intent.normalized.match(/(?:^|\s)m([1-7])(?:\s|$)/);
      if (match) return match[1] + ' Series';
      for (var platform in BMW_PLATFORM_SERIES) {
        if (Object.prototype.hasOwnProperty.call(BMW_PLATFORM_SERIES, platform) &&
          (' ' + intent.normalized + ' ').indexOf(' ' + platform + ' ') !== -1) {
          return BMW_PLATFORM_SERIES[platform];
        }
      }
    }
    if (canonicalBrand === 'Land Rover' && intent.tokens.some(function (token) {
      return editDistance(token, 'evoque') <= 1;
    })) return 'Range Rover Evoque';
    return null;
  }

  function allBrandPhrases(brand) {
    return unique([brand.name, brand.canonicalName].concat(brand.aliases || []));
  }

  function allModelPhrases(model) {
    return unique([model.name, model.canonicalName].concat(model.aliases || []));
  }

  function strictWholeTokenExtension(parentPhrase, childPhrase) {
    var parentTokens = normalize(parentPhrase).split(' ').filter(Boolean);
    var childTokens = normalize(childPhrase).split(' ').filter(Boolean);
    return childTokens.length > parentTokens.length && parentTokens.every(function (token, index) {
      return childTokens[index] === token;
    });
  }

  function familyAmbiguousModels(selected, rankedModels) {
    if (!selected || !selected.brand || !selected.model) return [];
    var selectedEntry = (rankedModels || []).find(function (entry) {
      return entry.brand.id === selected.brand.id && entry.model.id === selected.model.id;
    });
    var parentPhrase = selectedEntry && selectedEntry.match && selectedEntry.match.phrase;
    if (!parentPhrase) return [];

    var descendants = selected.brand.models.filter(function (model) {
      return model.id !== selected.model.id && allModelPhrases(model).some(function (phrase) {
        return strictWholeTokenExtension(parentPhrase, phrase);
      });
    });
    if (!descendants.length) return [];

    return [selectedEntry].concat(descendants.map(function (model) {
      var phrase = allModelPhrases(model).find(function (candidate) {
        return strictWholeTokenExtension(parentPhrase, candidate);
      });
      return {
        brand: selected.brand,
        model: model,
        score: selectedEntry.score,
        match: {
          score: selectedEntry.score,
          kind: 'family-descendant',
          phrase: phrase,
          matchedIndexes: [],
        },
        brandMatch: selectedEntry.brandMatch,
        modelIntent: selectedEntry.modelIntent,
      };
    }));
  }

  function compactModelRemainderMatches(brand, remainder, allowNumericShortcut) {
    if (!remainder) return false;
    if (allowNumericShortcut && /[0-9]/.test(remainder)) return true;
    return brand.models.some(function (model) {
      return allModelPhrases(model).some(function (phrase) {
        var compact = normalize(phrase).replace(/\s+/g, '');
        return compact.length >= 3 && (remainder === compact || remainder.indexOf(compact) === 0 || compact.indexOf(remainder) === 0);
      });
    });
  }

  function joinedBrandMatch(brand, intent) {
    return allBrandPhrases(brand).reduce(function (best, phrase) {
      var compact = normalize(phrase).replace(/\s+/g, '');
      if (compact.length < 2 || intent.compact.indexOf(compact) !== 0 || intent.compact === compact) return best;
      var remainder = intent.compact.slice(compact.length);
      if (!compactModelRemainderMatches(brand, remainder, compact.length >= 3)) return best;
      var match = {
        score: 1550 + compact.length,
        kind: 'joined-brand',
        phrase: phrase,
        matchedIndexes: [],
        consumedCompact: compact,
      };
      return !best || match.score > best.score ? match : best;
    }, null);
  }

  function modelIntentForBrand(intent, brandEntry) {
    var match = brandEntry && brandEntry.match;
    if (!match) return intent;
    if (match.consumedCompact && intent.compact.indexOf(match.consumedCompact) === 0) {
      return intentFor(intent.compact.slice(match.consumedCompact.length));
    }
    var used = {};
    (match.matchedIndexes || []).forEach(function (index) { used[index] = true; });
    var remaining = intent.tokens.filter(function (_, index) { return !used[index]; });
    if (!remaining.length && brandEntry.brand) {
      var coreMatch = bestPhraseMatch(intent, [brandEntry.brand.name, brandEntry.brand.canonicalName], { minimumPrefixLength: 2 });
      if (coreMatch && coreMatch.matchedIndexes && coreMatch.matchedIndexes.length < intent.tokens.length) {
        var coreUsed = {};
        coreMatch.matchedIndexes.forEach(function (index) { coreUsed[index] = true; });
        remaining = intent.tokens.filter(function (_, index) { return !coreUsed[index]; });
      }
    }
    return intentFor(remaining.join(' '));
  }

  function strongBrandEntries(scoredBrands) {
    if (!scoredBrands.length || scoredBrands[0].score < 850) return [];
    var topScore = scoredBrands[0].score;
    return scoredBrands.filter(function (entry) { return entry.score >= topScore - 35; });
  }

  function directBrandSuggestionMatch(brand, intent) {
    return bestPhraseMatch(intent, [brand.name, brand.canonicalName], {
      minimumPrefixLength: intent.tokens.length === 1 ? 1 : 2,
      allowShortEdit: true,
    });
  }

  function progressiveBrandSuggestions(scoredBrands, intent) {
    if (!intent || !intent.normalized || !scoredBrands.length) return [];
    var oneCharacter = intent.compact.length === 1;
    return scoredBrands.map(function (entry) {
      return {
        brand: entry.brand,
        score: entry.score,
        direct: directBrandSuggestionMatch(entry.brand, intent),
      };
    }).sort(function (left, right) {
      var leftDirect = left.direct ? 1 : 0;
      var rightDirect = right.direct ? 1 : 0;
      var directOrder = rightDirect - leftDirect;
      if (directOrder) return directOrder;

      var leftPopularity = Number(left.brand.popularRank || 999);
      var rightPopularity = Number(right.brand.popularRank || 999);
      if (oneCharacter && leftPopularity !== rightPopularity) return leftPopularity - rightPopularity;

      var scoreOrder = right.score - left.score;
      if (scoreOrder) return scoreOrder;
      if (leftPopularity !== rightPopularity) return leftPopularity - rightPopularity;
      return left.brand.name.localeCompare(right.brand.name);
    }).map(function (entry) { return entry.brand; });
  }

  function shortModelFragmentScore(intent, phrases) {
    if (!intent || intent.tokens.length !== 1 || intent.compact.length < 1 || intent.compact.length > 3) return 0;
    var fragment = intent.compact;
    return unique(phrases || []).reduce(function (best, phrase) {
      var compact = normalize(phrase).replace(/\s+/g, '');
      var position = compact.indexOf(fragment);
      if (position < 0) return best;
      var score = (position === 0 ? 820 : 760) + fragment.length;
      return Math.max(best, score);
    }, 0);
  }

  function partialModelPhraseScore(intent, phrases, options) {
    if (!intent || !intent.tokens.length) return 0;
    var settings = options || {};
    return unique(phrases || []).reduce(function (best, phrase) {
      var candidate = normalize(phrase);
      var candidateTokens = candidate.split(' ').filter(Boolean);
      if (candidateTokens.length <= intent.tokens.length) return best;
      var used = [];
      var bestAssignment = null;

      function visit(queryIndex, score, distance) {
        if (queryIndex >= intent.tokens.length) {
          if (!bestAssignment || score > bestAssignment.score ||
            (score === bestAssignment.score && distance < bestAssignment.distance)) {
            bestAssignment = { score: score, distance: distance };
          }
          return;
        }
        for (var candidateIndex = 0; candidateIndex < candidateTokens.length; candidateIndex += 1) {
          if (used[candidateIndex]) continue;
          var match = tokenMatch(intent.tokens[queryIndex], candidateTokens[candidateIndex], settings);
          if (!match) continue;
          used[candidateIndex] = true;
          visit(queryIndex + 1, score + match.score, distance + match.distance);
          used[candidateIndex] = false;
        }
      }

      visit(0, 0, 0);
      if (!bestAssignment) return best;
      var score = 680 + bestAssignment.score - (bestAssignment.distance * 25) - ((candidateTokens.length - intent.tokens.length) * 10);
      return Math.max(best, score);
    }, 0);
  }

  function familyTokenScore(intent, phrases) {
    if (!intent || !intent.tokens.length) return 0;
    var familyTokens = intent.tokens.filter(function (token) { return token.length >= 4; });
    if (!familyTokens.length) return 0;
    return unique(phrases || []).reduce(function (best, phrase) {
      var candidateTokens = normalize(phrase).split(' ').filter(Boolean);
      var shared = familyTokens.filter(function (token) { return candidateTokens.indexOf(token) !== -1; });
      return shared.length ? Math.max(best, 650 + shared.join('').length) : best;
    }, 0);
  }

  function rankVehicleIntent(tree, query) {
    var intent = intentFor(query);
    var scoredBrands = [];
    var scoredModels = [];

    if (!intent.normalized) {
      return { intent: intent, brands: scoredBrands, scopedBrands: [], models: scoredModels };
    }

    tree.forEach(function (brand) {
      var brandPrefixLength = intent.tokens.length === 1 ? 1 : 2;
      var brandMatch = bestPhraseMatch(intent, allBrandPhrases(brand), {
        minimumPrefixLength: brandPrefixLength,
        allowShortEdit: true,
      });
      var joinedMatch = joinedBrandMatch(brand, intent);
      var brandMatchConsumesWholeQuery = brandMatch && brandMatch.matchedIndexes && brandMatch.matchedIndexes.length === intent.tokens.length;
      if (joinedMatch && (!brandMatch || joinedMatch.score > brandMatch.score || brandMatchConsumesWholeQuery)) brandMatch = joinedMatch;
      if (brandMatch) scoredBrands.push({ brand: brand, score: brandMatch.score, match: brandMatch });
    });

    scoredBrands.sort(function (left, right) {
      return right.score - left.score || Number(left.brand.popularRank || 999) - Number(right.brand.popularRank || 999) || left.brand.name.localeCompare(right.brand.name);
    });
    var scopedBrands = strongBrandEntries(scoredBrands);
    var modelContexts = scopedBrands.length
      ? scopedBrands
      : tree.map(function (brand) { return { brand: brand, score: 0, match: null }; });

    modelContexts.forEach(function (brandEntry) {
      var brand = brandEntry.brand;
      var modelIntent = scopedBrands.length ? modelIntentForBrand(intent, brandEntry) : intent;
      if (!modelIntent.normalized) return;
      var inferred = scopedBrands.length ? inferredFamilyName(brand, intent) : null;
      brand.models.forEach(function (model) {
        var modelMatch = bestPhraseMatch(modelIntent, allModelPhrases(model), {
          minimumPrefixLength: 3,
          allowContainedCompact: true,
          allowShortEdit: Boolean(scopedBrands.length),
          allowNumericEdit: Boolean(scopedBrands.length),
        });
        var modelScore = modelMatch ? modelMatch.score : 0;
        var modelSpecificityBonus = modelMatch && modelMatch.kind === 'contained-exact' &&
          modelMatch.matchedIndexes && modelMatch.matchedIndexes.length > 1
          ? (modelMatch.matchedIndexes.length - 1) * 100
          : 0;
        if (scopedBrands.length) {
          modelScore = Math.max(
            modelScore,
            shortModelFragmentScore(modelIntent, allModelPhrases(model)),
            familyTokenScore(modelIntent, allModelPhrases(model)),
            partialModelPhraseScore(modelIntent, allModelPhrases(model), {
              minimumPrefixLength: 2,
              allowShortEdit: true,
              allowNumericEdit: true,
            })
          );
        }
        if (inferred && model.canonicalName === inferred) modelScore = Math.max(modelScore, 2200);
        if (!modelScore) return;
        scoredModels.push({
          brand: brand,
          model: model,
          score: modelScore + modelSpecificityBonus + Math.min(brandEntry.score, 500),
          match: modelMatch || { score: modelScore, kind: inferred ? 'inferred-family' : 'supporting-signal' },
          brandMatch: brandEntry.match,
          modelIntent: modelIntent,
        });
      });
    });

    scoredModels.sort(compareRankedModelEvidence);
    return { intent: intent, brands: scoredBrands, scopedBrands: scopedBrands, models: scoredModels };
  }

  function rankGlobalModelIntent(tree, intent) {
    var scoredModels = [];
    if (!intent || !intent.normalized) return scoredModels;
    (tree || []).forEach(function (brand) {
      brand.models.forEach(function (model) {
        var modelMatch = bestPhraseMatch(intent, allModelPhrases(model), {
          minimumPrefixLength: 3,
          allowContainedCompact: true,
          allowShortEdit: false,
          allowNumericEdit: false,
        });
        if (!modelMatch) return;
        var specificityBonus = modelMatch.kind === 'contained-exact' &&
          modelMatch.matchedIndexes && modelMatch.matchedIndexes.length > 1
          ? (modelMatch.matchedIndexes.length - 1) * 100
          : 0;
        scoredModels.push({
          brand: brand,
          model: model,
          score: modelMatch.score + specificityBonus,
          match: modelMatch,
          brandMatch: null,
          modelIntent: intent,
        });
      });
    });
    scoredModels.sort(compareRankedModelEvidence);
    return scoredModels;
  }

  function resolveVehicleIntent(tree, query) {
    var ranked = rankVehicleIntent(tree, query);
    return {
      brands: ranked.brands.map(function (entry) { return entry.brand; }),
      models: ranked.models.map(function (entry) { return { brand: entry.brand, model: entry.model }; }),
    };
  }

  var BRANDLESS_EXACT_MATCH_KINDS = {
    exact: true,
    'compact-exact': true,
    'contained-exact': true,
    'compact-contained': true,
    'token-exact': true,
  };

  function dedupeRankedModels(entries) {
    var seen = {};
    return (entries || []).filter(function (entry) {
      if (!entry || !entry.brand || !entry.model) return false;
      var key = entry.brand.id + '|' + entry.model.id;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function plausibleSmartYearToken(token, maximumYear) {
    if (!/^\d{4}$/.test(token)) return false;
    var value = Number(token);
    return value >= 1900 && value <= maximumYear;
  }

  function modelMatchConsumesQuery(intent, entry, maximumYear) {
    if (!intent || !entry || !entry.match) return false;
    var used = {};
    (entry.match.matchedIndexes || []).forEach(function (index) { used[index] = true; });
    var unexplained = (intent.tokens || []).filter(function (_, index) {
      return !used[index];
    }).filter(function (token) {
      return !plausibleSmartYearToken(token, maximumYear);
    });
    if (!unexplained.length && Object.keys(used).length) return true;
    if (entry.match.kind !== 'compact-contained' || !entry.match.phrase) return false;
    var queryCompact = (intent.tokens || []).filter(function (token) {
      return !plausibleSmartYearToken(token, maximumYear);
    }).join('');
    return normalize(entry.match.phrase).replace(/\s+/g, '') === queryCompact;
  }

  function brandlessAlphabeticCore(intent, maximumYear) {
    return (intent.tokens || []).filter(function (token) {
      return !plausibleSmartYearToken(token, maximumYear);
    }).join('').replace(/[^a-z]/g, '');
  }

  function brandlessSmartSelection(ranked, maximumYear) {
    var empty = { brand: null, model: null, ambiguousModels: [], proof: null };
    if (!ranked || ranked.scopedBrands.length) return empty;
    var candidates = dedupeRankedModels(ranked.models).filter(function (entry) {
      return modelMatchConsumesQuery(ranked.intent, entry, maximumYear);
    });
    var exact = candidates.filter(function (entry) {
      return Boolean(BRANDLESS_EXACT_MATCH_KINDS[entry.match.kind]);
    });
    if (exact.length === 1) {
      return { brand: exact[0].brand, model: exact[0].model, ambiguousModels: [], proof: 'exact' };
    }
    if (exact.length > 1) return { brand: null, model: null, ambiguousModels: exact, proof: 'exact' };
    if (!candidates.length) return empty;

    var top = candidates[0];
    var runnerUp = candidates[1];
    var margin = runnerUp ? top.score - runnerUp.score : Infinity;
    var alphabeticLength = brandlessAlphabeticCore(ranked.intent, maximumYear).length;
    var prefixSafe = top.match.kind === 'prefix' && top.score >= 1200 && alphabeticLength >= 3;
    var fuzzySafe = top.match.kind === 'fuzzy' && top.score >= 900 &&
      top.match.distance === 1 && alphabeticLength >= 4;
    if ((prefixSafe || fuzzySafe) && margin >= 80) {
      return {
        brand: top.brand,
        model: top.model,
        ambiguousModels: [],
        proof: prefixSafe ? 'prefix' : 'fuzzy',
      };
    }
    if (prefixSafe || fuzzySafe) {
      return {
        brand: null,
        model: null,
        ambiguousModels: candidates,
        proof: prefixSafe ? 'prefix' : 'fuzzy',
      };
    }
    return empty;
  }

  function selectedSmartVehicle(ranked, maximumYear) {
    if (!ranked) return { brand: null, model: null, ambiguousModels: [], proof: null };
    if (!ranked.scopedBrands.length) return brandlessSmartSelection(ranked, maximumYear);
    if (ranked.scopedBrands.length !== 1) return { brand: null, model: null, ambiguousModels: [], proof: null };
    var brand = ranked.scopedBrands[0].brand;
    var models = ranked.models.filter(function (entry) { return entry.brand.id === brand.id; });
    if (!models.length) return { brand: brand, model: null, ambiguousModels: [], proof: 'brand' };
    var consumingModels = models.filter(function (entry) {
      return modelMatchConsumesQuery(entry.modelIntent, entry, maximumYear);
    });
    var selectionModels = consumingModels.length ? consumingModels : models;
    var top = selectionModels[0];
    var runnerUp = selectionModels[1];
    var hasSafeScore = top.score >= 1450;
    var hasSafeMargin = !runnerUp || top.score - runnerUp.score >= 80;
    return {
      brand: brand,
      model: hasSafeScore && hasSafeMargin ? top.model : null,
      ambiguousModels: [],
      proof: 'brand',
    };
  }

  function modelYearTokenBudget(model, maximumYear) {
    var budget = {};
    if (!model) return budget;
    allModelPhrases(model).forEach(function (phrase) {
      var counts = {};
      intentFor(phrase).tokens.forEach(function (token) {
        if (!/^\d{4}$/.test(token)) return;
        var value = Number(token);
        if (value < 1900 || value > maximumYear) return;
        counts[token] = (counts[token] || 0) + 1;
      });
      Object.keys(counts).forEach(function (token) {
        budget[token] = Math.max(budget[token] || 0, counts[token]);
      });
    });
    return budget;
  }

  function smartYearCandidates(intent, selectedModel, maximumYear) {
    var budget = modelYearTokenBudget(selectedModel, maximumYear);
    var seen = {};
    var years = [];
    (intent.tokens || []).forEach(function (token) {
      if (!/^\d{4}$/.test(token)) return;
      var value = Number(token);
      if (value < 1900 || value > maximumYear) return;
      if (budget[token]) {
        budget[token] -= 1;
        return;
      }
      if (seen[value]) return;
      seen[value] = true;
      years.push(value);
    });
    return years;
  }

  function parseSmartVehicleQuery(tree, query, options) {
    var settings = options || {};
    var currentYear = Number(settings.currentYear || new Date().getFullYear());
    var ranked = rankVehicleIntent(tree || [], query);
    var globalModels = rankGlobalModelIntent(tree || [], ranked.intent);
    var globalRanked = {
      intent: ranked.intent,
      brands: ranked.brands,
      scopedBrands: [],
      models: globalModels,
    };
    var globalSelection = brandlessSmartSelection(globalRanked, currentYear + 1);
    var globalProofCanOverrideBrand = !ranked.scopedBrands.length ||
      globalSelection.proof === 'exact' ||
      globalSelection.proof === 'prefix';
    var hasGlobalSelection = globalProofCanOverrideBrand &&
      Boolean(globalSelection.model || globalSelection.ambiguousModels.length);
    var selected = hasGlobalSelection
      ? globalSelection
      : selectedSmartVehicle(ranked, currentYear + 1);
    var rankedModels = hasGlobalSelection ? globalModels : ranked.models;
    var familyModels = familyAmbiguousModels(selected, rankedModels);
    if (familyModels.length > 1) {
      selected = {
        brand: null,
        model: null,
        ambiguousModels: familyModels,
        proof: 'family',
      };
    }
    var years = smartYearCandidates(ranked.intent, selected.model, currentYear + 1);
    return {
      rawQuery: String(query || ''),
      normalizedQuery: ranked.intent.normalized,
      year: years.length === 1 ? years[0] : null,
      yearCandidates: years,
      ambiguousYear: years.length > 1,
      rankedBrands: ranked.brands,
      suggestedBrands: progressiveBrandSuggestions(ranked.brands, ranked.intent),
      rankedModels: rankedModels,
      ambiguousModels: selected.ambiguousModels || [],
      selectedBrand: selected.brand,
      selectedModel: selected.model,
    };
  }

  function emptySmartIntent(query) {
    return {
      kind: 'empty',
      rawQuery: String(query || ''),
      normalizedQuery: '',
      year: null,
      yearCandidates: [],
      brandMatches: [],
      suggestedBrands: [],
      modelMatches: [],
      selectedBrand: null,
      selectedModel: null,
      periods: [],
      exactPeriod: null,
      destination: null,
      canNavigate: false,
      reason: 'empty-query',
    };
  }

  function smartIntentBase(parser) {
    return {
      kind: 'no-match',
      rawQuery: parser.rawQuery,
      normalizedQuery: parser.normalizedQuery,
      year: parser.year,
      yearCandidates: parser.yearCandidates.slice(),
      brandMatches: parser.rankedBrands.map(function (entry) { return entry.brand; }),
      suggestedBrands: parser.suggestedBrands.slice(),
      modelMatches: (parser.ambiguousModels.length ? parser.ambiguousModels : parser.rankedModels).map(function (entry) {
        return { brand: entry.brand, model: entry.model };
      }),
      selectedBrand: parser.selectedBrand,
      selectedModel: parser.selectedModel,
      periods: parser.selectedModel && Array.isArray(parser.selectedModel.ranges)
        ? parser.selectedModel.ranges.slice()
        : [],
      exactPeriod: null,
      destination: null,
      canNavigate: false,
      reason: 'no-strong-match',
    };
  }

  function hasSmartCustomerPeriodTree(tree) {
    return Array.isArray(tree) && tree.length > 0 && tree.every(function (brand) {
      return brand && Array.isArray(brand.models) && brand.models.length > 0 && brand.models.every(function (model) {
        return model && Array.isArray(model.ranges) && model.ranges.length > 0 && model.ranges.every(function (range) {
          return range && range.isCustomerPeriod === true;
        });
      });
    });
  }

  function smartDestinationFor(range, options) {
    var settings = options || {};
    var destination = destinationFor(range, settings.localeRoot || '');
    if (!destination || !destination.productHandle || !destination.variantId) return null;
    return {
      productHandle: destination.productHandle,
      variantId: destination.variantId,
      url: preserveNavigationBypass(destination.url, settings.currentSearch || ''),
    };
  }

  function resolveSmartVehicleIntent(tree, query, options) {
    var parser = parseSmartVehicleQuery(tree || [], query, options);
    if (!parser.normalizedQuery) return emptySmartIntent(query);

    var result = smartIntentBase(parser);
    if (parser.ambiguousYear) {
      result.kind = 'ambiguous';
      result.reason = 'multiple-years';
      return result;
    }
    if (!parser.selectedBrand) {
      if (parser.ambiguousModels.length) {
        result.kind = 'ambiguous';
        result.reason = 'multiple-models';
      }
      return result;
    }

    if (!parser.selectedModel) {
      if (parser.rankedModels.length || parser.year != null) {
        result.kind = 'ambiguous';
        result.reason = 'multiple-models';
      } else {
        result.kind = 'brand-only';
        result.reason = 'brand-needs-model';
      }
      return result;
    }

    if (!hasSmartCustomerPeriodTree(tree)) {
      result.kind = 'no-match';
      result.reason = 'customer-period-catalog-invalid';
      return result;
    }

    if (parser.year != null) {
      var matchingPeriods = result.periods.filter(function (period) {
        return parser.year >= period.y0 && parser.year <= period.y1;
      });
      if (!matchingPeriods.length) {
        result.kind = 'unsupported-year';
        result.reason = 'year-outside-periods';
        return result;
      }
      if (matchingPeriods.length > 1) {
        result.kind = 'ambiguous';
        result.reason = 'multiple-periods';
        return result;
      }

      var exactDestination = smartDestinationFor(matchingPeriods[0], options);
      if (!exactDestination) {
        result.kind = 'ambiguous';
        result.reason = 'period-has-no-safe-destination';
        return result;
      }
      result.kind = 'exact-fit';
      result.exactPeriod = matchingPeriods[0];
      result.destination = exactDestination;
      result.canNavigate = true;
      result.reason = 'exact-period-match';
      return result;
    }

    var single = singleVariantSelection(parser.selectedModel, options && options.localeRoot);
    if (single) {
      result.kind = 'proven-single-variant';
      result.exactPeriod = single.range;
      result.destination = {
        productHandle: single.destination.productHandle,
        variantId: single.destination.variantId,
        url: preserveNavigationBypass(single.destination.url, options && options.currentSearch),
      };
      result.canNavigate = true;
      result.reason = 'single-variant-throughout';
      return result;
    }

    result.kind = 'model-needs-year';
    result.reason = 'model-needs-year';
    return result;
  }

  function activateSmartVehicleIntent(intent, assign) {
    if (!intent || intent.canNavigate !== true || !intent.destination || !intent.destination.url) return false;
    if (intent.kind !== 'exact-fit' && intent.kind !== 'proven-single-variant') return false;
    if (typeof assign !== 'function') return false;
    assign(intent.destination.url);
    return true;
  }

  function createSmartInputController(options) {
    var settings = options || {};
    var input = settings.input;
    var submitControl = settings.submit;
    var isComposing = false;
    var currentIntent = null;

    function refresh() {
      currentIntent = settings.resolve(String(input.value || ''));
      if (typeof settings.render === 'function') settings.render(currentIntent);
      return currentIntent;
    }

    function confirm() {
      if (!String(input.value || '').trim() && typeof settings.onEmptyConfirm === 'function') {
        return settings.onEmptyConfirm() === true;
      }
      var intent = refresh();
      if (typeof settings.activate !== 'function') return false;
      return settings.activate(intent) === true;
    }

    function onInput(event) {
      if (isComposing || event && event.isComposing) return;
      refresh();
    }

    function onCompositionStart() {
      isComposing = true;
    }

    function onCompositionEnd() {
      isComposing = false;
      refresh();
    }

    function onKeydown(event) {
      if (!event || isComposing || event.isComposing || event.keyCode === 229) return;
      if (event.key === 'Enter') {
        event.preventDefault();
        confirm();
        return;
      }
      if (event.key === 'Escape' && typeof settings.onEscape === 'function') {
        if (settings.onEscape(event, currentIntent) !== false) event.preventDefault();
        return;
      }
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Home' || event.key === 'End') &&
        typeof settings.onNavigate === 'function') {
        if (settings.onNavigate(event, currentIntent) !== false) event.preventDefault();
      }
    }

    function onConfirm(event) {
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      confirm();
    }

    input.addEventListener('input', onInput);
    input.addEventListener('compositionstart', onCompositionStart);
    input.addEventListener('compositionend', onCompositionEnd);
    input.addEventListener('keydown', onKeydown);
    if (submitControl && typeof submitControl.addEventListener === 'function') {
      submitControl.addEventListener('click', onConfirm);
      submitControl.addEventListener('submit', onConfirm);
    }

    return {
      refresh: refresh,
      submit: confirm,
      getIntent: function () { return currentIntent; },
      destroy: function () {
        input.removeEventListener('input', onInput);
        input.removeEventListener('compositionstart', onCompositionStart);
        input.removeEventListener('compositionend', onCompositionEnd);
        input.removeEventListener('keydown', onKeydown);
        if (submitControl && typeof submitControl.removeEventListener === 'function') {
          submitControl.removeEventListener('click', onConfirm);
          submitControl.removeEventListener('submit', onConfirm);
        }
      },
    };
  }

  function filterTree(tree, query) {
    return resolveVehicleIntent(tree, query);
  }

  function desktopPanelMode(state) {
    var value = state || {};
    if (String(value.query || '').trim()) return 'matches';
    if (value.brandId && value.modelId) return 'ranges';
    if (value.brandId) return 'models';
    return 'closed';
  }

  function desktopMatches(tree, query) {
    return resolveVehicleIntent(tree || [], query);
  }

  function desktopBrandGrid(tree) {
    var brands = Array.isArray(tree) ? tree.slice() : [];
    var popular = brands.filter(function (brand) { return brand.popularRank; }).sort(function (left, right) {
      return Number(left.popularRank) - Number(right.popularRank);
    });
    var popularIds = {};
    popular.forEach(function (brand) { popularIds[brand.id] = true; });
    return popular.concat(brands.filter(function (brand) { return !popularIds[brand.id]; }));
  }

  function arrowIcon() {
    return '<svg class="coff__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
  }

  function backIcon() {
    return '<svg class="coff__back-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
  }

  function brandLogoAttributes(brand, options) {
    var settings = options || {};
    var visible = settings.visible !== false;
    var popular = Boolean(brand && brand.popularRank);
    return ' loading="' + (visible ? 'eager' : 'lazy') + '" decoding="async"' +
      (popular && visible ? ' fetchpriority="high"' : '');
  }

  function renderBrandChoice(brand, options) {
    var settings = options || {};
    var extra = Boolean(settings.extra);
    var visible = !extra || Boolean(settings.expanded);
    var extraAttributes = extra
      ? ' data-coff-extra-brand aria-hidden="' + (settings.expanded ? 'false' : 'true') + '"' + (settings.expanded ? '' : ' hidden') + ' style="--coff-stagger: ' + Number(settings.stagger || 0) + '"'
      : '';
    return '<button type="button" class="coff__choice' + (extra ? ' coff__choice--extra' : '') + '" data-coff-action="pick-brand" data-brand-id="' + escapeHTML(brand.id) + '"' + extraAttributes + '>' +
      '<span class="coff__logo"><img src="' + escapeHTML(brand.logo) + '" alt="" width="44" height="44"' + brandLogoAttributes(brand, { visible: visible }) + '></span>' +
      '<span class="coff__choice-label">' + escapeHTML(brand.name) + '</span>' +
      arrowIcon() +
      '</button>';
  }

  function renderModelChoice(brand, model) {
    return '<button type="button" class="coff__choice" data-coff-action="pick-model" data-brand-id="' + escapeHTML(brand.id) + '" data-model-id="' + escapeHTML(model.id) + '">' +
      '<span class="coff__choice-label">' + escapeHTML(model.name) + '</span>' +
      arrowIcon() +
      '</button>';
  }

  function renderVehicleIdentity(brand, model, options) {
    var settings = options || {};
    var summary = Boolean(settings.summary);
    var outerTag = summary ? 'div' : 'span';
    var outerClass = summary ? 'coff__vehicle-summary' : 'coff__vehicle-identity';
    var logoClass = summary ? 'coff__vehicle-logo' : 'coff__choice-logo';
    return '<' + outerTag + ' class="' + outerClass + '">' +
      '<span class="' + logoClass + '"><img src="' + escapeHTML(brand.logo) + '" alt="" width="44" height="44"' + brandLogoAttributes(brand, { visible: true }) + '></span>' +
      '<span class="coff__vehicle-copy"><strong class="coff__vehicle-brand">' + escapeHTML(brand.name) + '</strong> ' +
      '<span class="coff__vehicle-model">' + escapeHTML(model.name) + '</span></span>' +
      '</' + outerTag + '>';
  }

  function renderAmbiguousModelChoice(brand, model, options) {
    var settings = options || {};
    return '<button type="button" class="coff__choice" data-coff-action="pick-model" data-brand-id="' + escapeHTML(brand.id) + '" data-model-id="' + escapeHTML(model.id) + '">' +
      (settings.showVehicleLogo
        ? renderVehicleIdentity(brand, model)
        : '<span class="coff__choice-label">' + escapeHTML(brand.name + ' · ' + model.name) + '</span>') +
      arrowIcon() +
      '</button>';
  }

  function renderRangeChoice(range, copy) {
    if (range.isCustomerPeriod) {
      return '<button type="button" class="coff__choice coff__choice--range" data-coff-action="pick-range" data-range-id="' + escapeHTML(range.id) + '">' +
        '<span class="coff__choice-label">' + escapeHTML(range.label) + '</span>' +
        arrowIcon() +
        '</button>';
    }
    if (!range.preferredVariantId && range.choices && range.choices.length > 1) {
      return range.choices.map(function (choice) {
        return '<button type="button" class="coff__choice coff__choice--range" data-coff-action="pick-range" data-range-id="' + escapeHTML(range.id) + '" data-variant-id="' + escapeHTML(choice.variantId) + '">' +
          '<span class="coff__choice-label">' + escapeHTML(range.label) + '</span>' +
          '<span class="coff__choice-meta">' + escapeHTML(choice.label) + '</span>' +
          arrowIcon() +
          '</button>';
      }).join('');
    }
    var secondary = range.systemLabel || (range.choices && range.choices[0] && range.choices[0].label) || '';
    return '<button type="button" class="coff__choice coff__choice--range" data-coff-action="pick-range" data-range-id="' + escapeHTML(range.id) + '">' +
      '<span class="coff__choice-label">' + escapeHTML(range.label) + '</span>' +
      '<span class="coff__choice-meta">' + escapeHTML(secondary) + '</span>' +
      arrowIcon() +
      '</button>';
  }

  function renderDesktopRangeChoice(range) {
    if (range.isCustomerPeriod) {
      return '<button type="button" class="cofr__panel-choice" role="option" data-cofr-action="range" data-range-id="' + escapeHTML(range.id) + '">' +
        '<span class="cofr__panel-label">' + escapeHTML(range.label) + '</span>' +
        arrowIcon() + '</button>';
    }
    if (!range.preferredVariantId && range.choices && range.choices.length > 1) {
      return range.choices.map(function (choice) {
        return '<button type="button" class="cofr__panel-choice" role="option" data-cofr-action="range" data-range-id="' + escapeHTML(range.id) + '" data-variant-id="' + escapeHTML(choice.variantId) + '">' +
          '<span class="cofr__panel-label">' + escapeHTML(range.label) + '</span>' +
          '<span class="cofr__panel-meta">' + escapeHTML(choice.label) + '</span>' +
          arrowIcon() + '</button>';
      }).join('');
    }
    var secondary = range.systemLabel || (range.choices && range.choices[0] && range.choices[0].label) || '';
    return '<button type="button" class="cofr__panel-choice" role="option" data-cofr-action="range" data-range-id="' + escapeHTML(range.id) + '">' +
      '<span class="cofr__panel-label">' + escapeHTML(range.label) + '</span>' +
      (secondary ? '<span class="cofr__panel-meta">' + escapeHTML(secondary) + '</span>' : '') +
      arrowIcon() + '</button>';
  }

  function desktopSmartChoice(action, label, attributes, meta) {
    return '<button type="button" class="cofr__panel-choice" role="option" data-cofr-action="' + escapeHTML(action) + '" ' + (attributes || '') + '>' +
      '<span class="cofr__panel-label">' + escapeHTML(label) + '</span>' +
      (meta ? '<span class="cofr__panel-meta">' + escapeHTML(meta) + '</span>' : '') +
      arrowIcon() + '</button>';
  }

  function renderDesktopSmartIntent(intent, copy) {
    if (!intent || intent.kind === 'empty') return '';
    var labels = copy || {};
    if (intent.kind === 'brand-only' && intent.selectedBrand) {
      return intent.selectedBrand.models.map(function (model) {
        return desktopSmartChoice(
          'model',
          model.name,
          'data-brand-id="' + escapeHTML(intent.selectedBrand.id) + '" data-model-id="' + escapeHTML(model.id) + '"',
          ''
        );
      }).join('');
    }
    if (intent.kind === 'model-needs-year' || intent.kind === 'unsupported-year' ||
      (intent.kind === 'ambiguous' && intent.selectedModel && intent.periods.length)) {
      return intent.periods.map(renderDesktopRangeChoice).join('');
    }
    if (intent.kind === 'exact-fit' || intent.kind === 'proven-single-variant') {
      var exactLabel = labels.open_product || labels.exact_match || 'Open matching product';
      var exactMeta = [
        intent.selectedBrand && intent.selectedBrand.name,
        intent.selectedModel && intent.selectedModel.name,
        intent.exactPeriod && intent.exactPeriod.label,
      ].filter(Boolean).join(' · ');
      return desktopSmartChoice('smart-destination', exactLabel, 'data-smart-destination="true"', exactMeta);
    }
    if (intent.kind === 'ambiguous') {
      var seen = {};
      return intent.modelMatches.filter(function (match) {
        var key = match.brand.id + '::' + match.model.id;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      }).slice(0, 18).map(function (match) {
        return desktopSmartChoice(
          'model',
          match.brand.name + ' · ' + match.model.name,
          'data-brand-id="' + escapeHTML(match.brand.id) + '" data-model-id="' + escapeHTML(match.model.id) + '"',
          ''
        );
      }).join('');
    }
    if (intent.kind === 'no-match' && intent.suggestedBrands && intent.suggestedBrands.length) {
      return intent.suggestedBrands.slice(0, 7).map(function (brand) {
        return desktopSmartChoice(
          'brand',
          brand.name,
          'data-brand-id="' + escapeHTML(brand.id) + '"',
          ''
        );
      }).join('');
    }
    return '';
  }

  function renderMobileSmartIntent(intent, copy, options) {
    if (!intent || intent.kind === 'empty') return '';
    var labels = copy || {};
    var settings = options || {};
    if (intent.kind === 'exact-fit' || intent.kind === 'proven-single-variant') {
      var label = labels.open_product || labels.exact_match || 'Open matching product';
      var meta = [
        intent.selectedBrand && intent.selectedBrand.name,
        intent.selectedModel && intent.selectedModel.name,
        intent.exactPeriod && intent.exactPeriod.label,
      ].filter(Boolean).join(' · ');
      return '<button type="button" class="coff__choice coff__choice--range" data-coff-action="smart-destination">' +
        (settings.showVehicleLogo && intent.selectedBrand && intent.selectedModel
          ? renderVehicleIdentity(intent.selectedBrand, intent.selectedModel)
          : '<span class="coff__choice-label">' + escapeHTML(label) + '</span>' +
            (meta ? '<span class="coff__choice-meta">' + escapeHTML(meta) + '</span>' : '')) +
        arrowIcon() + '</button>';
    }
    if (intent.kind === 'ambiguous') {
      var seen = {};
      return intent.modelMatches.filter(function (match) {
        var key = match.brand.id + '::' + match.model.id;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      }).slice(0, 32).map(function (match) {
        return renderAmbiguousModelChoice(match.brand, match.model, settings);
      }).join('');
    }
    if (intent.kind === 'no-match' && intent.suggestedBrands && intent.suggestedBrands.length) {
      return intent.suggestedBrands.slice(0, 7).map(function (brand) {
        return renderBrandChoice(brand);
      }).join('');
    }
    return '';
  }

  function createTypewriter(input, examples, options) {
    var settings = options || {};
    var values = Array.isArray(examples) && examples.length ? examples : ['BMW 3 Series'];
    var reducedMotion = Boolean(settings.reducedMotion);
    var setTimer = settings.setTimeout || global.setTimeout;
    var clearTimer = settings.clearTimeout || global.clearTimeout;
    var typingDelay = Number(settings.typingDelay || 82);
    var holdDelay = Number(settings.holdDelay || 1600);
    var deletingDelay = Number(settings.deletingDelay || 42);
    var betweenDelay = Number(settings.betweenDelay || 320);
    var timer = null;
    var running = false;
    var exampleIndex = 0;
    var characterIndex = 0;
    var phase = 'typing';

    function schedule(delay) {
      if (!running || timer != null || !setTimer) return;
      timer = setTimer(tick, delay);
    }

    function tick() {
      timer = null;
      if (!running) return;
      var example = values[exampleIndex];
      if (phase === 'typing') {
        characterIndex += 1;
        input.placeholder = example.slice(0, characterIndex);
        if (characterIndex >= example.length) {
          characterIndex = example.length;
          phase = 'holding';
          schedule(holdDelay);
          return;
        }
        schedule(typingDelay + ((characterIndex % 3) * 8));
      } else if (phase === 'holding') {
        phase = 'deleting';
        schedule(deletingDelay);
      } else {
        characterIndex -= 1;
        input.placeholder = example.slice(0, Math.max(0, characterIndex));
        if (characterIndex <= 0) {
          characterIndex = 0;
          exampleIndex = (exampleIndex + 1) % values.length;
          phase = 'typing';
          schedule(betweenDelay);
          return;
        }
        schedule(deletingDelay);
      }
    }

    function stop() {
      if (timer != null && clearTimer) clearTimer(timer);
      timer = null;
      running = false;
    }

    function start() {
      if (reducedMotion || !setTimer) {
        stop();
        input.placeholder = values[0];
        return;
      }
      if (running) return;
      running = true;
      schedule(characterIndex ? typingDelay : betweenDelay);
    }

    return {
      start: start,
      stop: stop,
      tick: tick,
      isRunning: function () { return running; },
    };
  }

  function createTypewriterActivity(typewriter, predicates) {
    var checks = predicates || {};
    var lastActive = null;

    function passes(check, fallback) {
      return typeof check === 'function' ? Boolean(check()) : fallback;
    }

    function sync() {
      var active = passes(checks.surfaceVisible, true) &&
        passes(checks.intersecting, true) &&
        passes(checks.pageVisible, true) &&
        passes(checks.inputIdle, true);
      if (active === lastActive) return active;
      lastActive = active;
      if (active) typewriter.start();
      else typewriter.stop();
      return active;
    }

    return { sync: sync };
  }

  function finderSurfaceVisible(host, ownModal, pageModal) {
    function modalOpen(modal) {
      if (!modal || modal.hidden) return false;
      return !modal.getAttribute || modal.getAttribute('aria-hidden') !== 'true';
    }

    if (!host || host.hidden) return false;
    if (ownModal && !modalOpen(ownModal)) return false;
    if (!ownModal && modalOpen(pageModal)) return false;
    if (host.closest && host.closest('[hidden], [aria-hidden="true"]')) return false;
    return true;
  }

  function trapModalTabKey(event, modal) {
    if (!event || event.key !== 'Tab' || !modal || typeof modal.querySelectorAll !== 'function') return false;
    var controls = Array.prototype.slice.call(modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (control) {
      if (!control || control.disabled || control.hidden) return false;
      if (control.getAttribute && control.getAttribute('aria-hidden') === 'true') return false;
      return !control.getClientRects || control.getClientRects().length > 0;
    });
    if (!controls.length) return false;
    var documentRef = modal.ownerDocument || global.document;
    var active = documentRef && documentRef.activeElement;
    var target = null;
    if (event.shiftKey && active === controls[0]) target = controls[controls.length - 1];
    else if (!event.shiftKey && active === controls[controls.length - 1]) target = controls[0];
    if (!target) return false;
    if (event.preventDefault) event.preventDefault();
    try { target.focus({ preventScroll: true }); }
    catch (error) { target.focus(); }
    return true;
  }

  function elementInViewport(element, viewWindow) {
    if (!element || typeof element.getBoundingClientRect !== 'function') return false;
    var viewport = viewWindow || global;
    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < Number(viewport.innerHeight || 0) &&
      rect.left < Number(viewport.innerWidth || 0);
  }

  function setBrandListExpanded(view, expanded, options) {
    var settings = options || {};
    var list = view && view.querySelector
      ? view.querySelector('[data-coff-brand-list]')
      : null;
    var toggle = view && view.querySelector
      ? view.querySelector('[data-coff-action="toggle-brands"]')
      : null;
    var count = view && view.querySelector
      ? view.querySelector('[data-coff-brand-count]')
      : null;
    var label = view && view.querySelector
      ? view.querySelector('[data-coff-brand-label]')
      : null;
    if (!list) return false;

    var extras = Array.prototype.slice.call(
      list.querySelectorAll ? list.querySelectorAll('[data-coff-extra-brand]') : []
    );
    var total = Number(settings.total || (Number(settings.popular || 7) + extras.length));
    var popular = Number(settings.popular || Math.max(0, total - extras.length));
    var requestFrame = settings.requestFrame || global.requestAnimationFrame || function (callback) {
      return global.setTimeout(callback, 16);
    };
    var setTimer = settings.setTimeout || global.setTimeout;
    var clearTimer = settings.clearTimeout || global.clearTimeout;

    if (list.__coffResizeTimer != null && clearTimer) {
      clearTimer(list.__coffResizeTimer);
      list.__coffResizeTimer = null;
    }
    var startHeight = list.getBoundingClientRect ? list.getBoundingClientRect().height : 0;
    if (list.style) {
      list.style.height = startHeight + 'px';
      list.style.overflow = 'hidden';
    }

    extras.forEach(function (entry) {
      entry.hidden = !expanded;
      if (entry.setAttribute) entry.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    });
    if (list.classList) {
      if (expanded) list.classList.add('is-expanded');
      else list.classList.remove('is-expanded');
    }
    if (toggle && toggle.setAttribute) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? settings.showLessLabel : settings.showAllLabel;
    }
    if (count) count.textContent = (expanded ? total : popular) + ' / ' + total;
    if (label) label.textContent = expanded ? settings.allLabel : settings.popularLabel;

    if (settings.reducedMotion || !startHeight || !list.getBoundingClientRect) {
      if (list.style) {
        list.style.height = '';
        list.style.overflow = '';
      }
      return true;
    }

    if (list.style) list.style.height = '';
    var targetHeight = list.getBoundingClientRect().height;
    list.style.height = startHeight + 'px';
    if (list.classList) list.classList.add('is-resizing');
    void list.offsetHeight;
    requestFrame(function () {
      list.style.height = targetHeight + 'px';
    });

    function cleanup() {
      if (list.classList) list.classList.remove('is-resizing');
      if (list.style) {
        list.style.height = '';
        list.style.overflow = '';
      }
      list.__coffResizeTimer = null;
    }
    if (setTimer) list.__coffResizeTimer = setTimer(cleanup, 520);
    return true;
  }

  function activationIsKeyboard(event, lastInteraction) {
    if (event && Number(event.detail) > 0) return false;
    return lastInteraction !== 'pointer';
  }

  function finderUiText(language, total) {
    var code = String(language || 'en').toLowerCase().split('-')[0];
    if (code === 'nb' || code === 'nn') code = 'no';
    var labels = {
      de: { found: '{count} Marken gefunden', more: 'Mehr anzeigen', less: 'Weniger anzeigen' },
      es: { found: '{count} marcas encontradas', more: 'Mostrar más', less: 'Mostrar menos' },
      fr: { found: '{count} marques trouvées', more: 'Afficher plus', less: 'Afficher moins' },
      it: { found: '{count} marchi trovati', more: 'Mostra altro', less: 'Mostra meno' },
      pl: { found: 'Znaleziono {count} marki', more: 'Pokaż więcej', less: 'Pokaż mniej' },
      sv: { found: '{count} märken hittades', more: 'Visa fler', less: 'Visa färre' },
      da: { found: '{count} mærker fundet', more: 'Vis flere', less: 'Vis færre' },
      fi: { found: '{count} merkkiä löytyi', more: 'Näytä lisää', less: 'Näytä vähemmän' },
      no: { found: '{count} merker funnet', more: 'Vis flere', less: 'Vis færre' },
      nl: { found: '{count} merken gevonden', more: 'Toon meer', less: 'Toon minder' },
      en: { found: '{count} brands found', more: 'Show more', less: 'Show less' },
    };
    var selected = labels[code] || labels.en;
    return {
      found: selected.found.replace('{count}', String(total)),
      more: selected.more,
      less: selected.less,
    };
  }

  function lockStepTransition(view) {
    if (!view || !view.style || typeof view.getBoundingClientRect !== 'function') return 0;
    var height = Math.ceil(Number(view.getBoundingClientRect().height || 0));
    if (!height) return 0;
    view.style.minHeight = height + 'px';
    if (view.classList) view.classList.add('is-step-transitioning');
    return height;
  }

  function releaseStepTransition(view) {
    if (!view) return;
    if (view.style) {
      view.style.minHeight = '';
      view.style.paddingTop = '';
      view.style.paddingBottom = '';
    }
    if (view.classList) view.classList.remove('is-step-transitioning');
  }

  function captureStepPosition(host, options) {
    var settings = options || {};
    var viewWindow = settings.window || global;
    var control = settings.control;
    var modal = host && host.closest ? host.closest('.co-vehicle-modal__dialog') : null;
    if (modal) {
      var modalRect = typeof modal.getBoundingClientRect === 'function'
        ? modal.getBoundingClientRect()
        : { top: 0 };
      var controlRect = control && typeof control.getBoundingClientRect === 'function'
        ? control.getBoundingClientRect()
        : null;
      return {
        element: modal,
        top: Number(modal.scrollTop || 0),
        anchorTop: controlRect ? Number(controlRect.top || 0) - Number(modalRect.top || 0) : null,
        window: null,
      };
    }
    var pageControlRect = control && typeof control.getBoundingClientRect === 'function'
      ? control.getBoundingClientRect()
      : null;
    return {
      element: null,
      top: Number(viewWindow.scrollY == null ? viewWindow.pageYOffset || 0 : viewWindow.scrollY),
      anchorTop: pageControlRect ? Number(pageControlRect.top || 0) : null,
      window: viewWindow,
    };
  }

  function applyStepAnchor(view, position) {
    if (!view || !view.style || typeof view.getBoundingClientRect !== 'function' ||
      !position || Number(position.top || 0) <= 1 || position.anchorTop == null) return 0;
    var viewRect = view.getBoundingClientRect();
    var elementRect = null;
    var currentViewTop;
    if (position.element && typeof position.element.getBoundingClientRect === 'function') {
      elementRect = position.element.getBoundingClientRect();
      currentViewTop = Number(viewRect.top || 0) - Number(elementRect.top || 0);
    } else {
      currentViewTop = Number(viewRect.top || 0);
    }
    var firstChoice = typeof view.querySelector === 'function'
      ? view.querySelector('[data-coff-action="pick-model"], [data-coff-action="pick-range"], [data-coff-action="pick-brand"]')
      : null;
    var firstChoiceRect = firstChoice && typeof firstChoice.getBoundingClientRect === 'function'
      ? firstChoice.getBoundingClientRect()
      : null;
    var currentAnchorTop = firstChoiceRect
      ? Number(firstChoiceRect.top || 0) - (elementRect ? Number(elementRect.top || 0) : 0)
      : currentViewTop;
    var reserve = Math.max(0, Math.ceil(Number(position.anchorTop || 0) - currentAnchorTop));
    view.style.paddingTop = reserve ? reserve + 'px' : '';

    var lockedMinHeight = view.style.minHeight;
    view.style.minHeight = '';
    view.style.paddingBottom = '';
    var naturalHeight = Math.ceil(Number(view.getBoundingClientRect().height || 0));
    var viewportHeight = position.element
      ? Number(position.element.clientHeight || 0)
      : Number(position.window && position.window.innerHeight || 0);
    var contentTop = position.element
      ? currentViewTop + Number(position.element.scrollTop || 0)
      : currentViewTop + Number(position.window && (position.window.scrollY == null
        ? position.window.pageYOffset || 0
        : position.window.scrollY) || 0);
    var requiredHeight = Math.max(0, Number(position.top || 0) + viewportHeight - contentTop);
    var bottomReserve = Math.max(0, Math.ceil(requiredHeight - naturalHeight));
    view.style.paddingBottom = bottomReserve ? bottomReserve + 'px' : '';
    view.style.minHeight = lockedMinHeight;
    return reserve;
  }

  function restoreStepPosition(position, behavior) {
    if (!position) return false;
    var target = Number(position.top || 0);
    var scrollBehavior = behavior || 'instant';
    if (position.element) {
      if (Math.abs(Number(position.element.scrollTop || 0) - target) <= 0.5) return true;
      if (typeof position.element.scrollTo === 'function') {
        position.element.scrollTo({ top: target, behavior: scrollBehavior });
      } else {
        position.element.scrollTop = target;
      }
      return true;
    }
    if (!position.window || typeof position.window.scrollTo !== 'function') return false;
    var current = Number(position.window.scrollY == null
      ? position.window.pageYOffset || 0
      : position.window.scrollY);
    if (Math.abs(current - target) <= 0.5) return true;
    position.window.scrollTo({ top: target, behavior: scrollBehavior });
    return true;
  }

  function forwardStepPosition(view, position) {
    if (!view || !position || !view.parentElement ||
      typeof view.parentElement.querySelector !== 'function') return position;
    var heading = view.parentElement.querySelector('[data-coff-heading]');
    if (!heading || typeof heading.getBoundingClientRect !== 'function') return position;
    var headingRect = heading.getBoundingClientRect();
    if (position.element) {
      if (typeof position.element.getBoundingClientRect !== 'function') return position;
      var elementRect = position.element.getBoundingClientRect();
      var headingContentTop = Number(headingRect.top || 0) - Number(elementRect.top || 0) +
        Number(position.element.scrollTop || 0);
      return {
        element: position.element,
        top: Math.max(0, Math.round(headingContentTop - 184)),
        anchorTop: null,
        window: null,
      };
    }
    if (!position.window) return position;
    var currentTop = Number(position.window.scrollY == null
      ? position.window.pageYOffset || 0
      : position.window.scrollY);
    var headingDocumentTop = Number(headingRect.top || 0) + currentTop;
    return {
      element: null,
      top: Math.max(0, Math.round(headingDocumentTop - 92)),
      anchorTop: null,
      window: position.window,
    };
  }

  function clampSettledStepPosition(view, position) {
    if (!view || !position || !view.parentElement ||
      typeof view.parentElement.querySelector !== 'function') return position;
    var heading = view.parentElement.querySelector('[data-coff-heading]');
    if (!heading || typeof heading.getBoundingClientRect !== 'function') return position;
    var headingRect = heading.getBoundingClientRect();
    var maximumTop;
    if (position.element) {
      if (typeof position.element.getBoundingClientRect !== 'function') return position;
      var elementRect = position.element.getBoundingClientRect();
      var headingContentTop = Number(headingRect.top || 0) - Number(elementRect.top || 0) +
        Number(position.element.scrollTop || 0);
      maximumTop = Math.max(0, Math.floor(headingContentTop - 72));
    } else {
      if (!position.window) return position;
      var currentTop = Number(position.window.scrollY == null
        ? position.window.pageYOffset || 0
        : position.window.scrollY);
      var headingDocumentTop = Number(headingRect.top || 0) + currentTop;
      maximumTop = Math.max(0, Math.floor(headingDocumentTop - 84));
    }
    var requestedTop = Number(position.top || 0);
    if (requestedTop <= maximumTop) return position;
    return {
      element: position.element,
      top: maximumTop,
      anchorTop: position.anchorTop,
      window: position.window,
    };
  }

  function settleStepTransition(view, position, options) {
    var settings = options || {};
    var requestFrame = settings.requestAnimationFrame || global.requestAnimationFrame || function (callback) {
      return global.setTimeout(callback, 16);
    };
    var mode = settings.mode || 'restore';
    var settledPosition = position;
    requestFrame(function () {
      if (view && view.style) {
        view.style.minHeight = '';
        view.style.paddingTop = '';
        view.style.paddingBottom = '';
      }
      if (view) void view.offsetHeight;
      if (settings.desktop && mode === 'forward') {
        if (view && view.classList) view.classList.remove('is-step-transitioning');
        return;
      }
      settledPosition = mode === 'forward'
        ? forwardStepPosition(view, position)
        : position;
      var behavior = settings.reducedMotion ? 'instant' : 'smooth';
      restoreStepPosition(settledPosition, behavior);
      requestFrame(function () {
        if (view && view.classList) view.classList.remove('is-step-transitioning');
        if (view) void view.offsetHeight;
        if (settings.reducedMotion) restoreStepPosition(settledPosition, 'instant');
      });
    });
  }

  function settleListResizePosition(position, options) {
    var settings = options || {};
    var requestFrame = settings.requestAnimationFrame || global.requestAnimationFrame || function (callback) {
      return global.setTimeout(callback, 16);
    };
    var setTimer = settings.setTimeout || global.setTimeout;
    restoreStepPosition(position);
    requestFrame(function () {
      restoreStepPosition(position);
      requestFrame(function () {
        restoreStepPosition(position);
      });
    });
    if (setTimer) {
      setTimer(function () {
        restoreStepPosition(position);
      }, 540);
    }
  }

  function shopifyLocaleRoot() {
    var root = global.Shopify && global.Shopify.routes && global.Shopify.routes.root;
    if (root && root !== '/') return normalizeRoot(root);
    if (global.location && global.location.pathname) {
      var match = global.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
      if (match) return match[1];
    }
    return '';
  }

  function persistSelection(range, destination, brand, model, options) {
    var settings = options || {};
    var label = brand.name + ' ' + model.name + (settings.modelOnly ? '' : ' ' + range.label);
    try {
      global.sessionStorage.setItem('co_pending_fit', JSON.stringify({
        id: range.id,
        productHandle: destination.productHandle,
        variantId: destination.variantId,
        ts: Date.now(),
      }));
    } catch (error) {}
    try {
      global.localStorage.setItem('co_garage', JSON.stringify({
        id: range.id,
        label: label,
        productHandle: destination.productHandle,
        variantId: destination.variantId,
      }));
    } catch (error) {}
    if (global.document) {
      global.document.cookie = 'co_garage=' + encodeURIComponent(range.id) + '; path=/; max-age=' + (60 * 60 * 24 * 90) + '; SameSite=Lax';
    }
  }

  function usesCoarsePointer(viewWindow) {
    var win = viewWindow || global;
    if (win.matchMedia) {
      try {
        if (win.matchMedia('(pointer: coarse)').matches) return true;
      } catch (error) {}
    }
    return Boolean(win.navigator && Number(win.navigator.maxTouchPoints) > 0);
  }

  function revealSearchAboveKeyboard(searchSurface, viewWindow) {
    if (!searchSurface || typeof searchSurface.getBoundingClientRect !== 'function') return false;
    var win = viewWindow || global;
    var viewport = win.visualViewport;
    var visibleTop = Number(viewport && viewport.offsetTop || 0);
    var visibleHeight = Number(viewport && viewport.height || win.innerHeight || 0);
    if (!Number.isFinite(visibleTop) || !Number.isFinite(visibleHeight) || visibleHeight <= 0) return false;
    var rect = searchSurface.getBoundingClientRect();
    var margin = 24;
    var visibleBottom = visibleTop + visibleHeight;
    var delta = 0;
    if (rect.bottom > visibleBottom - margin) delta = rect.bottom - (visibleBottom - margin);
    else if (rect.top < visibleTop + margin) delta = rect.top - (visibleTop + margin);
    if (!delta) return false;

    var modalDialog = searchSurface.closest ? searchSurface.closest('.co-vehicle-modal__dialog') : null;
    if (modalDialog && typeof modalDialog.scrollTop === 'number') {
      modalDialog.scrollTop += delta;
      return true;
    }
    if (typeof win.scrollBy === 'function') {
      try { win.scrollBy({ top: delta, left: 0, behavior: 'auto' }); }
      catch (error) { win.scrollBy(0, delta); }
      return true;
    }
    if (typeof searchSurface.scrollIntoView === 'function') {
      searchSurface.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      return true;
    }
    return false;
  }

  function watchSearchKeyboard(input, searchSurface, viewWindow) {
    var win = viewWindow || global;
    var viewport = win.visualViewport;
    var disposed = false;
    var timer = null;
    function reveal() {
      if (disposed) return;
      var documentRef = input && input.ownerDocument;
      if (documentRef && documentRef.activeElement !== input) return;
      revealSearchAboveKeyboard(searchSurface, win);
    }
    function cleanup() {
      if (disposed) return;
      disposed = true;
      if (viewport && viewport.removeEventListener) {
        viewport.removeEventListener('resize', reveal);
        viewport.removeEventListener('scroll', reveal);
      }
      if (win.removeEventListener) win.removeEventListener('resize', reveal);
      if (timer != null && win.clearTimeout) win.clearTimeout(timer);
    }
    if (viewport && viewport.addEventListener) {
      viewport.addEventListener('resize', reveal);
      viewport.addEventListener('scroll', reveal);
    }
    if (win.addEventListener) win.addEventListener('resize', reveal);
    if (win.setTimeout) {
      win.setTimeout(reveal, 0);
      win.setTimeout(reveal, 120);
      timer = win.setTimeout(cleanup, 1400);
    }
    return cleanup;
  }

  function mount(host, index, options) {
    if (!host) return false;
    if (host.__coffMounted) return host.__coffApi || false;
    var settings = options || {};
    var input = host.querySelector('[data-coff-input]');
    var searchSurface = input && input.closest ? input.closest('.coff__search') : null;
    var heading = host.querySelector('[data-coff-heading]');
    var status = host.querySelector('[data-coff-status]');
    var view = host.querySelector('[data-coff-view]');
    var copyNode = host.querySelector('[data-coff-copy]');
    if (!input || !heading || !status || !view || !copyNode) return false;

    var stopKeyboardReveal = null;

    if (searchSurface && searchSurface.addEventListener) {
      searchSurface.addEventListener('click', function (event) {
        var clearControl = event && event.target && event.target.closest
          ? event.target.closest('[data-coff-action="clear-search"]')
          : null;
        if (clearControl || !input || typeof input.focus !== 'function') return;
        if (stopKeyboardReveal) stopKeyboardReveal();
        stopKeyboardReveal = usesCoarsePointer(global)
          ? watchSearchKeyboard(input, searchSurface, global)
          : null;
        input.focus();
      });
    }

    var copy;
    try {
      copy = settings.copy || JSON.parse(copyNode.textContent || '{}');
    } catch (error) {
      status.textContent = 'The vehicle list could not be loaded. Please try again.';
      return false;
    }
    var pageLanguage = settings.language || (global.document && global.document.documentElement
      ? global.document.documentElement.lang
      : 'en');
    var tree = buildTree(index, copy, pageLanguage);
    if (!tree.length) {
      status.textContent = copy.load_error;
      view.innerHTML = '<p class="coff__empty">' + escapeHTML(copy.load_error) + '</p>';
      return false;
    }
    var finderText = finderUiText(pageLanguage, tree.length);

    host.__coffMounted = true;
    var state = {
      step: 'brand',
      query: '',
      showAllBrands: false,
      brandId: null,
      modelId: null,
      smartIntent: null,
    };
    var assign = settings.assign || function (url) { global.location.href = url; };
    var localeRoot = settings.localeRoot == null ? shopifyLocaleRoot() : settings.localeRoot;
    var reducedMotion = Boolean(
      settings.reducedMotion == null
        ? global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches
        : settings.reducedMotion
    );
    var typewriter = createTypewriter(input, copy.examples, {
      reducedMotion: reducedMotion,
      setTimeout: settings.setTimeout,
      clearTimeout: settings.clearTimeout,
      typingDelay: settings.typingDelay,
      holdDelay: settings.holdDelay,
      deletingDelay: settings.deletingDelay,
      betweenDelay: settings.betweenDelay,
    });
    var inputFocused = false;
    var inViewport = !global.IntersectionObserver;
    var externallyActive = true;
    var modalSurface = host.closest ? host.closest('[data-co-vehicle-modal]') : null;
    var pageModal = global.document && global.document.querySelector
      ? global.document.querySelector('[data-co-vehicle-modal]')
      : modalSurface;
    if (modalSurface && modalSurface.addEventListener && !modalSurface.__coffFocusTrapHandler) {
      modalSurface.__coffFocusTrapHandler = function (event) {
        trapModalTabKey(event, modalSurface);
      };
      modalSurface.addEventListener('keydown', modalSurface.__coffFocusTrapHandler);
    }

    function surfaceVisible() {
      return externallyActive && finderSurfaceVisible(host, modalSurface, pageModal);
    }

    var typewriterActivity = createTypewriterActivity(typewriter, {
      surfaceVisible: surfaceVisible,
      intersecting: function () { return inViewport; },
      pageVisible: function () { return !global.document || global.document.visibilityState !== 'hidden'; },
      inputIdle: function () { return !inputFocused && !input.value.trim() && settings.enableTyping !== false; },
    });

    if (global.IntersectionObserver) {
      var intersectionObserver = new global.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== host) return;
          inViewport = Boolean(entry.isIntersecting && entry.intersectionRatio > 0);
          typewriterActivity.sync();
        });
      }, { threshold: 0.01 });
      intersectionObserver.observe(host);
      host.__coffIntersectionObserver = intersectionObserver;
    }
    if (global.MutationObserver && pageModal) {
      var mutationObserver = new global.MutationObserver(function () {
        inViewport = elementInViewport(host, global);
        typewriterActivity.sync();
      });
      mutationObserver.observe(pageModal, {
        attributes: true,
        attributeFilter: ['hidden', 'aria-hidden', 'class', 'style'],
      });
      host.__coffMutationObserver = mutationObserver;
    }
    if (global.document && global.document.addEventListener) {
      global.document.addEventListener('visibilitychange', typewriterActivity.sync);
    }

    function selectedBrand() {
      return tree.find(function (brand) { return brand.id === state.brandId; }) || null;
    }

    function selectedModel() {
      var brand = selectedBrand();
      if (!brand) return null;
      return brand.models.find(function (model) { return model.id === state.modelId; }) || null;
    }

    function renderSearchResults() {
      var intent = state.smartIntent || resolveSmartVehicleIntent(tree, state.query, {
        localeRoot: localeRoot,
        currentSearch: settings.currentSearch == null
          ? global.location && global.location.search
          : settings.currentSearch,
        currentYear: settings.currentYear,
      });
      var smartMarkup = renderMobileSmartIntent(intent, copy, {
        showVehicleLogo: Boolean(modalSurface),
      });
      var fallbackBrands = tree.filter(function (brand) { return brand.popularRank; }).sort(function (left, right) {
        return left.popularRank - right.popularRank;
      }).slice(0, 7);
      var fallbackMessage = copy.search_fallback || copy.no_results;
      if (intent.kind === 'exact-fit' || intent.kind === 'proven-single-variant') {
        heading.textContent = copy.exact_match || copy.open_product;
        status.textContent = copy.exact_match || copy.open_product;
      } else if (intent.kind === 'ambiguous') {
        heading.textContent = copy.multiple_matches || copy.choose_model;
        status.textContent = copy.multiple_matches || copy.choose_model;
      } else if (intent.kind === 'no-match' && intent.suggestedBrands && intent.suggestedBrands.length) {
        heading.textContent = copy.choose_brand;
        status.textContent = copy.choose_brand;
      } else {
        heading.textContent = copy.choose_brand;
        status.textContent = copy.no_safe_match || fallbackMessage;
      }
      view.innerHTML = smartMarkup
        ? '<div class="coff__choices">' + smartMarkup + '</div>'
        : '<div class="coff__empty"><p>' + escapeHTML(fallbackMessage) + '</p><button type="button" class="coff__link" data-coff-action="clear-search">' + escapeHTML(copy.clear_search) + '</button></div>' +
          '<div class="coff__choices coff__choices--fallback">' + fallbackBrands.map(renderBrandChoice).join('') + '</div>';
    }

    function renderBrands() {
      if (state.query) {
        renderSearchResults();
        return;
      }
      var popularBrands = tree.filter(function (brand) { return brand.popularRank; }).sort(function (left, right) {
        return left.popularRank - right.popularRank;
      });
      var popularIds = {};
      popularBrands.forEach(function (brand) { popularIds[brand.id] = true; });
      var brands = popularBrands.concat(tree.filter(function (brand) { return !popularIds[brand.id]; }));
      var visibleCount = state.showAllBrands ? brands.length : popularBrands.length;
      heading.textContent = copy.choose_brand;
      status.textContent = copy.choose_brand + ' · ' + visibleCount;
      view.innerHTML = '<div class="coff__view-head coff__view-head--results"><strong data-coff-brand-label>' + escapeHTML(finderText.found) + '</strong></div>' +
        '<div class="coff__choices coff__choices--brands' + (state.showAllBrands ? ' is-expanded' : '') + '" data-coff-brand-list>' + brands.map(function (brand, index) {
          return renderBrandChoice(brand, {
            extra: index >= popularBrands.length,
            stagger: Math.max(0, index - popularBrands.length),
            expanded: state.showAllBrands,
          });
        }).join('') + '</div>' +
        '<button type="button" class="coff__show-all" data-coff-action="toggle-brands" aria-expanded="' + (state.showAllBrands ? 'true' : 'false') + '">' +
          escapeHTML(state.showAllBrands ? finderText.less : finderText.more) +
        '</button>';
    }

    function renderModels() {
      var brand = selectedBrand();
      if (!brand) {
        state.step = 'brand';
        renderBrands();
        return;
      }
      heading.textContent = brand.name + ' · ' + copy.choose_model;
      status.textContent = copy.choose_model + ' · ' + brand.models.length;
      view.innerHTML = '<div class="coff__view-head"><button type="button" class="coff__back" data-coff-action="back-brands">' + backIcon() + escapeHTML(copy.back_brands) + '</button></div>' +
        '<div class="coff__choices">' + brand.models.map(function (model) {
          return renderModelChoice(brand, model);
        }).join('') + '</div>';
    }

    function renderYears() {
      var brand = selectedBrand();
      var model = selectedModel();
      if (!brand || !model) {
        state.step = brand ? 'model' : 'brand';
        render();
        return;
      }
      var yearPrompt = state.smartIntent && state.smartIntent.kind === 'unsupported-year'
        ? copy.unsupported_year || copy.valid_years || copy.choose_year
        : state.smartIntent && state.smartIntent.kind === 'ambiguous'
          ? copy.multiple_matches || copy.choose_year
          : state.smartIntent
            ? copy.ask_year || copy.choose_year
            : copy.choose_year;
      heading.textContent = modalSurface
        ? yearPrompt
        : brand.name + ' ' + model.name + ' · ' + yearPrompt;
      status.textContent = yearPrompt + ' · ' + model.ranges.length;
      view.innerHTML = (modalSurface ? renderVehicleIdentity(brand, model, { summary: true }) : '') +
        '<div class="coff__view-head"><button type="button" class="coff__back" data-coff-action="back-models">' + backIcon() + escapeHTML(copy.back_models) + '</button></div>' +
        '<div class="coff__choices">' + model.ranges.map(function (range) {
          return renderRangeChoice(range, copy);
        }).join('') + '</div>';
    }

    function render() {
      host.dataset.coffStep = state.step;
      if (state.step === 'model') renderModels();
      else if (state.step === 'year') renderYears();
      else renderBrands();
    }

    function focusHeading() {
      if (!heading || typeof heading.focus !== 'function') return;
      try { heading.focus({ preventScroll: true }); }
      catch (error) { heading.focus(); }
    }

    var pointerStepPosition = null;
    var stepPositions = {};

    function transition(step, event, direction) {
      var sourceStep = state.step;
      var capturedPosition = pointerStepPosition || captureStepPosition(host, { window: global });
      pointerStepPosition = null;
      var mode = direction === 'back' ? 'restore' : 'forward';
      if (mode === 'forward') stepPositions[sourceStep] = capturedPosition;
      var targetPosition = mode === 'restore' && stepPositions[step]
        ? stepPositions[step]
        : capturedPosition;
      lockStepTransition(view);
      if (view && view.style) {
        view.style.paddingTop = '';
        view.style.paddingBottom = '';
      }
      state.step = step;
      render();
      if (mode === 'restore') applyStepAnchor(view, targetPosition);
      if (activationIsKeyboard(event, lastInteraction)) focusHeading();
      var desktop = global.matchMedia && global.matchMedia('(min-width: 1024px)').matches;
      settleStepTransition(view, targetPosition, {
        mode: mode,
        desktop: desktop,
        reducedMotion: reducedMotion,
        requestAnimationFrame: settings.requestAnimationFrame,
      });
    }

    var lastInteraction = 'pointer';
    function rememberPointerStepPosition(event) {
      lastInteraction = 'pointer';
      var control = event && event.target && event.target.closest
        ? event.target.closest('[data-coff-action]')
        : null;
      var action = control && control.dataset ? control.dataset.coffAction : null;
      if (['pick-brand', 'pick-model', 'back-brands', 'back-models'].indexOf(action) !== -1) {
        pointerStepPosition = captureStepPosition(host, { window: global, control: control });
      } else {
        pointerStepPosition = null;
      }
    }
    host.addEventListener('pointerdown', rememberPointerStepPosition);
    host.addEventListener('touchstart', rememberPointerStepPosition, { passive: true });
    host.addEventListener('keydown', function (event) {
      if (!event || ['Tab', 'Enter', ' ', 'Spacebar', 'ArrowUp', 'ArrowDown'].indexOf(event.key) !== -1) {
        lastInteraction = 'keyboard';
        pointerStepPosition = null;
      }
    });

    host.addEventListener('click', function (event) {
      var control = event.target && event.target.closest
        ? event.target.closest('[data-coff-action]')
        : null;
      if (!control) return;
      if (event.preventDefault) event.preventDefault();
      var action = control.dataset.coffAction;

      if (action === 'show-all' || action === 'toggle-brands') {
        var listResizePosition = captureStepPosition(host, { window: global });
        state.showAllBrands = action === 'show-all' ? true : !state.showAllBrands;
        setBrandListExpanded(view, state.showAllBrands, {
          reducedMotion: reducedMotion,
          total: tree.length,
          popular: tree.filter(function (brand) { return brand.popularRank; }).length,
          showAllLabel: finderText.more,
          showLessLabel: finderText.less,
          allLabel: finderText.found,
          popularLabel: finderText.found,
          requestFrame: settings.requestAnimationFrame,
          setTimeout: settings.setTimeout,
          clearTimeout: settings.clearTimeout,
        });
        settleListResizePosition(listResizePosition, {
          requestAnimationFrame: settings.requestAnimationFrame,
          setTimeout: settings.setTimeout,
        });
        status.textContent = copy.choose_brand + ' · ' + (state.showAllBrands ? tree.length : tree.filter(function (brand) { return brand.popularRank; }).length);
      } else if (action === 'clear-search') {
        releaseStepTransition(view);
        input.value = '';
        state.query = '';
        state.smartIntent = null;
        state.brandId = null;
        state.modelId = null;
        state.step = 'brand';
        render();
        if (typeof input.focus === 'function') input.focus();
      } else if (action === 'pick-brand') {
        input.value = '';
        state.query = '';
        state.smartIntent = null;
        state.brandId = control.dataset.brandId;
        state.modelId = null;
        transition('model', event, 'forward');
      } else if (action === 'pick-model') {
        input.value = '';
        state.query = '';
        state.smartIntent = null;
        state.brandId = control.dataset.brandId || state.brandId;
        state.modelId = control.dataset.modelId;
        var directBrand = selectedBrand();
        var directModel = selectedModel();
        var directSelection = singleVariantSelection(directModel, localeRoot);
        if (directBrand && directModel && directSelection) {
          persistSelection(
            directSelection.range,
            directSelection.destination,
            directBrand,
            directModel,
            { modelOnly: true }
          );
          assign(preserveNavigationBypass(
            directSelection.destination.url,
            global.location && global.location.search
          ));
        } else {
          transition('year', event, 'forward');
        }
      } else if (action === 'back-brands') {
        state.modelId = null;
        transition('brand', event, 'back');
      } else if (action === 'back-models') {
        transition('model', event, 'back');
      } else if (action === 'smart-destination') {
        activateMobileSmartIntent(state.smartIntent);
      } else if (action === 'pick-range') {
        var brand = selectedBrand();
        var model = selectedModel();
        var range = model && model.ranges.find(function (entry) {
          return entry.id === control.dataset.rangeId;
        });
        var destination = destinationFor(range, localeRoot, control.dataset.variantId);
        if (brand && model && range && destination) {
          persistSelection(range, destination, brand, model);
          assign(preserveNavigationBypass(
            destination.url,
            global.location && global.location.search
          ));
        }
      }
    });

    function resolveMobileSmartInput(query) {
      return resolveSmartVehicleIntent(tree, query, {
        localeRoot: localeRoot,
        currentSearch: settings.currentSearch == null
          ? global.location && global.location.search
          : settings.currentSearch,
        currentYear: settings.currentYear,
      });
    }

    function renderMobileSmartInput(intent) {
      releaseStepTransition(view);
      state.smartIntent = intent;
      state.query = intent.rawQuery;
      state.brandId = intent.selectedBrand ? intent.selectedBrand.id : null;
      state.modelId = intent.selectedModel ? intent.selectedModel.id : null;
      if (intent.kind === 'brand-only') state.step = 'model';
      else if (intent.kind === 'model-needs-year' || intent.kind === 'unsupported-year' ||
        (intent.kind === 'ambiguous' && intent.selectedModel && intent.periods.length)) state.step = 'year';
      else state.step = 'brand';
      render();
      typewriterActivity.sync();
    }

    function activateMobileSmartIntent(intent) {
      if (!intent || !intent.canNavigate || !intent.destination) return false;
      if (intent.selectedBrand && intent.selectedModel && intent.exactPeriod) {
        persistSelection(
          intent.exactPeriod,
          intent.destination,
          intent.selectedBrand,
          intent.selectedModel,
          { modelOnly: intent.kind === 'proven-single-variant' }
        );
      }
      return activateSmartVehicleIntent(intent, assign);
    }

    var smartInputController = createSmartInputController({
      input: input,
      resolve: resolveMobileSmartInput,
      render: renderMobileSmartInput,
      activate: activateMobileSmartIntent,
    });

    input.addEventListener('focus', function () {
      inputFocused = true;
      typewriterActivity.sync();
    });
    input.addEventListener('blur', function () {
      inputFocused = false;
      typewriterActivity.sync();
    });

    function getPublicState() {
      return {
        step: state.step,
        query: state.query,
        showAllBrands: state.showAllBrands,
        brandId: state.brandId || '',
        modelId: state.modelId || '',
      };
    }

    function setPublicState(next) {
      var value = next || {};
      if (Object.prototype.hasOwnProperty.call(value, 'query')) {
        state.query = String(value.query || '');
        input.value = state.query;
        state.smartIntent = state.query ? resolveMobileSmartInput(state.query) : null;
      }
      if (Object.prototype.hasOwnProperty.call(value, 'brandId')) state.brandId = value.brandId || null;
      if (Object.prototype.hasOwnProperty.call(value, 'modelId')) state.modelId = value.modelId || null;
      if (Object.prototype.hasOwnProperty.call(value, 'showAllBrands')) state.showAllBrands = Boolean(value.showAllBrands);

      var brand = selectedBrand();
      if (!brand) {
        state.brandId = null;
        state.modelId = null;
      } else if (!selectedModel()) {
        state.modelId = null;
      }

      if (state.query) state.step = 'brand';
      else if (state.brandId && state.modelId) state.step = 'year';
      else if (state.brandId) state.step = 'model';
      else state.step = 'brand';
      if (value.step === 'brand' || value.step === 'model' || value.step === 'year') state.step = value.step;
      render();
      typewriterActivity.sync();
      return getPublicState();
    }

    function setActive(active) {
      externallyActive = Boolean(active);
      typewriterActivity.sync();
    }

    function destroy() {
      externallyActive = false;
      if (stopKeyboardReveal) stopKeyboardReveal();
      typewriter.stop();
      smartInputController.destroy();
      if (host.__coffIntersectionObserver && host.__coffIntersectionObserver.disconnect) {
        host.__coffIntersectionObserver.disconnect();
      }
      if (host.__coffMutationObserver && host.__coffMutationObserver.disconnect) {
        host.__coffMutationObserver.disconnect();
      }
      host.__coffMounted = false;
      host.__coffApi = null;
    }

    render();
    typewriterActivity.sync();
    host.__coffApi = {
      getState: getPublicState,
      setState: setPublicState,
      setActive: setActive,
      getSmartIntent: function () { return state.smartIntent; },
      destroy: destroy,
    };
    return host.__coffApi;
  }

  function focusWithoutScroll(control) {
    if (!control || typeof control.focus !== 'function') return;
    try { control.focus({ preventScroll: true }); }
    catch (error) { control.focus(); }
  }

  function desktopPanelRevealDelta(rect, viewportHeight, margin) {
    var top = rect && Number(rect.top);
    var bottom = rect && Number(rect.bottom);
    var height = Number(viewportHeight);
    var safeMargin = Number(margin == null ? 16 : margin);
    if (!Number.isFinite(top) || !Number.isFinite(bottom) || !Number.isFinite(height) || height <= 0) return 0;
    if (!Number.isFinite(safeMargin) || safeMargin < 0) safeMargin = 16;
    if (top < safeMargin) return top - safeMargin;
    var viewportBottom = height - safeMargin;
    if (bottom > viewportBottom) return bottom - viewportBottom;
    return 0;
  }

  function revealDesktopPanel(panel, options) {
    var settings = options || {};
    var win = settings.window || global;
    var requestFrame = settings.requestAnimationFrame || (win && win.requestAnimationFrame);
    if (!panel || !win || typeof win.scrollTo !== 'function') return false;
    function reveal() {
      if (panel.hidden || typeof panel.getBoundingClientRect !== 'function') return;
      var delta = desktopPanelRevealDelta(
        panel.getBoundingClientRect(),
        win.innerHeight,
        settings.margin == null ? 16 : settings.margin
      );
      if (!delta) return;
      var currentScroll = Number(win.scrollY == null ? win.pageYOffset || 0 : win.scrollY);
      win.scrollTo({
        top: Math.max(0, currentScroll + delta),
        behavior: settings.reducedMotion ? 'auto' : 'smooth',
      });
    }
    if (requestFrame) requestFrame(reveal);
    else reveal();
    return true;
  }

  function settleDesktopScroll(scrollY, options) {
    var settings = options || {};
    var win = settings.window || global;
    var requestFrame = settings.requestAnimationFrame || (win && win.requestAnimationFrame);
    var setTimer = settings.setTimeout || (win && win.setTimeout);
    if (!win || typeof win.scrollTo !== 'function' || typeof scrollY !== 'number') return;
    function restore() {
      if (win.scrollY !== scrollY) win.scrollTo(0, scrollY);
    }
    restore();
    if (!requestFrame) return;
    requestFrame(function () {
      restore();
      requestFrame(restore);
    });
    if (setTimer) {
      setTimer(restore, 80);
      setTimer(restore, 220);
    }
  }

  function desktopActivationUsesFocus(event) {
    return Boolean(event && event.detail === 0 && !event.pointerType);
  }

  function desktopPreservedScroll(pointerScrollY, currentScrollY) {
    return typeof pointerScrollY === 'number' ? pointerScrollY : currentScrollY;
  }

  function setSurfaceActive(surface, active) {
    if (!surface) return;
    surface.hidden = !active;
    if (surface.setAttribute) surface.setAttribute('aria-hidden', active ? 'false' : 'true');
  }

  function mountDesktopFinder(host, index, options) {
    if (!host) return false;
    if (host.__cofrDesktopApi) return host.__cofrDesktopApi;
    var settings = options || {};
    var desktop = host.querySelector('[data-cofr-desktop]');
    var input = host.querySelector('[data-cofr-input]');
    var brandTrigger = host.querySelector('[data-cofr-brand-trigger]');
    var brandLabel = host.querySelector('[data-cofr-brand-label]');
    var modelTrigger = host.querySelector('[data-cofr-model-trigger]');
    var modelLabel = host.querySelector('[data-cofr-model-label]');
    var submit = host.querySelector('[data-cofr-submit]');
    var panel = host.querySelector('[data-cofr-panel]');
    var grid = host.querySelector('[data-cofr-brand-grid]');
    var found = host.querySelector('[data-cofr-found]');
    var status = host.querySelector('[data-cofr-status]');
    var copyNode = host.querySelector('[data-cofr-copy]');
    if (!desktop || !input || !brandTrigger || !brandLabel || !modelTrigger || !modelLabel || !submit || !panel || !grid || !copyNode) return false;

    var copy;
    try { copy = settings.copy || JSON.parse(copyNode.textContent || '{}'); }
    catch (error) { return false; }
    var language = settings.language || (global.document && global.document.documentElement
      ? global.document.documentElement.lang
      : host.dataset && host.dataset.cofrLocale || 'en');
    var tree = buildTree(index, copy, language);
    if (!tree.length) return false;
    var finderText = finderUiText(language, tree.length);
    var localeRoot = settings.localeRoot == null ? shopifyLocaleRoot() : settings.localeRoot;
    var assign = settings.assign || function (url) { global.location.href = url; };
    var state = {
      query: '',
      brandId: '',
      modelId: '',
      step: 'brand',
      panel: 'closed',
      opener: null,
      smartIntent: null,
    };
    var pointerScrollY = null;
    var active = false;
    var inputFocused = false;
    var reducedMotion = Boolean(
      settings.reducedMotion == null
        ? global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches
        : settings.reducedMotion
    );
    var requestFrame = settings.requestAnimationFrame || global.requestAnimationFrame;
    var typewriter = createTypewriter(input, copy.examples, {
      reducedMotion: reducedMotion,
      setTimeout: settings.setTimeout,
      clearTimeout: settings.clearTimeout,
      typingDelay: settings.typingDelay,
      holdDelay: settings.holdDelay,
      deletingDelay: settings.deletingDelay,
      betweenDelay: settings.betweenDelay,
    });

    function selectedBrand() {
      return tree.find(function (brand) { return brand.id === state.brandId; }) || null;
    }

    function selectedModel() {
      var brand = selectedBrand();
      return brand && brand.models.find(function (model) { return model.id === state.modelId; }) || null;
    }

    function syncTypewriter() {
      if (active && !inputFocused && !String(input.value || '').trim() && settings.enableTyping !== false) typewriter.start();
      else typewriter.stop();
    }

    function setExpanded(control, expanded) {
      if (!control) return;
      if (control.setAttribute) control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (control.classList && control.classList.toggle) control.classList.toggle('is-active', expanded);
    }

    function syncExpandedState() {
      var open = state.panel !== 'closed' && !panel.hidden;
      setExpanded(input, open && state.opener === 'search');
      setExpanded(brandTrigger, open && state.opener === 'brand');
      setExpanded(modelTrigger, open && state.opener === 'model');
    }

    function controlForOpener(opener) {
      if (opener === 'brand') return brandTrigger;
      if (opener === 'model') return modelTrigger;
      return input;
    }

    function closePanel(options) {
      var closeOptions = options || {};
      var opener = state.opener;
      state.panel = 'closed';
      state.opener = null;
      panel.hidden = true;
      panel.innerHTML = '';
      if (panel.classList && panel.classList.remove) panel.classList.remove('is-open');
      if (panel.setAttribute) panel.setAttribute('aria-hidden', 'true');
      syncExpandedState();
      if (closeOptions.restoreFocus) focusWithoutScroll(controlForOpener(opener));
    }

    function desktopChoice(action, label, attributes, meta) {
      return '<button type="button" class="cofr__panel-choice" role="option" data-cofr-action="' + escapeHTML(action) + '" ' + (attributes || '') + '>' +
        '<span class="cofr__panel-label">' + escapeHTML(label) + '</span>' +
        (meta ? '<span class="cofr__panel-meta">' + escapeHTML(meta) + '</span>' : '') +
        arrowIcon() + '</button>';
    }

    function renderBrands() {
      return desktopBrandGrid(tree).map(function (brand) {
        var selected = brand.id === state.brandId ? ' aria-selected="true" data-selected="true"' : ' aria-selected="false"';
        return desktopChoice('brand', brand.name, 'data-brand-id="' + escapeHTML(brand.id) + '"' + selected, '');
      }).join('');
    }

    function renderMatches() {
      var intent = state.smartIntent || resolveSmartVehicleIntent(tree, state.query, {
        localeRoot: localeRoot,
        currentSearch: settings.currentSearch == null
          ? global.location && global.location.search
          : settings.currentSearch,
        currentYear: settings.currentYear,
      });
      var markup = renderDesktopSmartIntent(intent, copy);
      if (!markup) {
        var fallback = desktopBrandGrid(tree).slice(0, 7).map(function (brand) {
          return desktopChoice('brand', brand.name, 'data-brand-id="' + escapeHTML(brand.id) + '"', '');
        }).join('');
        return '<div class="cofr__panel-empty"><p>' + escapeHTML(copy.search_fallback || copy.no_results) + '</p></div>' + fallback;
      }
      return markup;
    }

    function renderModels() {
      var brand = selectedBrand();
      if (!brand) return '';
      return brand.models.map(function (model) {
        var selected = model.id === state.modelId ? ' aria-selected="true" data-selected="true"' : ' aria-selected="false"';
        return desktopChoice('model', model.name, 'data-brand-id="' + escapeHTML(brand.id) + '" data-model-id="' + escapeHTML(model.id) + '"' + selected, '');
      }).join('');
    }

    function renderRanges() {
      var model = selectedModel();
      if (!model) return '';
      return model.ranges.map(renderDesktopRangeChoice).join('');
    }

    function renderPanel(mode) {
      var nextMode = mode || state.panel || desktopPanelMode(state);
      state.panel = nextMode;
      if (!active || nextMode === 'closed') {
        closePanel();
        return;
      }
      var markup = '';
      if (nextMode === 'brands') markup = renderBrands();
      else if (nextMode === 'matches') markup = renderMatches();
      else if (nextMode === 'models') markup = renderModels();
      else if (nextMode === 'ranges') markup = renderRanges();
      if (!markup) {
        closePanel();
        return;
      }
      panel.innerHTML = markup;
      panel.hidden = false;
      if (panel.setAttribute) panel.setAttribute('aria-hidden', 'false');
      if (panel.classList && panel.classList.remove) panel.classList.remove('is-open');
      if (panel.classList && panel.classList.add) {
        if (reducedMotion || !requestFrame) panel.classList.add('is-open');
        else requestFrame(function () {
          if (!panel.hidden && state.panel === nextMode) panel.classList.add('is-open');
        });
      }
      syncExpandedState();
      if (status) {
        if (nextMode === 'matches' && state.smartIntent) {
          if (state.smartIntent.kind === 'model-needs-year') status.textContent = copy.ask_year || copy.choose_year;
          else if (state.smartIntent.kind === 'exact-fit' || state.smartIntent.kind === 'proven-single-variant') status.textContent = copy.exact_match || copy.open_product;
          else if (state.smartIntent.kind === 'ambiguous') status.textContent = copy.multiple_matches || copy.choose_model;
          else if (state.smartIntent.kind === 'unsupported-year') status.textContent = copy.unsupported_year || copy.valid_years;
          else if (state.smartIntent.kind === 'no-match' && state.smartIntent.suggestedBrands && state.smartIntent.suggestedBrands.length) status.textContent = copy.choose_brand;
          else if (state.smartIntent.kind === 'no-match') status.textContent = copy.no_safe_match || copy.search_fallback || copy.no_results;
          else if (state.smartIntent.kind === 'brand-only') status.textContent = copy.choose_model;
          else status.textContent = copy.choose_brand;
        } else if (nextMode === 'models') status.textContent = copy.choose_model;
        else if (nextMode === 'ranges') status.textContent = copy.choose_year;
        else status.textContent = copy.choose_brand;
      }
    }

    function openPanel(mode, opener) {
      state.panel = mode;
      state.opener = opener || null;
      renderPanel(mode);
    }

    function render() {
      if (state.modelId && !selectedModel()) state.modelId = '';
      var brand = selectedBrand();
      var model = selectedModel();
      brandLabel.textContent = brand ? brand.name : copy.brand_label || 'Brand';
      modelLabel.textContent = model ? model.name : copy.model_label || 'Model';
      modelTrigger.disabled = !brand;
      if (input.value !== state.query) input.value = state.query;
      renderPanel(state.panel);
      syncTypewriter();
    }

    function getState() {
      return {
        query: state.query,
        brandId: state.brandId,
        modelId: state.modelId,
        step: state.step,
        panel: state.panel,
        opener: state.opener,
      };
    }

    function setState(next) {
      var value = next || {};
      if (Object.prototype.hasOwnProperty.call(value, 'query')) state.query = String(value.query || '');
      if (Object.prototype.hasOwnProperty.call(value, 'brandId')) state.brandId = value.brandId || '';
      if (Object.prototype.hasOwnProperty.call(value, 'modelId')) state.modelId = value.modelId || '';
      if (Object.prototype.hasOwnProperty.call(value, 'panel')) state.panel = value.panel || 'closed';
      if (Object.prototype.hasOwnProperty.call(value, 'opener')) state.opener = value.opener || null;
      var brand = selectedBrand();
      if (!brand) {
        state.brandId = '';
        state.modelId = '';
      } else if (!selectedModel()) {
        state.modelId = '';
      }
      if (state.panel === 'closed') state.opener = null;
      else if (!state.opener) state.opener = state.panel === 'matches' ? 'search' : state.panel === 'brands' ? 'brand' : 'model';
      state.smartIntent = state.query ? resolveSmartVehicleIntent(tree, state.query, {
        localeRoot: localeRoot,
        currentSearch: settings.currentSearch == null
          ? global.location && global.location.search
          : settings.currentSearch,
        currentYear: settings.currentYear,
      }) : null;
      state.step = state.modelId ? 'year' : state.brandId ? 'model' : 'brand';
      render();
      return getState();
    }

    function setActive(nextActive) {
      active = Boolean(nextActive);
      if (!active) closePanel();
      syncTypewriter();
    }

    function selectBrand(brandId, focusModel) {
      state.query = '';
      state.smartIntent = null;
      state.brandId = brandId || '';
      state.modelId = '';
      state.step = state.brandId ? 'model' : 'brand';
      state.panel = state.brandId ? 'models' : 'closed';
      state.opener = state.brandId ? 'model' : null;
      render();
      if (focusModel) focusWithoutScroll(modelTrigger);
    }

    function selectModel(brandId, modelId) {
      if (brandId) state.brandId = brandId;
      state.query = '';
      state.smartIntent = null;
      state.modelId = modelId || '';
      var brand = selectedBrand();
      var model = selectedModel();
      var directSelection = singleVariantSelection(model, localeRoot);
      if (brand && model && directSelection) {
        state.step = 'year';
        closePanel();
        render();
        persistSelection(
          directSelection.range,
          directSelection.destination,
          brand,
          model,
          { modelOnly: true }
        );
        assign(preserveNavigationBypass(
          directSelection.destination.url,
          global.location && global.location.search
        ));
        return true;
      }
      state.step = state.modelId ? 'year' : state.brandId ? 'model' : 'brand';
      state.panel = state.modelId ? 'ranges' : state.brandId ? 'models' : 'closed';
      state.opener = state.panel === 'closed' ? null : 'model';
      render();
      return false;
    }

    var desktopLogosVisible = !global.matchMedia || global.matchMedia('(min-width: 1024px)').matches;
    grid.innerHTML = desktopBrandGrid(tree).map(function (brand) {
      return '<button type="button" class="cofr__brand" data-cofr-action="brand" data-brand-id="' + escapeHTML(brand.id) + '">' +
        '<span class="cofr__brand-logo"><img src="' + escapeHTML(brand.logo) + '" alt="" width="72" height="72"' + brandLogoAttributes(brand, { visible: desktopLogosVisible }) + '></span>' +
        '<span class="cofr__brand-name">' + escapeHTML(brand.name) + '</span></button>';
    }).join('');
    if (found) found.textContent = finderText.found;

    function resolveSmartInput(query) {
      return resolveSmartVehicleIntent(tree, query, {
        localeRoot: localeRoot,
        currentSearch: settings.currentSearch == null
          ? global.location && global.location.search
          : settings.currentSearch,
        currentYear: settings.currentYear,
      });
    }

    function renderSmartInput(intent) {
      state.smartIntent = intent;
      state.query = intent.rawQuery;
      state.brandId = intent.selectedBrand ? intent.selectedBrand.id : '';
      state.modelId = intent.selectedModel ? intent.selectedModel.id : '';
      state.step = state.modelId ? 'year' : state.brandId ? 'model' : 'brand';
      state.panel = intent.kind === 'empty' ? 'closed' : 'matches';
      state.opener = intent.kind === 'empty' ? null : 'search';
      render();
    }

    function activateDesktopSmartIntent(intent) {
      if (!intent || !intent.canNavigate || !intent.destination) return false;
      if (intent.selectedBrand && intent.selectedModel && intent.exactPeriod) {
        persistSelection(
          intent.exactPeriod,
          intent.destination,
          intent.selectedBrand,
          intent.selectedModel,
          { modelOnly: intent.kind === 'proven-single-variant' }
        );
      }
      return activateSmartVehicleIntent(intent, assign);
    }

    var smartInputController = createSmartInputController({
      input: input,
      submit: submit,
      resolve: resolveSmartInput,
      render: renderSmartInput,
      activate: activateDesktopSmartIntent,
      onEmptyConfirm: function () {
        var brand = selectedBrand();
        var model = selectedModel();
        if (brand && model) return selectModel(brand.id, model.id);
        if (brand) openPanel('models', 'model');
        else openPanel('brands', 'brand');
        return false;
      },
    });

    function onFocus() {
      inputFocused = true;
      syncTypewriter();
      if (state.smartIntent && state.smartIntent.kind !== 'empty') openPanel('matches', 'search');
    }
    function onBlur() { inputFocused = false; syncTypewriter(); }
    function panelChoices() {
      if (!panel.querySelectorAll) return [];
      return Array.prototype.slice.call(panel.querySelectorAll('[data-cofr-action]')).filter(function (choice) {
        return !choice.disabled;
      });
    }
    function focusPanelChoice(index) {
      var choices = panelChoices();
      if (!choices.length) return false;
      var safeIndex = Math.max(0, Math.min(Number(index) || 0, choices.length - 1));
      choices.forEach(function (choice, choiceIndex) {
        if (choice.setAttribute) choice.setAttribute('tabindex', choiceIndex === safeIndex ? '0' : '-1');
      });
      focusWithoutScroll(choices[safeIndex]);
      return true;
    }
    function focusInitialPanelChoice() {
      var choices = panelChoices();
      var selectedIndex = choices.findIndex(function (choice) {
        return choice.getAttribute && choice.getAttribute('aria-selected') === 'true';
      });
      return focusPanelChoice(selectedIndex >= 0 ? selectedIndex : 0);
    }
    function toggleBrands() {
      if (state.panel === 'brands' && state.opener === 'brand') closePanel();
      else openPanel('brands', 'brand');
    }
    function toggleModels() {
      if (!selectedBrand()) return false;
      if (state.panel === 'models' && state.opener === 'model') closePanel();
      else openPanel('models', 'model');
      return true;
    }
    function onKeydown(event) {
      if (!event) return;
      if (event.key === 'Escape' && state.panel !== 'closed') {
        if (event.preventDefault) event.preventDefault();
        closePanel({ restoreFocus: true });
        return;
      }
      if (event.target === input && event.key === 'ArrowDown' && state.panel !== 'closed' && state.opener === 'search') {
        if (event.preventDefault) event.preventDefault();
        focusInitialPanelChoice();
        return;
      }
      var control = event.target && event.target.closest ? event.target.closest('[data-cofr-action]') : null;
      var action = control && control.dataset ? control.dataset.cofrAction : '';
      var openKey = event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown';
      if (openKey && (action === 'toggle-brands' || action === 'toggle-models')) {
        if (event.preventDefault) event.preventDefault();
        if (action === 'toggle-brands') openPanel('brands', 'brand');
        else if (!selectedBrand()) return;
        else openPanel('models', 'model');
        focusInitialPanelChoice();
        return;
      }
      var choices = panelChoices();
      var choiceIndex = control ? choices.indexOf(control) : -1;
      if (choiceIndex < 0) return;
      var nextIndex = null;
      if (event.key === 'ArrowDown') nextIndex = (choiceIndex + 1) % choices.length;
      else if (event.key === 'ArrowUp') nextIndex = (choiceIndex - 1 + choices.length) % choices.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = choices.length - 1;
      if (nextIndex != null) {
        if (event.preventDefault) event.preventDefault();
        focusPanelChoice(nextIndex);
      }
    }
    function onPointerDown(event) {
      var control = event && event.target && event.target.closest ? event.target.closest('[data-cofr-action]') : null;
      pointerScrollY = control && control.dataset && control.dataset.cofrAction === 'brand' && typeof global.scrollY === 'number'
        ? global.scrollY
        : null;
    }
    function onClick(event) {
      var control = event.target && event.target.closest ? event.target.closest('[data-cofr-action]') : null;
      if (!control || !host.contains(control)) return;
      if (event.preventDefault) event.preventDefault();
      var action = control.dataset.cofrAction;
      if (action === 'clear') {
        state.query = '';
        state.smartIntent = null;
        state.brandId = '';
        state.modelId = '';
        state.step = 'brand';
        state.panel = 'closed';
        state.opener = null;
        render();
        focusWithoutScroll(input);
      } else if (action === 'toggle-brands') {
        toggleBrands();
      } else if (action === 'toggle-models') {
        toggleModels();
      } else if (action === 'brand') {
        pointerScrollY = null;
        selectBrand(control.dataset.brandId, desktopActivationUsesFocus(event));
        revealDesktopPanel(panel, {
          window: global,
          requestAnimationFrame: settings.requestAnimationFrame,
          reducedMotion: reducedMotion,
          margin: 16,
        });
      } else if (action === 'model') {
        selectModel(control.dataset.brandId, control.dataset.modelId);
      } else if (action === 'smart-destination') {
        activateDesktopSmartIntent(state.smartIntent);
      } else if (action === 'range') {
        var brand = selectedBrand();
        var model = selectedModel();
        var range = model && model.ranges.find(function (entry) { return entry.id === control.dataset.rangeId; });
        var destination = destinationFor(range, localeRoot, control.dataset.variantId);
        if (brand && model && range && destination) {
          persistSelection(range, destination, brand, model);
          assign(preserveNavigationBypass(
            destination.url,
            global.location && global.location.search
          ));
        }
      }
    }
    function onDocumentPointer(event) {
      if (active && event && event.target && host.contains && !host.contains(event.target)) closePanel();
    }

    input.addEventListener('focus', onFocus);
    input.addEventListener('blur', onBlur);
    host.addEventListener('pointerdown', onPointerDown);
    host.addEventListener('touchstart', onPointerDown, { passive: true });
    host.addEventListener('click', onClick);
    host.addEventListener('keydown', onKeydown);
    if (global.document && global.document.addEventListener) global.document.addEventListener('pointerdown', onDocumentPointer);

    function destroy() {
      setActive(false);
      smartInputController.destroy();
      if (global.document && global.document.removeEventListener) global.document.removeEventListener('pointerdown', onDocumentPointer);
      host.__cofrDesktopApi = null;
    }

    host.__cofrDesktopApi = {
      getState: getState,
      setState: setState,
      setActive: setActive,
      closePanel: closePanel,
      getSmartIntent: function () { return state.smartIntent; },
      destroy: destroy,
    };
    render();
    return host.__cofrDesktopApi;
  }

  function mountResponsiveFinder(host, index, options) {
    if (!host) return false;
    if (host.__cofrApi) return host.__cofrApi;
    var settings = options || {};
    var desktopSurface = host.querySelector('[data-cofr-desktop]');
    var mobileSurface = host.querySelector('[data-cofr-mobile]');
    var mobileHost = host.querySelector('[data-coff-responsive-mobile]');
    if (!desktopSurface || !mobileSurface || !mobileHost) return false;
    var desktopApi = mountDesktopFinder(host, index, settings);
    var mobileApi = mount(mobileHost, index, settings.mobileOptions || settings);
    if (!desktopApi || !mobileApi) return false;

    var matcher = settings.matchMedia
      ? settings.matchMedia('(min-width: 1024px)')
      : global.matchMedia
        ? global.matchMedia('(min-width: 1024px)')
        : { matches: Number(global.innerWidth || 0) >= 1024 };
    var desktopActive = null;

    function copyState(fromApi, toApi) {
      var source = fromApi && fromApi.getState ? fromApi.getState() : {};
      toApi.setState({
        query: source.query || '',
        brandId: source.brandId || '',
        modelId: source.modelId || '',
        panel: 'closed',
      });
    }

    function applyMode(force) {
      var nextDesktop = Boolean(matcher.matches);
      if (!force && desktopActive === nextDesktop) return;
      if (desktopActive === true) copyState(desktopApi, mobileApi);
      else if (desktopActive === false) copyState(mobileApi, desktopApi);
      desktopActive = nextDesktop;
      desktopApi.closePanel();
      setSurfaceActive(desktopSurface, desktopActive);
      setSurfaceActive(mobileSurface, !desktopActive);
      desktopApi.setActive(desktopActive);
      mobileApi.setActive(!desktopActive);
    }

    function onMediaChange() { applyMode(false); }
    if (matcher.addEventListener) matcher.addEventListener('change', onMediaChange);
    else if (matcher.addListener) matcher.addListener(onMediaChange);
    applyMode(true);

    function getState() { return desktopActive ? desktopApi.getState() : mobileApi.getState(); }
    function setState(next) {
      desktopApi.setState(next);
      mobileApi.setState(next);
      return getState();
    }
    function closePanel() { desktopApi.closePanel(); }
    function destroy() {
      if (matcher.removeEventListener) matcher.removeEventListener('change', onMediaChange);
      else if (matcher.removeListener) matcher.removeListener(onMediaChange);
      desktopApi.destroy();
      mobileApi.destroy();
      host.__cofrApi = null;
    }

    host.__cofrApi = {
      getState: getState,
      setState: setState,
      closePanel: closePanel,
      destroy: destroy,
    };
    return host.__cofrApi;
  }

  function mountCompactFinder(root, index, options) {
    if (!root) return false;
    if (root.__cofSmartApi) return root.__cofSmartApi;
    var settings = options || {};
    var input = root.querySelector('[data-cof-input]');
    var results = root.querySelector('[data-cof-results]');
    var brandSelect = root.querySelector('[data-cof-brand]');
    var modelSelect = root.querySelector('[data-cof-model]');
    var submitButton = root.querySelector('[data-cof-submit]');
    var clearButton = root.querySelector('[data-cof-clear]');
    var hints = root.querySelector('[data-cof-hints]');
    var inputWrap = root.querySelector('[data-cof-input-wrap]');
    var copyNode = root.querySelector('[data-cof-copy]');
    if (!input || !results || !brandSelect || !modelSelect || !submitButton) return false;

    var copy = settings.copy || {};
    if (copyNode) {
      try { copy = JSON.parse(copyNode.textContent || '{}'); }
      catch (error) { copy = settings.copy || {}; }
    }
    var language = settings.language || root.dataset && root.dataset.cofLocale ||
      global.document && global.document.documentElement && global.document.documentElement.lang || 'en';
    var tree = buildTree(index, copy, language);
    if (!tree.length) return false;
    var localeRoot = settings.localeRoot == null ? shopifyLocaleRoot() : settings.localeRoot;
    var assign = settings.assign || function (url) { global.location.href = url; };
    var currentIntent = null;

    function option(value, label) {
      return '<option value="' + escapeHTML(value) + '">' + escapeHTML(label) + '</option>';
    }

    function selectedBrand() {
      return tree.find(function (brand) { return brand.id === brandSelect.value; }) || null;
    }

    function selectedModel() {
      var brand = selectedBrand();
      return brand && brand.models.find(function (model) { return model.id === modelSelect.value; }) || null;
    }

    function controlQuery(rawQuery) {
      var raw = String(rawQuery || '');
      if (raw.trim()) return raw;
      var brand = selectedBrand();
      var model = selectedModel();
      return brand ? brand.name + (model ? ' ' + model.name : '') : '';
    }

    function resolveCompact(query) {
      return resolveSmartVehicleIntent(tree, controlQuery(query), {
        localeRoot: localeRoot,
        currentSearch: settings.currentSearch == null
          ? global.location && global.location.search
          : settings.currentSearch,
        currentYear: settings.currentYear,
      });
    }

    function compactRow(action, label, meta, attributes) {
      return '<button type="button" class="cof__sug" role="option" data-cof-smart-action="' + escapeHTML(action) + '" ' + (attributes || '') + '>' +
        '<span class="cof__sug-main">' + escapeHTML(label) + '</span>' +
        (meta ? '<span class="cof__sug-sub">' + escapeHTML(meta) + '</span>' : '') +
        '</button>';
    }

    function compactPeriodRows(intent) {
      return intent.periods.map(function (period) {
        return compactRow('period', period.label, '', 'data-range-id="' + escapeHTML(period.id) + '"');
      }).join('');
    }

    function compactModelRows(intent) {
      var matches = intent.kind === 'brand-only' && intent.selectedBrand
        ? intent.selectedBrand.models.map(function (model) { return { brand: intent.selectedBrand, model: model }; })
        : intent.modelMatches;
      var seen = {};
      return matches.filter(function (match) {
        var key = match.brand.id + '::' + match.model.id;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      }).slice(0, 32).map(function (match) {
        return compactRow(
          'model',
          match.brand.name + (intent.kind === 'ambiguous' ? ' · ' : ' ') + match.model.name,
          '',
          'data-brand-id="' + escapeHTML(match.brand.id) + '" data-model-id="' + escapeHTML(match.model.id) + '"'
        );
      }).join('');
    }

    function compactBrandRows(intent) {
      return (intent.suggestedBrands || []).slice(0, 7).map(function (brand) {
        return compactRow(
          'brand',
          brand.name,
          '',
          'data-brand-id="' + escapeHTML(brand.id) + '"'
        );
      }).join('');
    }

    function renderCompact(intent) {
      currentIntent = intent;
      var markup = '';
      if (intent.kind === 'exact-fit' || intent.kind === 'proven-single-variant') {
        markup = compactRow(
          'destination',
          copy.open_product || copy.exact_match || 'Open matching product',
          [
            intent.selectedBrand && intent.selectedBrand.name,
            intent.selectedModel && intent.selectedModel.name,
            intent.exactPeriod && intent.exactPeriod.label,
          ].filter(Boolean).join(' · '),
          'data-destination="true"'
        );
      } else if (intent.kind === 'model-needs-year' || intent.kind === 'unsupported-year' ||
        (intent.kind === 'ambiguous' && intent.selectedModel && intent.periods.length)) {
        markup = compactPeriodRows(intent);
      } else if (intent.kind === 'brand-only' || intent.kind === 'ambiguous') {
        markup = compactModelRows(intent);
      } else if (intent.kind === 'no-match' && intent.suggestedBrands && intent.suggestedBrands.length) {
        markup = compactBrandRows(intent);
      } else if (intent.kind === 'no-match') {
        markup = '<div class="cof__empty"><p>' + escapeHTML(copy.no_safe_match || copy.search_fallback || copy.no_results || 'No safe match') + '</p></div>';
      }
      results.innerHTML = markup ? '<div class="cof__sec">' + markup + '</div>' : '';
      if (input.setAttribute) input.setAttribute('aria-expanded', markup ? 'true' : 'false');
      if (inputWrap && inputWrap.classList) {
        if (input.value) inputWrap.classList.add('has-value');
        else inputWrap.classList.remove('has-value');
      }
    }

    function activateCompact(intent) {
      if (!intent || !intent.canNavigate || !intent.destination) return false;
      if (intent.selectedBrand && intent.selectedModel && intent.exactPeriod) {
        persistSelection(
          intent.exactPeriod,
          intent.destination,
          intent.selectedBrand,
          intent.selectedModel,
          { modelOnly: intent.kind === 'proven-single-variant' }
        );
      }
      return activateSmartVehicleIntent(intent, assign);
    }

    var controller = createSmartInputController({
      input: input,
      submit: submitButton,
      resolve: resolveCompact,
      render: renderCompact,
      activate: activateCompact,
    });

    function populateModels() {
      var brand = selectedBrand();
      modelSelect.innerHTML = option('', copy.model_label || 'Model') + (brand
        ? brand.models.map(function (model) { return option(model.id, model.name); }).join('')
        : '');
      modelSelect.disabled = !brand;
      modelSelect.value = '';
      renderCompact(resolveCompact(''));
    }

    function onModelChange() {
      renderCompact(resolveCompact(''));
    }

    function onModelKeydown(event) {
      if (event && event.key === 'Enter') {
        if (event.preventDefault) event.preventDefault();
        controller.submit();
      }
    }

    function onResultsClick(event) {
      var control = event && event.target && event.target.closest
        ? event.target.closest('[data-cof-smart-action]')
        : null;
      if (!control) return;
      if (event.preventDefault) event.preventDefault();
      var action = control.dataset.cofSmartAction;
      if (action === 'destination') {
        activateCompact(currentIntent);
      } else if (action === 'brand') {
        input.value = '';
        brandSelect.value = control.dataset.brandId;
        populateModels();
      } else if (action === 'model') {
        brandSelect.value = control.dataset.brandId;
        populateModels();
        modelSelect.value = control.dataset.modelId;
        renderCompact(resolveCompact(''));
      } else if (action === 'period') {
        var brand = currentIntent && currentIntent.selectedBrand;
        var model = currentIntent && currentIntent.selectedModel;
        var period = currentIntent && currentIntent.periods.find(function (entry) {
          return entry.id === control.dataset.rangeId;
        });
        var destination = smartDestinationFor(period, {
          localeRoot: localeRoot,
          currentSearch: settings.currentSearch == null
            ? global.location && global.location.search
            : settings.currentSearch,
        });
        if (brand && model && period && destination) {
          var periodIntent = {
            kind: 'exact-fit', canNavigate: true, destination: destination,
            selectedBrand: brand, selectedModel: model, exactPeriod: period,
          };
          activateCompact(periodIntent);
        }
      }
    }

    function onClear() {
      input.value = '';
      brandSelect.value = '';
      modelSelect.value = '';
      modelSelect.disabled = true;
      currentIntent = null;
      results.innerHTML = '';
      if (input.setAttribute) input.setAttribute('aria-expanded', 'false');
      if (inputWrap && inputWrap.classList) inputWrap.classList.remove('has-value');
      if (typeof input.focus === 'function') input.focus();
    }

    brandSelect.innerHTML = option('', copy.brand_label || 'Brand') + tree.map(function (brand) {
      return option(brand.id, brand.name);
    }).join('');
    modelSelect.innerHTML = option('', copy.model_label || 'Model');
    brandSelect.addEventListener('change', populateModels);
    modelSelect.addEventListener('change', onModelChange);
    modelSelect.addEventListener('keydown', onModelKeydown);
    results.addEventListener('click', onResultsClick);
    if (clearButton) clearButton.addEventListener('click', onClear);
    if (hints && hints.querySelectorAll) {
      Array.prototype.slice.call(hints.querySelectorAll('[data-cof-chip]')).forEach(function (chip) {
        chip.addEventListener('click', function () {
          input.value = chip.getAttribute('data-cof-chip') || '';
          controller.refresh();
          if (typeof input.focus === 'function') input.focus();
        });
      });
    }

    root.__cofSmartApi = {
      getIntent: function () { return currentIntent; },
      refresh: controller.refresh,
      submit: controller.submit,
      destroy: function () {
        controller.destroy();
        brandSelect.removeEventListener('change', populateModels);
        modelSelect.removeEventListener('change', onModelChange);
        modelSelect.removeEventListener('keydown', onModelKeydown);
        results.removeEventListener('click', onResultsClick);
        if (clearButton) clearButton.removeEventListener('click', onClear);
        root.__cofSmartApi = null;
      },
    };
    return root.__cofSmartApi;
  }

  function loadIndex(options) {
    if (typeof global.coFinderLoadIndex === 'function') return global.coFinderLoadIndex(options || {});
    if (typeof global.fetch !== 'function') return Promise.reject(new Error('vehicle index fetch unavailable'));
    var state = global.__coFinderIndexState || (global.__coFinderIndexState = {
      status: 'idle', promise: null, value: null, error: null, attempt: 0
    });
    if (state.value && !(options && options.retry)) return Promise.resolve(state.value);
    if (state.promise && !(options && options.retry)) return state.promise;
    var url = global.coFinderIndexUrl || '/assets/co-search-index.json';
    var controller = typeof global.AbortController === 'function' ? new global.AbortController() : null;
    var timeout = controller ? global.setTimeout(controller.abort.bind(controller), 8000) : null;
    state.status = 'loading';
    state.attempt += 1;
    state.promise = global.fetch(url, {
      credentials: 'same-origin', signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('vehicle index request failed');
      return response.json();
    }).then(function (index) {
      state.status = 'ready';
      state.value = index;
      return index;
    }).catch(function (error) {
      state.status = 'error';
      state.error = error;
      state.promise = null;
      throw error;
    }).then(function (index) {
      if (timeout) global.clearTimeout(timeout);
      return index;
    }, function (error) {
      if (timeout) global.clearTimeout(timeout);
      throw error;
    });
    global.__coFinderIndexPromise = state.promise;
    return state.promise;
  }

  function replayQueuedFinderQueries(root, controller) {
    if (!root || !controller) return false;
    var input = root.querySelector('[data-cofr-input], [data-coff-input], [data-cof-input]');
    var query = input ? String(input.value || '').trim() : '';
    if (!query) return false;
    if (typeof controller.refresh === 'function') controller.refresh();
    else if (typeof controller.setState === 'function') controller.setState({ query: query, panel: 'matches' });
    return true;
  }

  function syncFinderLoadingState(root, state) {
    root.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    var panel = root.querySelector('[data-co-finder-load-state]');
    if (!panel) return;
    panel.dataset.state = state;
    panel.hidden = state === 'ready';
    var loading = panel.querySelector('[data-co-finder-loading]');
    var retry = panel.querySelector('[data-co-finder-retry]');
    var help = panel.querySelector('[data-co-finder-offline-help]');
    if (loading) loading.hidden = state !== 'loading';
    if (retry) retry.hidden = state !== 'error';
    if (help) help.hidden = state !== 'error';
  }

  function boot() {
    if (!global.document) return;
    var responsiveRoots = global.document.querySelectorAll('[data-co-responsive-finder]');
    var roots = global.document.querySelectorAll('[data-co-full-finder]');
    var compactRoots = global.document.querySelectorAll('[data-co-finder]');
    var productVehicleRoots = global.document.querySelectorAll('[data-co-product-vehicle]');
    if (!roots.length && !responsiveRoots.length && !compactRoots.length && !productVehicleRoots.length) return;
    var finderRoots = Array.prototype.slice.call(responsiveRoots)
      .concat(Array.prototype.slice.call(roots), Array.prototype.slice.call(compactRoots));
    finderRoots.forEach(function (host) { syncFinderLoadingState(host, 'loading'); });
    loadIndex().then(function (index) {
      responsiveRoots.forEach(function (host) {
        var controller = mountResponsiveFinder(host, index);
        replayQueuedFinderQueries(host, controller);
        syncFinderLoadingState(host, controller ? 'ready' : 'error');
      });
      roots.forEach(function (host) {
        var controller = mount(host, index);
        replayQueuedFinderQueries(host, controller);
        syncFinderLoadingState(host, controller ? 'ready' : 'error');
      });
      compactRoots.forEach(function (root) {
        var controller = mountCompactFinder(root, index);
        replayQueuedFinderQueries(root, controller);
        syncFinderLoadingState(root, controller ? 'ready' : 'error');
      });
      productVehicleRoots.forEach(function (root) { mountProductVehicle(root, index); });
    }).catch(function () {
      finderRoots.forEach(function (host) { syncFinderLoadingState(host, 'error'); });
      roots.forEach(function (host) {
        var status = host.querySelector('[data-coff-status]');
        var view = host.querySelector('[data-coff-view]');
        var copyNode = host.querySelector('[data-coff-copy]');
        var copy = {};
        try { copy = JSON.parse(copyNode ? copyNode.textContent : '{}'); } catch (error) {}
        if (status) status.textContent = copy.load_error || 'The vehicle list could not be loaded. Please try again.';
        if (view) view.innerHTML = '<p class="coff__empty">' + escapeHTML(copy.load_error || 'The vehicle list could not be loaded. Please try again.') + '</p>';
      });
    });
  }

  global.CarOptionsFullFinder = {
    buildTree: buildTree,
    productHandleForPage: productHandleForPage,
    resolveProductVehicleSelection: resolveProductVehicleSelection,
    mountProductVehicle: mountProductVehicle,
    buildTechnicalTree: buildTechnicalTree,
    buildCustomerPeriodTree: buildCustomerPeriodTree,
    hasCompleteCustomerPeriodCatalog: hasCompleteCustomerPeriodCatalog,
    localizedBrandName: localizedBrandName,
    localizedModelNames: localizedModelNames,
    localizedModelName: localizedModelName,
    brandLogoAttributes: brandLogoAttributes,
    renderRangeChoice: renderRangeChoice,
    renderDesktopRangeChoice: renderDesktopRangeChoice,
    renderDesktopSmartIntent: renderDesktopSmartIntent,
    renderMobileSmartIntent: renderMobileSmartIntent,
    destinationFor: destinationFor,
    preserveNavigationBypass: preserveNavigationBypass,
    singleVariantSelection: singleVariantSelection,
    rankVehicleIntent: rankVehicleIntent,
    parseSmartVehicleQuery: parseSmartVehicleQuery,
    resolveSmartVehicleIntent: resolveSmartVehicleIntent,
    activateSmartVehicleIntent: activateSmartVehicleIntent,
    createSmartInputController: createSmartInputController,
    resolveVehicleIntent: resolveVehicleIntent,
    filterTree: filterTree,
    mount: mount,
    mountDesktopFinder: mountDesktopFinder,
    mountResponsiveFinder: mountResponsiveFinder,
    mountCompactFinder: mountCompactFinder,
    desktopPanelMode: desktopPanelMode,
    desktopMatches: desktopMatches,
    desktopBrandGrid: desktopBrandGrid,
    desktopPanelRevealDelta: desktopPanelRevealDelta,
    revealDesktopPanel: revealDesktopPanel,
    settleDesktopScroll: settleDesktopScroll,
    desktopActivationUsesFocus: desktopActivationUsesFocus,
    desktopPreservedScroll: desktopPreservedScroll,
    createTypewriter: createTypewriter,
    createTypewriterActivity: createTypewriterActivity,
    finderSurfaceVisible: finderSurfaceVisible,
    trapModalTabKey: trapModalTabKey,
    elementInViewport: elementInViewport,
    setBrandListExpanded: setBrandListExpanded,
    activationIsKeyboard: activationIsKeyboard,
    finderUiText: finderUiText,
    lockStepTransition: lockStepTransition,
    releaseStepTransition: releaseStepTransition,
    captureStepPosition: captureStepPosition,
    applyStepAnchor: applyStepAnchor,
    restoreStepPosition: restoreStepPosition,
    forwardStepPosition: forwardStepPosition,
    settleStepTransition: settleStepTransition,
    settleListResizePosition: settleListResizePosition,
    rangeActionSignature: rangeActionSignature,
    coalesceRanges: coalesceRanges,
    retryBoot: boot,
  };

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    global.document.addEventListener('shopify:section:load', boot);
  }
})(global);
/* END CAROPTIONS EU FULL VEHICLE FINDER */
/* END CAROPTIONS EU VEHICLE MATCH */

/* BEGIN CAROPTIONS EU VEHICLE MODAL — generated by build-candidate.mjs */
/* CarOptions EU vehicle-finder modal controller. */
(function (root) {
  'use strict';

  var OPEN_SELECTOR = 'a[href="/openmodal"], [data-co-vehicle-modal-trigger]';
  var CLOSE_SELECTOR = '[data-co-vehicle-modal-close]';
  var MODAL_SELECTOR = '[data-co-vehicle-modal]';
  var BODY_CLASS = 'co-vehicle-modal-open';
  var ROOT_CLASS = 'co-vehicle-modal-root-open';

  function focusWithoutScroll(element) {
    if (!element || typeof element.focus !== 'function') return false;
    try { element.focus({ preventScroll: true }); }
    catch (error) { element.focus(); }
    return true;
  }

  function usesCoarsePointer(viewWindow) {
    var win = viewWindow || root;
    if (win.matchMedia) {
      try {
        if (win.matchMedia('(pointer: coarse)').matches) return true;
      } catch (error) {}
    }
    return Boolean(win.navigator && Number(win.navigator.maxTouchPoints) > 0);
  }

  function lockPageScroll(doc, viewWindow) {
    if (!doc || !doc.body) return null;
    var win = viewWindow || root;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var scrollTop = Number(win.scrollY == null ? win.pageYOffset || 0 : win.scrollY);
    var scrollLeft = Number(win.scrollX == null ? win.pageXOffset || 0 : win.scrollX);
    var lock = {
      scrollTop: scrollTop,
      scrollLeft: scrollLeft,
      hadBodyClass: Boolean(body.classList && body.classList.contains && body.classList.contains(BODY_CLASS)),
      hadRootClass: Boolean(documentElement && documentElement.classList && documentElement.classList.contains && documentElement.classList.contains(ROOT_CLASS)),
      styles: {
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        overflow: body.style.overflow,
      },
    };
    body.style.position = 'fixed';
    body.style.top = '-' + scrollTop + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (body.classList) body.classList.add(BODY_CLASS);
    if (documentElement && documentElement.classList) documentElement.classList.add(ROOT_CLASS);
    return lock;
  }

  function unlockPageScroll(doc, viewWindow, lock) {
    if (!doc || !doc.body || !lock) return false;
    var win = viewWindow || root;
    var body = doc.body;
    var styles = lock.styles || {};
    body.style.position = styles.position || '';
    body.style.top = styles.top || '';
    body.style.left = styles.left || '';
    body.style.right = styles.right || '';
    body.style.width = styles.width || '';
    body.style.overflow = styles.overflow || '';
    if (body.classList && !lock.hadBodyClass) body.classList.remove(BODY_CLASS);
    if (doc.documentElement && doc.documentElement.classList && !lock.hadRootClass) {
      doc.documentElement.classList.remove(ROOT_CLASS);
    }
    if (typeof win.scrollTo === 'function') {
      win.scrollTo({
        top: Number(lock.scrollTop || 0),
        left: Number(lock.scrollLeft || 0),
        behavior: 'instant',
      });
    }
    return true;
  }

  function mount(doc) {
    if (!doc || doc.__coVehicleModalMounted) return null;
    doc.__coVehicleModalMounted = true;
    var opener = null;
    var pageLock = null;

    function getModal() {
      return doc.querySelector(MODAL_SELECTOR);
    }

    function open(trigger) {
      var modal = getModal();
      if (!modal) return false;
      opener = trigger || null;
      pageLock = pageLock || lockPageScroll(doc, root);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      var dialog = modal.querySelector('.co-vehicle-modal__dialog');
      if (dialog) dialog.scrollTop = 0;
      var input = modal.querySelector('[data-cof-input]');
      focusWithoutScroll(usesCoarsePointer(root) ? dialog : input || dialog);
      return true;
    }

    function close() {
      var modal = getModal();
      if (!modal || modal.hidden) return false;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      unlockPageScroll(doc, root, pageLock);
      pageLock = null;
      if (opener && (!doc.contains || doc.contains(opener))) focusWithoutScroll(opener);
      opener = null;
      return true;
    }

    function onClick(event) {
      var target = event && event.target;
      if (!target || typeof target.closest !== 'function') return;
      var trigger = target.closest(OPEN_SELECTOR);
      if (trigger) {
        if (!getModal()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        open(trigger);
        return;
      }
      var closeControl = target.closest(CLOSE_SELECTOR);
      if (closeControl && close()) event.preventDefault();
    }

    function onKeydown(event) {
      if (event && event.key === 'Escape' && close()) event.preventDefault();
    }

    doc.addEventListener('click', onClick, true);
    doc.addEventListener('keydown', onKeydown);
    return { open: open, close: close };
  }

  root.CarOptionsVehicleModal = {
    mount: mount,
    lockPageScroll: lockPageScroll,
    unlockPageScroll: unlockPageScroll,
  };
  if (root.document) {
    var boot = function () { mount(root.document); };
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  }
})(global);
/* END CAROPTIONS EU VEHICLE MODAL */
})(typeof window !== 'undefined' ? window : this);
